(function () {
  'use strict';

  var DATA =
{
  "Holden": {
    "Commodore": {
      "VL": [
        {
          "label": "RB30E 3.0L SOHC",
          "family": "Holden VL / Nissan RB30",
          "url": "/collections/all/bt-fit-route-holden-commodore-vl-rb30e?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-vl-rb30e&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-holden-commodore-vl-rb30e",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 2,
            "wiring-sensors-displays": 2,
            "fuel-system": 4,
            "intake": 4,
            "exhaust": 1,
            "engine-parts": 17,
            "ignition": 1,
            "suspension-brakes": 2
          },
          "engineTag": "bt-fit-engine-rb30",
          "productCount": 28,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "RB30ET 3.0L Turbo SOHC",
          "family": "Holden VL / Nissan RB30",
          "url": "/collections/all/bt-fit-route-holden-commodore-vl-rb30et?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-vl-rb30et&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-holden-commodore-vl-rb30et",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 2,
            "wiring-sensors-displays": 2,
            "turbo-forced-induction": 2,
            "intercooler": 1,
            "fuel-system": 4,
            "intake": 4,
            "exhaust": 2,
            "engine-parts": 18,
            "ignition": 1,
            "clutch": 1,
            "transmission-driveline": 1,
            "suspension-brakes": 2
          },
          "engineTag": "bt-fit-engine-rb30",
          "productCount": 32,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "VN–VR": [
        {
          "label": "3.8 V6 (Buick)",
          "family": "Holden 3.8 V6",
          "url": "/collections/all/bt-fit-route-holden-commodore-vn-vr-3-8-buick?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-vn-vr-3-8-buick&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-holden-commodore-vn-vr-3-8-buick",
          "engineTag": "bt-fit-engine-buick-v6",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "fuel-system",
            "exhaust",
            "engine-parts",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 3,
            "wiring-sensors-displays": 3,
            "fuel-system": 1,
            "exhaust": 4,
            "engine-parts": 8,
            "suspension-brakes": 1
          },
          "productCount": 18,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "5.0L EFI V8",
          "family": "Holden 5.0 EFI V8",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-holden-commodore-vn-vr-5-0-efi-v8",
          "systems": [
            "engine-management",
            "turbo-forced-induction",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts"
          ],
          "systemCounts": {
            "engine-management": 1,
            "turbo-forced-induction": 2,
            "fuel-system": 1,
            "intake": 2,
            "exhaust": 5,
            "engine-parts": 96
          },
          "url": "/collections/all/bt-fit-route-holden-commodore-vn-vr-5-0-efi-v8?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-vn-vr-5-0-efi-v8&sort_by=price-ascending",
          "productCount": 105,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "VS": [
        {
          "label": "3.8 Ecotec V6",
          "family": "GM Ecotec V6",
          "url": "/collections/all/bt-fit-route-holden-commodore-vs-3-8-ecotec?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-vs-3-8-ecotec&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-holden-commodore-vs-3-8-ecotec",
          "engineTag": "bt-fit-engine-ecotec",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "fuel-system",
            "exhaust",
            "engine-parts",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 4,
            "wiring-sensors-displays": 1,
            "turbo-forced-induction": 5,
            "fuel-system": 1,
            "exhaust": 4,
            "engine-parts": 14,
            "suspension-brakes": 1
          },
          "productCount": 29,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "L67 3.8L Supercharged V6",
          "family": "GM Ecotec & Supercharged V6",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-l67",
          "url": "/collections/all/bt-fit-route-holden-commodore-vs-l67?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-vs-l67&sort_by=price-ascending",
          "routeTag": "bt-fit-route-holden-commodore-vs-l67",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "exhaust",
            "engine-parts",
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 5,
            "wiring-sensors-displays": 1,
            "turbo-forced-induction": 16,
            "intercooler": 6,
            "fuel-system": 1,
            "exhaust": 2,
            "engine-parts": 12,
            "clutch": 1,
            "transmission-driveline": 1,
            "suspension-brakes": 1
          },
          "productCount": 38,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "5.0L EFI V8",
          "family": "Holden 5.0 EFI V8",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-holden-commodore-vs-5-0-efi-v8",
          "systems": [
            "turbo-forced-induction",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2,
            "fuel-system": 1,
            "intake": 2,
            "exhaust": 5,
            "engine-parts": 96
          },
          "url": "/collections/all/bt-fit-route-holden-commodore-vs-5-0-efi-v8?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-vs-5-0-efi-v8&sort_by=price-ascending",
          "productCount": 104,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "VT / VT II": [
        {
          "label": "3.8 Ecotec V6",
          "family": "GM Ecotec V6",
          "url": "/collections/all/bt-fit-route-holden-commodore-vt-vt-ii-3-8-ecotec?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-vt-vt-ii-3-8-ecotec&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-holden-commodore-vt-vt-ii-3-8-ecotec",
          "engineTag": "bt-fit-engine-ecotec",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "fuel-system",
            "exhaust",
            "engine-parts",
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 4,
            "wiring-sensors-displays": 1,
            "turbo-forced-induction": 5,
            "fuel-system": 1,
            "exhaust": 3,
            "engine-parts": 14,
            "clutch": 1,
            "transmission-driveline": 1,
            "suspension-brakes": 1
          },
          "productCount": 29,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "L67 3.8L Supercharged V6",
          "family": "GM Ecotec & Supercharged V6",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-l67",
          "url": "/collections/all/bt-fit-route-holden-commodore-vt-vt-ii-l67?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-vt-vt-ii-l67&sort_by=price-ascending",
          "routeTag": "bt-fit-route-holden-commodore-vt-vt-ii-l67",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "exhaust",
            "engine-parts",
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 5,
            "wiring-sensors-displays": 1,
            "turbo-forced-induction": 16,
            "intercooler": 6,
            "fuel-system": 1,
            "exhaust": 3,
            "engine-parts": 12,
            "clutch": 1,
            "transmission-driveline": 1,
            "suspension-brakes": 1
          },
          "productCount": 39,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "LS1 5.7L",
          "family": "GM LS",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-ls1",
          "routeTag": "bt-fit-route-holden-commodore-vt-vt-ii-ls1",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "clutch",
            "transmission-driveline",
            "cooling",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 5,
            "wiring-sensors-displays": 10,
            "turbo-forced-induction": 17,
            "intercooler": 3,
            "fuel-system": 5,
            "intake": 15,
            "exhaust": 9,
            "engine-parts": 269,
            "ignition": 3,
            "clutch": 5,
            "transmission-driveline": 8,
            "cooling": 4,
            "suspension-brakes": 15
          },
          "url": "/collections/all/bt-fit-route-holden-commodore-vt-vt-ii-ls1?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-vt-vt-ii-ls1&sort_by=price-ascending",
          "productCount": 343,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "VX": [
        {
          "label": "3.8 Ecotec V6",
          "family": "GM Ecotec V6",
          "url": "/collections/all/bt-fit-route-holden-commodore-vx-3-8-ecotec?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-vx-3-8-ecotec&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-holden-commodore-vx-3-8-ecotec",
          "engineTag": "bt-fit-engine-ecotec",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "fuel-system",
            "exhaust",
            "engine-parts",
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 4,
            "wiring-sensors-displays": 1,
            "turbo-forced-induction": 5,
            "fuel-system": 1,
            "exhaust": 3,
            "engine-parts": 14,
            "clutch": 1,
            "transmission-driveline": 1,
            "suspension-brakes": 1
          },
          "productCount": 29,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "L67 3.8L Supercharged V6",
          "family": "GM Ecotec & Supercharged V6",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-l67",
          "url": "/collections/all/bt-fit-route-holden-commodore-vx-l67?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-vx-l67&sort_by=price-ascending",
          "routeTag": "bt-fit-route-holden-commodore-vx-l67",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "exhaust",
            "engine-parts",
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 5,
            "wiring-sensors-displays": 1,
            "turbo-forced-induction": 16,
            "intercooler": 6,
            "fuel-system": 1,
            "exhaust": 3,
            "engine-parts": 12,
            "clutch": 1,
            "transmission-driveline": 1,
            "suspension-brakes": 1
          },
          "productCount": 39,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "LS1 5.7L",
          "family": "GM LS",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-ls1",
          "routeTag": "bt-fit-route-holden-commodore-vx-ls1",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "clutch",
            "transmission-driveline",
            "cooling",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 5,
            "wiring-sensors-displays": 10,
            "turbo-forced-induction": 17,
            "intercooler": 3,
            "fuel-system": 5,
            "intake": 15,
            "exhaust": 9,
            "engine-parts": 269,
            "ignition": 3,
            "clutch": 5,
            "transmission-driveline": 8,
            "cooling": 4,
            "suspension-brakes": 15
          },
          "url": "/collections/all/bt-fit-route-holden-commodore-vx-ls1?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-vx-ls1&sort_by=price-ascending",
          "productCount": 343,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "VY": [
        {
          "label": "3.8 Ecotec V6",
          "family": "GM Ecotec V6",
          "url": "/collections/all/bt-fit-route-holden-commodore-vy-3-8-ecotec?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-vy-3-8-ecotec&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-holden-commodore-vy-3-8-ecotec",
          "engineTag": "bt-fit-engine-ecotec",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "fuel-system",
            "exhaust",
            "engine-parts",
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 7,
            "wiring-sensors-displays": 3,
            "turbo-forced-induction": 5,
            "fuel-system": 1,
            "exhaust": 3,
            "engine-parts": 14,
            "clutch": 1,
            "transmission-driveline": 1,
            "suspension-brakes": 1
          },
          "productCount": 32,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "L67 3.8L Supercharged V6",
          "family": "GM Ecotec & Supercharged V6",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-l67",
          "url": "/collections/all/bt-fit-route-holden-commodore-vy-l67?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-vy-l67&sort_by=price-ascending",
          "routeTag": "bt-fit-route-holden-commodore-vy-l67",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "exhaust",
            "engine-parts",
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 8,
            "wiring-sensors-displays": 3,
            "turbo-forced-induction": 16,
            "intercooler": 6,
            "fuel-system": 1,
            "exhaust": 3,
            "engine-parts": 12,
            "clutch": 1,
            "transmission-driveline": 1,
            "suspension-brakes": 1
          },
          "productCount": 42,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "LS1 5.7L",
          "family": "GM LS",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-ls1",
          "routeTag": "bt-fit-route-holden-commodore-vy-ls1",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "clutch",
            "transmission-driveline",
            "cooling",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 5,
            "wiring-sensors-displays": 10,
            "turbo-forced-induction": 17,
            "intercooler": 3,
            "fuel-system": 5,
            "intake": 15,
            "exhaust": 15,
            "engine-parts": 270,
            "ignition": 3,
            "clutch": 5,
            "transmission-driveline": 8,
            "cooling": 4,
            "suspension-brakes": 14
          },
          "url": "/collections/all/bt-fit-route-holden-commodore-vy-ls1?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-vy-ls1&sort_by=price-ascending",
          "productCount": 349,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "VZ": [
        {
          "label": "3.6 Alloytec V6",
          "family": "Holden Alloytec V6",
          "url": "/collections/all/bt-fit-route-holden-commodore-vz-3-6-alloytec?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-vz-3-6-alloytec&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-holden-commodore-vz-3-6-alloytec",
          "engineTag": "bt-fit-engine-alloytec",
          "systems": [
            "wiring-sensors-displays",
            "exhaust",
            "engine-parts",
            "clutch",
            "transmission-driveline",
            "cooling",
            "suspension-brakes"
          ],
          "systemCounts": {
            "wiring-sensors-displays": 4,
            "exhaust": 4,
            "engine-parts": 12,
            "clutch": 1,
            "transmission-driveline": 1,
            "cooling": 1,
            "suspension-brakes": 1
          },
          "productCount": 18,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "LS1 5.7L",
          "family": "GM LS",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-ls1",
          "routeTag": "bt-fit-route-holden-commodore-vz-ls1",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "clutch",
            "transmission-driveline",
            "cooling",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 5,
            "wiring-sensors-displays": 10,
            "turbo-forced-induction": 17,
            "intercooler": 3,
            "fuel-system": 6,
            "intake": 15,
            "exhaust": 16,
            "engine-parts": 270,
            "ignition": 3,
            "clutch": 5,
            "transmission-driveline": 8,
            "cooling": 4,
            "suspension-brakes": 14
          },
          "url": "/collections/all/bt-fit-route-holden-commodore-vz-ls1?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-vz-ls1&sort_by=price-ascending",
          "productCount": 351,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "LS2 6.0L",
          "family": "GM LS",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-ls2",
          "routeTag": "bt-fit-route-holden-commodore-vz-ls2",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "clutch",
            "transmission-driveline",
            "cooling",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 6,
            "wiring-sensors-displays": 13,
            "turbo-forced-induction": 16,
            "intercooler": 2,
            "fuel-system": 8,
            "intake": 15,
            "exhaust": 16,
            "engine-parts": 260,
            "ignition": 3,
            "clutch": 5,
            "transmission-driveline": 8,
            "cooling": 4,
            "suspension-brakes": 14
          },
          "url": "/collections/all/bt-fit-route-holden-commodore-vz-ls2?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-vz-ls2&sort_by=price-ascending",
          "productCount": 342,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "L76 6.0L",
          "family": "GM LS",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-l76",
          "routeTag": "bt-fit-route-holden-commodore-vz-l76",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "clutch",
            "transmission-driveline",
            "cooling",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 5,
            "wiring-sensors-displays": 8,
            "turbo-forced-induction": 13,
            "intercooler": 1,
            "fuel-system": 7,
            "intake": 12,
            "exhaust": 16,
            "engine-parts": 249,
            "ignition": 2,
            "clutch": 3,
            "transmission-driveline": 6,
            "cooling": 2,
            "suspension-brakes": 14
          },
          "url": "/collections/all/bt-fit-route-holden-commodore-vz-l76?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-vz-l76&sort_by=price-ascending",
          "productCount": 321,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "VE": [
        {
          "label": "LE0 3.6L Alloytec V6",
          "family": "Holden High Feature V6",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-le0",
          "routeTag": "bt-fit-route-holden-commodore-ve-le0",
          "systems": [
            "wiring-sensors-displays",
            "intake",
            "engine-parts",
            "transmission-driveline",
            "cooling",
            "suspension-brakes",
            "tools-accessories"
          ],
          "systemCounts": {
            "wiring-sensors-displays": 4,
            "intake": 1,
            "engine-parts": 7,
            "transmission-driveline": 1,
            "cooling": 2,
            "suspension-brakes": 5,
            "tools-accessories": 1
          },
          "url": "/collections/all/bt-fit-route-holden-commodore-ve-le0?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-ve-le0&sort_by=price-ascending",
          "productCount": 15,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "LY7 3.6L Alloytec HO V6",
          "family": "Holden High Feature V6",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-ly7",
          "routeTag": "bt-fit-route-holden-commodore-ve-ly7",
          "systems": [
            "wiring-sensors-displays",
            "intake",
            "engine-parts",
            "clutch",
            "transmission-driveline",
            "cooling",
            "suspension-brakes",
            "tools-accessories"
          ],
          "systemCounts": {
            "wiring-sensors-displays": 4,
            "intake": 1,
            "engine-parts": 12,
            "clutch": 1,
            "transmission-driveline": 2,
            "cooling": 2,
            "suspension-brakes": 5,
            "tools-accessories": 1
          },
          "url": "/collections/all/bt-fit-route-holden-commodore-ve-ly7?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-ve-ly7&sort_by=price-ascending",
          "productCount": 21,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "LW2 3.6L Dual-Fuel LPG V6",
          "family": "Holden High Feature V6",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-lw2",
          "routeTag": "bt-fit-route-holden-commodore-ve-lw2",
          "systems": [
            "intake",
            "engine-parts",
            "transmission-driveline",
            "cooling",
            "suspension-brakes",
            "tools-accessories"
          ],
          "systemCounts": {
            "intake": 1,
            "engine-parts": 4,
            "transmission-driveline": 1,
            "cooling": 1,
            "suspension-brakes": 5,
            "tools-accessories": 1
          },
          "url": "/collections/all/bt-fit-route-holden-commodore-ve-lw2?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-ve-lw2&sort_by=price-ascending",
          "productCount": 12,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "LF1 3.0L SIDI V6",
          "family": "Holden High Feature V6",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-lf1",
          "routeTag": "bt-fit-route-holden-commodore-ve-lf1",
          "systems": [
            "wiring-sensors-displays",
            "intake",
            "engine-parts",
            "transmission-driveline",
            "cooling",
            "suspension-brakes",
            "tools-accessories"
          ],
          "systemCounts": {
            "wiring-sensors-displays": 3,
            "intake": 1,
            "engine-parts": 7,
            "transmission-driveline": 1,
            "cooling": 1,
            "suspension-brakes": 5,
            "tools-accessories": 1
          },
          "url": "/collections/all/bt-fit-route-holden-commodore-ve-lf1?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-ve-lf1&sort_by=price-ascending",
          "productCount": 15,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "LLT 3.6L SIDI V6",
          "family": "Holden High Feature V6",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-llt",
          "routeTag": "bt-fit-route-holden-commodore-ve-llt",
          "systems": [
            "wiring-sensors-displays",
            "intake",
            "engine-parts",
            "clutch",
            "transmission-driveline",
            "suspension-brakes",
            "tools-accessories"
          ],
          "systemCounts": {
            "wiring-sensors-displays": 1,
            "intake": 1,
            "engine-parts": 7,
            "clutch": 1,
            "transmission-driveline": 2,
            "suspension-brakes": 5,
            "tools-accessories": 1
          },
          "url": "/collections/all/bt-fit-route-holden-commodore-ve-llt?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-ve-llt&sort_by=price-ascending",
          "productCount": 16,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "LFW 3.0L SIDI V6",
          "family": "Holden High Feature V6",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-lfw",
          "routeTag": "bt-fit-route-holden-commodore-ve-lfw",
          "systems": [
            "wiring-sensors-displays",
            "intake",
            "engine-parts",
            "transmission-driveline",
            "cooling",
            "suspension-brakes",
            "tools-accessories"
          ],
          "systemCounts": {
            "wiring-sensors-displays": 3,
            "intake": 1,
            "engine-parts": 15,
            "transmission-driveline": 1,
            "cooling": 1,
            "suspension-brakes": 5,
            "tools-accessories": 1
          },
          "url": "/collections/all/bt-fit-route-holden-commodore-ve-lfw?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-ve-lfw&sort_by=price-ascending",
          "productCount": 23,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "LFX 3.6L SIDI V6",
          "family": "Holden High Feature V6",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-lfx",
          "routeTag": "bt-fit-route-holden-commodore-ve-lfx",
          "systems": [
            "wiring-sensors-displays",
            "intake",
            "engine-parts",
            "transmission-driveline",
            "cooling",
            "suspension-brakes",
            "tools-accessories"
          ],
          "systemCounts": {
            "wiring-sensors-displays": 3,
            "intake": 1,
            "engine-parts": 14,
            "transmission-driveline": 1,
            "cooling": 1,
            "suspension-brakes": 5,
            "tools-accessories": 1
          },
          "url": "/collections/all/bt-fit-route-holden-commodore-ve-lfx?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-ve-lfx&sort_by=price-ascending",
          "productCount": 22,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "LWR 3.6L Dedicated LPG V6",
          "family": "Holden High Feature V6",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-lwr",
          "routeTag": "bt-fit-route-holden-commodore-ve-lwr",
          "systems": [
            "intake",
            "engine-parts",
            "transmission-driveline",
            "suspension-brakes",
            "tools-accessories"
          ],
          "systemCounts": {
            "intake": 1,
            "engine-parts": 10,
            "transmission-driveline": 1,
            "suspension-brakes": 5,
            "tools-accessories": 1
          },
          "url": "/collections/all/bt-fit-route-holden-commodore-ve-lwr?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-ve-lwr&sort_by=price-ascending",
          "productCount": 18,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "LS2 6.0L",
          "family": "GM LS",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-ls2",
          "routeTag": "bt-fit-route-holden-commodore-ve-ls2",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "clutch",
            "transmission-driveline",
            "cooling",
            "suspension-brakes",
            "tools-accessories"
          ],
          "systemCounts": {
            "engine-management": 6,
            "wiring-sensors-displays": 16,
            "turbo-forced-induction": 15,
            "intercooler": 3,
            "fuel-system": 7,
            "intake": 29,
            "exhaust": 11,
            "engine-parts": 265,
            "ignition": 3,
            "clutch": 4,
            "transmission-driveline": 6,
            "cooling": 9,
            "suspension-brakes": 6,
            "tools-accessories": 1
          },
          "url": "/collections/all/bt-fit-route-holden-commodore-ve-ls2?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-ve-ls2&sort_by=price-ascending",
          "productCount": 345,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "L76 6.0L",
          "family": "GM LS",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-l76",
          "routeTag": "bt-fit-route-holden-commodore-ve-l76",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "clutch",
            "transmission-driveline",
            "cooling",
            "suspension-brakes",
            "tools-accessories"
          ],
          "systemCounts": {
            "engine-management": 5,
            "wiring-sensors-displays": 11,
            "turbo-forced-induction": 11,
            "intercooler": 2,
            "fuel-system": 7,
            "intake": 26,
            "exhaust": 11,
            "engine-parts": 254,
            "ignition": 2,
            "clutch": 3,
            "transmission-driveline": 5,
            "cooling": 7,
            "suspension-brakes": 6,
            "tools-accessories": 1
          },
          "url": "/collections/all/bt-fit-route-holden-commodore-ve-l76?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-ve-l76&sort_by=price-ascending",
          "productCount": 325,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "L98 6.0L",
          "family": "GM LS",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-l98",
          "routeTag": "bt-fit-route-holden-commodore-ve-l98",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "clutch",
            "transmission-driveline",
            "cooling",
            "suspension-brakes",
            "tools-accessories"
          ],
          "systemCounts": {
            "engine-management": 5,
            "wiring-sensors-displays": 14,
            "turbo-forced-induction": 14,
            "intercooler": 2,
            "fuel-system": 7,
            "intake": 26,
            "exhaust": 11,
            "engine-parts": 272,
            "ignition": 4,
            "clutch": 4,
            "transmission-driveline": 6,
            "cooling": 8,
            "suspension-brakes": 6,
            "tools-accessories": 1
          },
          "url": "/collections/all/bt-fit-route-holden-commodore-ve-l98?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-ve-l98&sort_by=price-ascending",
          "productCount": 347,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "L77 6.0L",
          "family": "GM LS",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-l77",
          "routeTag": "bt-fit-route-holden-commodore-ve-l77",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "clutch",
            "transmission-driveline",
            "cooling",
            "suspension-brakes",
            "tools-accessories"
          ],
          "systemCounts": {
            "engine-management": 5,
            "wiring-sensors-displays": 11,
            "turbo-forced-induction": 12,
            "intercooler": 2,
            "fuel-system": 7,
            "intake": 26,
            "exhaust": 11,
            "engine-parts": 253,
            "ignition": 2,
            "clutch": 2,
            "transmission-driveline": 4,
            "cooling": 8,
            "suspension-brakes": 6,
            "tools-accessories": 1
          },
          "url": "/collections/all/bt-fit-route-holden-commodore-ve-l77?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-ve-l77&sort_by=price-ascending",
          "productCount": 324,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "LS3 6.2L",
          "family": "GM LS",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-ls3",
          "routeTag": "bt-fit-route-holden-commodore-ve-ls3",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "clutch",
            "transmission-driveline",
            "cooling",
            "suspension-brakes",
            "tools-accessories"
          ],
          "systemCounts": {
            "engine-management": 5,
            "wiring-sensors-displays": 14,
            "turbo-forced-induction": 16,
            "intercooler": 2,
            "fuel-system": 8,
            "intake": 29,
            "exhaust": 11,
            "engine-parts": 283,
            "ignition": 4,
            "clutch": 4,
            "transmission-driveline": 6,
            "cooling": 10,
            "suspension-brakes": 6,
            "tools-accessories": 1
          },
          "url": "/collections/all/bt-fit-route-holden-commodore-ve-ls3?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-ve-ls3&sort_by=price-ascending",
          "productCount": 363,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "LS7 7.0L",
          "family": "GM LS",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-ls7",
          "routeTag": "bt-fit-route-holden-commodore-ve-ls7",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "clutch",
            "transmission-driveline",
            "cooling",
            "suspension-brakes",
            "tools-accessories"
          ],
          "systemCounts": {
            "engine-management": 5,
            "wiring-sensors-displays": 9,
            "turbo-forced-induction": 11,
            "intercooler": 2,
            "fuel-system": 5,
            "intake": 21,
            "exhaust": 3,
            "engine-parts": 53,
            "ignition": 3,
            "clutch": 1,
            "transmission-driveline": 3,
            "cooling": 5,
            "suspension-brakes": 6,
            "tools-accessories": 1
          },
          "url": "/collections/all/bt-fit-route-holden-commodore-ve-ls7?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-ve-ls7&sort_by=price-ascending",
          "productCount": 106,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "3.6L SIDI V6",
          "family": "Holden Exact Engine",
          "url": "/collections/all/bt-fit-route-holden-commodore-ve-3-6-sidi?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-ve-3-6-sidi&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-holden-commodore-ve-3-6-sidi",
          "engineTag": "bt-fit-engine-holden-3-6-sidi",
          "systems": [
            "exhaust"
          ],
          "systemCounts": {
            "exhaust": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "VF / VFII": [
        {
          "label": "LFW 3.0L SIDI V6",
          "family": "Holden High Feature V6",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-lfw",
          "routeTag": "bt-fit-route-holden-commodore-vf-vfii-lfw",
          "systems": [
            "wiring-sensors-displays",
            "intake",
            "engine-parts",
            "transmission-driveline",
            "suspension-brakes",
            "tools-accessories"
          ],
          "systemCounts": {
            "wiring-sensors-displays": 3,
            "intake": 1,
            "engine-parts": 15,
            "transmission-driveline": 1,
            "suspension-brakes": 4,
            "tools-accessories": 1
          },
          "url": "/collections/all/bt-fit-route-holden-commodore-vf-vfii-lfw?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-vf-vfii-lfw&sort_by=price-ascending",
          "productCount": 22,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "LFX 3.6L SIDI V6",
          "family": "Holden High Feature V6",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-lfx",
          "routeTag": "bt-fit-route-holden-commodore-vf-vfii-lfx",
          "systems": [
            "wiring-sensors-displays",
            "intake",
            "engine-parts",
            "transmission-driveline",
            "suspension-brakes",
            "tools-accessories"
          ],
          "systemCounts": {
            "wiring-sensors-displays": 3,
            "intake": 2,
            "engine-parts": 14,
            "transmission-driveline": 1,
            "suspension-brakes": 4,
            "tools-accessories": 1
          },
          "url": "/collections/all/bt-fit-route-holden-commodore-vf-vfii-lfx?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-vf-vfii-lfx&sort_by=price-ascending",
          "productCount": 22,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "LWR 3.6L Dedicated LPG V6",
          "family": "Holden High Feature V6",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-lwr",
          "routeTag": "bt-fit-route-holden-commodore-vf-vfii-lwr",
          "systems": [
            "intake",
            "engine-parts",
            "transmission-driveline",
            "suspension-brakes",
            "tools-accessories"
          ],
          "systemCounts": {
            "intake": 1,
            "engine-parts": 10,
            "transmission-driveline": 1,
            "suspension-brakes": 4,
            "tools-accessories": 1
          },
          "url": "/collections/all/bt-fit-route-holden-commodore-vf-vfii-lwr?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-vf-vfii-lwr&sort_by=price-ascending",
          "productCount": 17,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "L77 6.0L",
          "family": "GM LS",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-l77",
          "routeTag": "bt-fit-route-holden-commodore-vf-vfii-l77",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "clutch",
            "transmission-driveline",
            "cooling",
            "suspension-brakes",
            "tools-accessories"
          ],
          "systemCounts": {
            "engine-management": 5,
            "wiring-sensors-displays": 11,
            "turbo-forced-induction": 12,
            "intercooler": 2,
            "fuel-system": 7,
            "intake": 24,
            "exhaust": 12,
            "engine-parts": 253,
            "ignition": 2,
            "clutch": 2,
            "transmission-driveline": 4,
            "cooling": 8,
            "suspension-brakes": 5,
            "tools-accessories": 1
          },
          "url": "/collections/all/bt-fit-route-holden-commodore-vf-vfii-l77?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-vf-vfii-l77&sort_by=price-ascending",
          "productCount": 322,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "LS3 6.2L",
          "family": "GM LS",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-ls3",
          "routeTag": "bt-fit-route-holden-commodore-vf-vfii-ls3",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "clutch",
            "transmission-driveline",
            "cooling",
            "suspension-brakes",
            "tools-accessories"
          ],
          "systemCounts": {
            "engine-management": 5,
            "wiring-sensors-displays": 14,
            "turbo-forced-induction": 14,
            "intercooler": 2,
            "fuel-system": 8,
            "intake": 27,
            "exhaust": 12,
            "engine-parts": 281,
            "ignition": 4,
            "clutch": 4,
            "transmission-driveline": 6,
            "cooling": 9,
            "suspension-brakes": 5,
            "tools-accessories": 1
          },
          "url": "/collections/all/bt-fit-route-holden-commodore-vf-vfii-ls3?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-vf-vfii-ls3&sort_by=price-ascending",
          "productCount": 358,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "LSA 6.2L Supercharged",
          "family": "GM LS",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-lsa",
          "routeTag": "bt-fit-route-holden-commodore-vf-vfii-lsa",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "clutch",
            "transmission-driveline",
            "cooling",
            "suspension-brakes",
            "tools-accessories"
          ],
          "systemCounts": {
            "engine-management": 5,
            "wiring-sensors-displays": 12,
            "turbo-forced-induction": 27,
            "intercooler": 3,
            "fuel-system": 10,
            "intake": 24,
            "exhaust": 12,
            "engine-parts": 266,
            "ignition": 2,
            "clutch": 3,
            "transmission-driveline": 5,
            "cooling": 6,
            "suspension-brakes": 5,
            "tools-accessories": 1
          },
          "url": "/collections/all/bt-fit-route-holden-commodore-vf-vfii-lsa?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-vf-vfii-lsa&sort_by=price-ascending",
          "productCount": 350,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "LS9 6.2L Supercharged",
          "family": "GM LS",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-ls9",
          "routeTag": "bt-fit-route-holden-commodore-vf-vfii-ls9",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "clutch",
            "transmission-driveline",
            "cooling",
            "suspension-brakes",
            "tools-accessories"
          ],
          "systemCounts": {
            "engine-management": 5,
            "wiring-sensors-displays": 8,
            "turbo-forced-induction": 11,
            "intercooler": 2,
            "fuel-system": 4,
            "intake": 18,
            "exhaust": 3,
            "engine-parts": 38,
            "ignition": 2,
            "clutch": 1,
            "transmission-driveline": 3,
            "cooling": 5,
            "suspension-brakes": 5,
            "tools-accessories": 1
          },
          "url": "/collections/all/bt-fit-route-holden-commodore-vf-vfii-ls9?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-vf-vfii-ls9&sort_by=price-ascending",
          "productCount": 86,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "ZB": [
        {
          "label": "2.0L Turbo",
          "family": "Holden Commodore ZB",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-holden-commodore-zb-20-turbo",
          "systems": [
            "intake"
          ],
          "systemCounts": {
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-holden-commodore-zb-20-turbo?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-zb-20-turbo&sort_by=price-ascending",
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "VR / VS": [
        {
          "label": "Chassis fitment — driveline",
          "family": "Holden Commodore VR / VS",
          "url": "/collections/all/bt-fit-route-holden-commodore-vr-vs-chassis-driveline?bbt_vehicle=1&bbt_route=bt-fit-route-holden-commodore-vr-vs-chassis-driveline&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-holden-commodore-vr-vs-chassis-driveline",
          "engineTag": "bt-fit-chassis-vr-vs",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Colorado": {
      "RC": [
        {
          "label": "3.6 Alloytec V6",
          "family": "Holden Alloytec V6",
          "url": "/collections/all/bt-fit-route-holden-colorado-rc-3-6-v6?bbt_vehicle=1&bbt_route=bt-fit-route-holden-colorado-rc-3-6-v6&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-holden-colorado-rc-3-6-v6",
          "engineTag": "bt-fit-engine-alloytec",
          "systems": [
            "engine-parts",
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-parts": 1,
            "clutch": 4,
            "transmission-driveline": 10,
            "suspension-brakes": 1
          },
          "productCount": 12,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "RG": [
        {
          "label": "2.8L Turbo Diesel",
          "family": "Holden Colorado RG",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-holden-colorado-rg-28-diesel",
          "systems": [
            "intake",
            "exhaust",
            "engine-parts",
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "intake": 2,
            "exhaust": 3,
            "engine-parts": 1,
            "clutch": 1,
            "transmission-driveline": 3,
            "suspension-brakes": 1
          },
          "url": "/collections/all/bt-fit-route-holden-colorado-rg-28-diesel?bbt_vehicle=1&bbt_route=bt-fit-route-holden-colorado-rg-28-diesel&sort_by=price-ascending",
          "productCount": 10,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Rodeo": {
      "RA": [
        {
          "label": "RA",
          "family": "Holden Rodeo RA",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-holden-rodeo-ra-ra",
          "systems": [
            "exhaust",
            "transmission-driveline"
          ],
          "systemCounts": {
            "exhaust": 4,
            "transmission-driveline": 6
          },
          "url": "/collections/all/bt-fit-route-holden-rodeo-ra-ra?bbt_vehicle=1&bbt_route=bt-fit-route-holden-rodeo-ra-ra&sort_by=price-ascending",
          "productCount": 10,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "4JH1 3.0L Diesel",
          "family": "Holden Exact Engine",
          "url": "/collections/all/bt-fit-route-holden-rodeo-ra-4jh1?bbt_vehicle=1&bbt_route=bt-fit-route-holden-rodeo-ra-4jh1&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-holden-rodeo-ra-4jh1",
          "engineTag": "bt-fit-engine-4jh1",
          "systems": [
            "exhaust"
          ],
          "systemCounts": {
            "exhaust": 2
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "4JJ1 3.0L Common-Rail Diesel",
          "family": "Holden Exact Engine",
          "url": "/collections/all/bt-fit-route-holden-rodeo-ra-4jj1?bbt_vehicle=1&bbt_route=bt-fit-route-holden-rodeo-ra-4jj1&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-holden-rodeo-ra-4jj1",
          "engineTag": "bt-fit-engine-4jj1",
          "systems": [
            "exhaust"
          ],
          "systemCounts": {
            "exhaust": 2
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Jackaroo": {
      "UB / UBS (1988–2002)": [
        {
          "label": "4WD driveline applications",
          "family": "Holden Jackaroo",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-holden-jackaroo-ubs-ub-1988-2002",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 5
          },
          "url": "/collections/all/bt-fit-route-holden-jackaroo-ubs-ub-1988-2002?bbt_vehicle=1&bbt_route=bt-fit-route-holden-jackaroo-ubs-ub-1988-2002&sort_by=price-ascending",
          "productCount": 5,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Torana": {
      "LH–UC": [
        {
          "label": "Chassis / steering",
          "family": "Holden Torana LH–UC",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-holden-torana-lh-uc",
          "systems": [
            "engine-parts",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-parts": 68,
            "suspension-brakes": 1
          },
          "url": "/collections/all/bt-fit-route-holden-torana-lh-uc?bbt_vehicle=1&bbt_route=bt-fit-route-holden-torana-lh-uc&sort_by=price-ascending",
          "productCount": 69,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Acadia": {
      "CG / 2018–2020": [
        {
          "label": "3.6L V6",
          "family": "GM 3.6 V6",
          "url": "/collections/all/bt-fit-route-holden-acadia-cg-3-6-v6?bbt_vehicle=1&bbt_route=bt-fit-route-holden-acadia-cg-3-6-v6&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-holden-acadia-cg-3-6-v6",
          "engineTag": "bt-fit-engine-gm-3-6-v6",
          "systems": [
            "intake"
          ],
          "systemCounts": {
            "intake": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Differential Family / Custom": {
      "Holden Banjo / 10 spline": [
        {
          "label": "Holden Banjo / 10 spline",
          "family": "Holden Differential Family",
          "url": "/collections/all/bt-fit-route-holden-driveline-banjo-10spline?bbt_vehicle=1&bbt_route=bt-fit-route-holden-driveline-banjo-10spline&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-holden-driveline-banjo-10spline",
          "engineTag": "bt-fit-diff-banjo-10",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "Holden Banjo / 23 spline": [
        {
          "label": "Holden Banjo / 23 spline",
          "family": "Holden Differential Family",
          "url": "/collections/all/bt-fit-route-holden-driveline-banjo-23spline?bbt_vehicle=1&bbt_route=bt-fit-route-holden-driveline-banjo-23spline&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-holden-driveline-banjo-23spline",
          "engineTag": "bt-fit-diff-banjo-23",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "Holden Banjo / 25 spline": [
        {
          "label": "Holden Banjo / 25 spline",
          "family": "Holden Differential Family",
          "url": "/collections/all/bt-fit-route-holden-driveline-banjo-25spline?bbt_vehicle=1&bbt_route=bt-fit-route-holden-driveline-banjo-25spline&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-holden-driveline-banjo-25spline",
          "engineTag": "bt-fit-diff-banjo-25",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "Holden Banjo / 26 spline": [
        {
          "label": "Holden Banjo / 26 spline",
          "family": "Holden Differential Family",
          "url": "/collections/all/bt-fit-route-holden-driveline-banjo-26spline?bbt_vehicle=1&bbt_route=bt-fit-route-holden-driveline-banjo-26spline&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-holden-driveline-banjo-26spline",
          "engineTag": "bt-fit-diff-banjo-26",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "Holden Banjo / 28 spline": [
        {
          "label": "Holden Banjo / 28 spline",
          "family": "Holden Differential Family",
          "url": "/collections/all/bt-fit-route-holden-driveline-banjo-28spline?bbt_vehicle=1&bbt_route=bt-fit-route-holden-driveline-banjo-28spline&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-holden-driveline-banjo-28spline",
          "engineTag": "bt-fit-diff-banjo-28",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "Holden Salisbury / 28 spline": [
        {
          "label": "Holden Salisbury / 28 spline",
          "family": "Holden Differential Family",
          "url": "/collections/all/bt-fit-route-holden-driveline-salisbury-28spline?bbt_vehicle=1&bbt_route=bt-fit-route-holden-driveline-salisbury-28spline&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-holden-driveline-salisbury-28spline",
          "engineTag": "bt-fit-diff-salisbury-28",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "Holden Salisbury / 31 spline": [
        {
          "label": "Holden Salisbury / 31 spline",
          "family": "Holden Differential Family",
          "url": "/collections/all/bt-fit-route-holden-driveline-salisbury-31spline?bbt_vehicle=1&bbt_route=bt-fit-route-holden-driveline-salisbury-31spline&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-holden-driveline-salisbury-31spline",
          "engineTag": "bt-fit-diff-salisbury-31",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "Borg Warner M78 / 28 spline": [
        {
          "label": "Borg Warner M78 / 28 spline",
          "family": "Holden Differential Family",
          "url": "/collections/all/bt-fit-route-holden-driveline-m78-28spline?bbt_vehicle=1&bbt_route=bt-fit-route-holden-driveline-m78-28spline&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-holden-driveline-m78-28spline",
          "engineTag": "bt-fit-diff-m78-28",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 2
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "Borg Warner M78 / 31 spline": [
        {
          "label": "Borg Warner M78 / 31 spline",
          "family": "Holden Differential Family",
          "url": "/collections/all/bt-fit-route-holden-driveline-m78-31spline?bbt_vehicle=1&bbt_route=bt-fit-route-holden-driveline-m78-31spline&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-holden-driveline-m78-31spline",
          "engineTag": "bt-fit-diff-m78-31",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 2
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "Borg Warner M80 differential": [
        {
          "label": "Borg Warner M80 differential",
          "family": "Holden Differential Family",
          "url": "/collections/all/bt-fit-route-holden-driveline-m80?bbt_vehicle=1&bbt_route=bt-fit-route-holden-driveline-m80&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-holden-driveline-m80",
          "engineTag": "bt-fit-diff-m80",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "Borg Warner M86 / 30 spline": [
        {
          "label": "Borg Warner M86 / 30 spline",
          "family": "Holden Differential Family",
          "url": "/collections/all/bt-fit-route-holden-driveline-m86-30spline?bbt_vehicle=1&bbt_route=bt-fit-route-holden-driveline-m86-30spline&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-holden-driveline-m86-30spline",
          "engineTag": "bt-fit-diff-m86-30",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 2
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "Borg Warner 78": [
        {
          "label": "Borg Warner 78 nine-bolt housing",
          "family": "Borg Warner 78",
          "url": "/collections/all/bt-fit-route-holden-driveline-borg-warner-78-housing?bbt_vehicle=1&bbt_route=bt-fit-route-holden-driveline-borg-warner-78-housing&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-holden-driveline-borg-warner-78-housing",
          "engineTag": "bt-fit-diff-borg-warner-78",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Engine Family / Custom": {
      "LTG 2.0T": [
        {
          "label": "GM LTG 2.0L Turbo",
          "family": "GM LTG",
          "url": "/collections/all/bt-fit-route-holden-engine-family-ltg-2-0t?bbt_vehicle=1&bbt_route=bt-fit-route-holden-engine-family-ltg-2-0t&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-holden-engine-family-ltg-2-0t",
          "engineTag": "bt-fit-engine-ltg",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "Chevrolet": {
    "Corvette": {
      "C5": [
        {
          "label": "LS1 5.7L",
          "family": "GM LS",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-ls1",
          "routeTag": "bt-fit-route-chevrolet-corvette-c5-ls1",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "engine-parts",
            "ignition",
            "clutch",
            "transmission-driveline",
            "cooling",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 5,
            "wiring-sensors-displays": 10,
            "turbo-forced-induction": 11,
            "intercooler": 1,
            "fuel-system": 4,
            "intake": 13,
            "engine-parts": 266,
            "ignition": 3,
            "clutch": 3,
            "transmission-driveline": 4,
            "cooling": 6,
            "suspension-brakes": 1
          },
          "url": "/collections/all/bt-fit-route-chevrolet-corvette-c5-ls1?bbt_vehicle=1&bbt_route=bt-fit-route-chevrolet-corvette-c5-ls1&sort_by=price-ascending",
          "productCount": 303,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "LS6 5.7L",
          "family": "GM LS",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-ls6",
          "routeTag": "bt-fit-route-chevrolet-corvette-c5-ls6",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "fuel-system",
            "intake",
            "engine-parts",
            "ignition",
            "transmission-driveline",
            "cooling",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 5,
            "wiring-sensors-displays": 5,
            "turbo-forced-induction": 9,
            "fuel-system": 3,
            "intake": 11,
            "engine-parts": 25,
            "ignition": 2,
            "transmission-driveline": 1,
            "cooling": 4,
            "suspension-brakes": 1
          },
          "url": "/collections/all/bt-fit-route-chevrolet-corvette-c5-ls6?bbt_vehicle=1&bbt_route=bt-fit-route-chevrolet-corvette-c5-ls6&sort_by=price-ascending",
          "productCount": 53,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "C6": [
        {
          "label": "LS2 6.0L",
          "family": "GM LS",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-ls2",
          "routeTag": "bt-fit-route-chevrolet-corvette-c6-ls2",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "engine-parts",
            "ignition",
            "clutch",
            "transmission-driveline",
            "cooling",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 6,
            "wiring-sensors-displays": 13,
            "turbo-forced-induction": 11,
            "intercooler": 1,
            "fuel-system": 5,
            "intake": 13,
            "engine-parts": 256,
            "ignition": 3,
            "clutch": 3,
            "transmission-driveline": 4,
            "cooling": 6,
            "suspension-brakes": 1
          },
          "url": "/collections/all/bt-fit-route-chevrolet-corvette-c6-ls2?bbt_vehicle=1&bbt_route=bt-fit-route-chevrolet-corvette-c6-ls2&sort_by=price-ascending",
          "productCount": 294,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "LS3 6.2L",
          "family": "GM LS",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-ls3",
          "routeTag": "bt-fit-route-chevrolet-corvette-c6-ls3",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "fuel-system",
            "intake",
            "engine-parts",
            "ignition",
            "clutch",
            "transmission-driveline",
            "cooling",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 5,
            "wiring-sensors-displays": 11,
            "turbo-forced-induction": 10,
            "fuel-system": 6,
            "intake": 13,
            "engine-parts": 273,
            "ignition": 4,
            "clutch": 3,
            "transmission-driveline": 4,
            "cooling": 7,
            "suspension-brakes": 1
          },
          "url": "/collections/all/bt-fit-route-chevrolet-corvette-c6-ls3?bbt_vehicle=1&bbt_route=bt-fit-route-chevrolet-corvette-c6-ls3&sort_by=price-ascending",
          "productCount": 310,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "LS7 7.0L",
          "family": "GM LS",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-ls7",
          "routeTag": "bt-fit-route-chevrolet-corvette-c6-ls7",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "fuel-system",
            "intake",
            "engine-parts",
            "ignition",
            "transmission-driveline",
            "cooling",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 5,
            "wiring-sensors-displays": 6,
            "turbo-forced-induction": 9,
            "fuel-system": 4,
            "intake": 12,
            "engine-parts": 46,
            "ignition": 3,
            "transmission-driveline": 1,
            "cooling": 4,
            "suspension-brakes": 2
          },
          "url": "/collections/all/bt-fit-route-chevrolet-corvette-c6-ls7?bbt_vehicle=1&bbt_route=bt-fit-route-chevrolet-corvette-c6-ls7&sort_by=price-ascending",
          "productCount": 77,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "LS9 6.2L Supercharged",
          "family": "GM LS",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-ls9",
          "routeTag": "bt-fit-route-chevrolet-corvette-c6-ls9",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "fuel-system",
            "intake",
            "engine-parts",
            "ignition",
            "transmission-driveline",
            "cooling",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 5,
            "wiring-sensors-displays": 5,
            "turbo-forced-induction": 9,
            "fuel-system": 3,
            "intake": 10,
            "engine-parts": 33,
            "ignition": 2,
            "transmission-driveline": 1,
            "cooling": 4,
            "suspension-brakes": 1
          },
          "url": "/collections/all/bt-fit-route-chevrolet-corvette-c6-ls9?bbt_vehicle=1&bbt_route=bt-fit-route-chevrolet-corvette-c6-ls9&sort_by=price-ascending",
          "productCount": 60,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "C8": [
        {
          "label": "LT2 6.2L V8 — 2020+",
          "family": "GM LT",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-chevrolet-corvette-c8-lt2",
          "systems": [
            "turbo-forced-induction",
            "intake",
            "engine-parts"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "intake": 1,
            "engine-parts": 1
          },
          "url": "/collections/all/bt-fit-route-chevrolet-corvette-c8-lt2?bbt_vehicle=1&bbt_route=bt-fit-route-chevrolet-corvette-c8-lt2&sort_by=price-ascending",
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Camaro": {
      "5th Gen": [
        {
          "label": "LS3 6.2L",
          "family": "GM LS",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-ls3",
          "routeTag": "bt-fit-route-chevrolet-camaro-5th-gen-ls3",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "clutch",
            "transmission-driveline",
            "cooling",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 5,
            "wiring-sensors-displays": 11,
            "turbo-forced-induction": 10,
            "fuel-system": 6,
            "intake": 14,
            "exhaust": 1,
            "engine-parts": 272,
            "ignition": 4,
            "clutch": 3,
            "transmission-driveline": 4,
            "cooling": 6,
            "suspension-brakes": 1
          },
          "url": "/collections/all/bt-fit-route-chevrolet-camaro-5th-gen-ls3?bbt_vehicle=1&bbt_route=bt-fit-route-chevrolet-camaro-5th-gen-ls3&sort_by=price-ascending",
          "productCount": 311,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "LSA 6.2L Supercharged",
          "family": "GM LS",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-lsa",
          "routeTag": "bt-fit-route-chevrolet-camaro-5th-gen-lsa",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "engine-parts",
            "ignition",
            "transmission-driveline",
            "cooling",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 5,
            "wiring-sensors-displays": 9,
            "turbo-forced-induction": 18,
            "intercooler": 1,
            "fuel-system": 8,
            "intake": 14,
            "engine-parts": 257,
            "ignition": 2,
            "transmission-driveline": 1,
            "cooling": 5,
            "suspension-brakes": 1
          },
          "url": "/collections/all/bt-fit-route-chevrolet-camaro-5th-gen-lsa?bbt_vehicle=1&bbt_route=bt-fit-route-chevrolet-camaro-5th-gen-lsa&sort_by=price-ascending",
          "productCount": 300,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "6th Gen": [
        {
          "label": "LT1 6.2L",
          "family": "GM LT",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-chevrolet-camaro-6th-gen-lt1",
          "systems": [
            "turbo-forced-induction",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2,
            "fuel-system": 1,
            "intake": 1,
            "exhaust": 1,
            "engine-parts": 5
          },
          "url": "/collections/all/bt-fit-route-chevrolet-camaro-6th-gen-lt1?bbt_vehicle=1&bbt_route=bt-fit-route-chevrolet-camaro-6th-gen-lt1&sort_by=price-ascending",
          "productCount": 10,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "ZL1 / LT4 6.2L Supercharged",
          "family": "GM LT",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-chevrolet-camaro-6th-gen-zl1-lt4",
          "systems": [
            "turbo-forced-induction",
            "fuel-system",
            "intake",
            "engine-parts"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "fuel-system": 1,
            "intake": 1,
            "engine-parts": 3
          },
          "url": "/collections/all/bt-fit-route-chevrolet-camaro-6th-gen-zl1-lt4?bbt_vehicle=1&bbt_route=bt-fit-route-chevrolet-camaro-6th-gen-zl1-lt4&sort_by=price-ascending",
          "productCount": 6,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Silverado 1500": {
      "K2XX": [
        {
          "label": "5.3L / 6.2L V8",
          "family": "GM K2XX",
          "url": "/collections/all/bt-fit-route-chevrolet-silverado1500-k2xx-5-3-6-2?bbt_vehicle=1&bbt_route=bt-fit-route-chevrolet-silverado1500-k2xx-5-3-6-2&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-chevrolet-silverado1500-k2xx-5-3-6-2",
          "engineTag": "bt-fit-engine-gm-v8-5-3-6-2",
          "systems": [],
          "systemCounts": {},
          "productCount": 0,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "T1XX / 2019+": [
        {
          "label": "5.3L / 6.2L V8",
          "family": "GM T1XX",
          "url": "/collections/all/bt-fit-route-chevrolet-silverado1500-t1xx-5-3-6-2?bbt_vehicle=1&bbt_route=bt-fit-route-chevrolet-silverado1500-t1xx-5-3-6-2&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-chevrolet-silverado1500-t1xx-5-3-6-2",
          "engineTag": "bt-fit-engine-gm-v8-5-3-6-2",
          "systems": [
            "intake"
          ],
          "systemCounts": {
            "intake": 4
          },
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "L87 6.2L V8",
          "family": "GM L87 6.2L",
          "url": "/collections/all/bt-fit-route-chevrolet-silverado1500-t1xx-l87-6-2?bbt_vehicle=1&bbt_route=bt-fit-route-chevrolet-silverado1500-t1xx-l87-6-2&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-chevrolet-silverado1500-t1xx-l87-6-2",
          "engineTag": "bt-fit-engine-l87",
          "systems": [
            "turbo-forced-induction",
            "intake"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "intake": 5
          },
          "productCount": 6,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Silverado 2500 / 3500 HD": {
      "2020+": [
        {
          "label": "6.6L Gas V8",
          "family": "GM HD",
          "url": "/collections/all/bt-fit-route-chevrolet-silverado-hd-2020-6-6-gas?bbt_vehicle=1&bbt_route=bt-fit-route-chevrolet-silverado-hd-2020-6-6-gas&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-chevrolet-silverado-hd-2020-6-6-gas",
          "engineTag": "bt-fit-engine-gm-6-6-gas-v8",
          "systems": [
            "fuel-system",
            "intake",
            "engine-parts"
          ],
          "systemCounts": {
            "fuel-system": 1,
            "intake": 1,
            "engine-parts": 1
          },
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "6.6L Duramax Diesel",
          "family": "GM HD",
          "url": "/collections/all/bt-fit-route-chevrolet-silverado-hd-2020-6-6-duramax?bbt_vehicle=1&bbt_route=bt-fit-route-chevrolet-silverado-hd-2020-6-6-duramax&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-chevrolet-silverado-hd-2020-6-6-duramax",
          "engineTag": "bt-fit-engine-duramax-6-6",
          "systems": [
            "intake"
          ],
          "systemCounts": {
            "intake": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Tahoe": {
      "2021+": [
        {
          "label": "5.3L / 6.2L V8",
          "family": "GM T1XX SUV",
          "url": "/collections/all/bt-fit-route-chevrolet-tahoe-2021-5-3-6-2?bbt_vehicle=1&bbt_route=bt-fit-route-chevrolet-tahoe-2021-5-3-6-2&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-chevrolet-tahoe-2021-5-3-6-2",
          "engineTag": "bt-fit-engine-gm-v8-5-3-6-2",
          "systems": [
            "intake"
          ],
          "systemCounts": {
            "intake": 4
          },
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "L87 6.2L V8",
          "family": "GM L87 6.2L",
          "url": "/collections/all/bt-fit-route-chevrolet-tahoe-2021-l87-6-2?bbt_vehicle=1&bbt_route=bt-fit-route-chevrolet-tahoe-2021-l87-6-2&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-chevrolet-tahoe-2021-l87-6-2",
          "engineTag": "bt-fit-engine-l87",
          "systems": [
            "turbo-forced-induction",
            "intake"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "intake": 4
          },
          "productCount": 5,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Suburban": {
      "2021+": [
        {
          "label": "5.3L / 6.2L V8",
          "family": "GM T1XX SUV",
          "url": "/collections/all/bt-fit-route-chevrolet-suburban-2021-5-3-6-2?bbt_vehicle=1&bbt_route=bt-fit-route-chevrolet-suburban-2021-5-3-6-2&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-chevrolet-suburban-2021-5-3-6-2",
          "engineTag": "bt-fit-engine-gm-v8-5-3-6-2",
          "systems": [
            "intake"
          ],
          "systemCounts": {
            "intake": 4
          },
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "L87 6.2L V8",
          "family": "GM L87 6.2L",
          "url": "/collections/all/bt-fit-route-chevrolet-suburban-2021-l87-6-2?bbt_vehicle=1&bbt_route=bt-fit-route-chevrolet-suburban-2021-l87-6-2&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-chevrolet-suburban-2021-l87-6-2",
          "engineTag": "bt-fit-engine-l87",
          "systems": [
            "turbo-forced-induction",
            "intake"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "intake": 4
          },
          "productCount": 5,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Blazer": {
      "2019–2020": [
        {
          "label": "3.6L V6",
          "family": "GM 3.6 V6",
          "url": "/collections/all/bt-fit-route-chevrolet-blazer-2019-2020-3-6-v6?bbt_vehicle=1&bbt_route=bt-fit-route-chevrolet-blazer-2019-2020-3-6-v6&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-chevrolet-blazer-2019-2020-3-6-v6",
          "engineTag": "bt-fit-engine-gm-3-6-v6",
          "systems": [
            "intake"
          ],
          "systemCounts": {
            "intake": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Cobalt SS": {
      "2004–2007": [
        {
          "label": "LSJ 2.0L Supercharged",
          "family": "GM LSJ",
          "url": "/collections/all/bt-fit-route-chevrolet-cobalt-ss-2004-2007-lsj?bbt_vehicle=1&bbt_route=bt-fit-route-chevrolet-cobalt-ss-2004-2007-lsj&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-chevrolet-cobalt-ss-2004-2007-lsj",
          "engineTag": "bt-fit-engine-lsj",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Engine Family / Custom": {
      "GM LS": [
        {
          "label": "4-inch-stroke engine build",
          "family": "GM LS Engine Build",
          "url": "/collections/all/bt-fit-route-chevrolet-engine-family-ls-4inch-stroke-build?bbt_vehicle=1&bbt_route=bt-fit-route-chevrolet-engine-family-ls-4inch-stroke-build&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-chevrolet-engine-family-ls-4inch-stroke-build",
          "engineTag": "bt-fit-engine-ls-4inch-stroke",
          "systems": [
            "engine-parts"
          ],
          "systemCounts": {
            "engine-parts": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "LTG 2.0T": [
        {
          "label": "GM LTG 2.0L Turbo",
          "family": "GM LTG",
          "url": "/collections/all/bt-fit-route-chevrolet-engine-family-ltg-2-0t?bbt_vehicle=1&bbt_route=bt-fit-route-chevrolet-engine-family-ltg-2-0t&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-chevrolet-engine-family-ltg-2-0t",
          "engineTag": "bt-fit-engine-ltg",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "Ford": {
    "Falcon": {
      "BA / BF": [
        {
          "label": "Barra 6-cyl",
          "family": "Ford Barra",
          "url": "/collections/all/bt-fit-route-ford-falcon-ba-bf-barra?bbt_vehicle=1&bbt_route=bt-fit-route-ford-falcon-ba-bf-barra&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-falcon-ba-bf-barra",
          "engineTag": "bt-fit-engine-barra",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "clutch",
            "transmission-driveline",
            "suspension-brakes",
            "tools-accessories"
          ],
          "systemCounts": {
            "engine-management": 1,
            "wiring-sensors-displays": 4,
            "turbo-forced-induction": 20,
            "intercooler": 11,
            "fuel-system": 6,
            "intake": 18,
            "exhaust": 12,
            "engine-parts": 50,
            "ignition": 3,
            "clutch": 5,
            "transmission-driveline": 8,
            "suspension-brakes": 2,
            "tools-accessories": 1
          },
          "productCount": 117,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "Barra 5.4L V8 24V",
          "family": "Ford Barra V8 5.4 24V",
          "url": "/collections/all/bt-fit-route-ford-falcon-ba-bf-barra-v8-5-4-24v?bbt_vehicle=1&bbt_route=bt-fit-route-ford-falcon-ba-bf-barra-v8-5-4-24v&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-falcon-ba-bf-barra-v8-5-4-24v",
          "engineTag": "bt-fit-engine-barra-v8-5-4-24v",
          "systems": [
            "fuel-system"
          ],
          "systemCounts": {
            "fuel-system": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "BOSS 5.4L V8",
          "family": "Ford BOSS 5.4",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-falcon-ba-bf-boss-5-4",
          "systems": [
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "turbo-forced-induction": 3,
            "intercooler": 1,
            "fuel-system": 1,
            "intake": 4,
            "exhaust": 5,
            "engine-parts": 16,
            "clutch": 2,
            "transmission-driveline": 2
          },
          "url": "/collections/all/bt-fit-route-ford-falcon-ba-bf-boss-5-4?bbt_vehicle=1&bbt_route=bt-fit-route-ford-falcon-ba-bf-boss-5-4&sort_by=price-ascending",
          "productCount": 26,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "FG / FG X": [
        {
          "label": "Barra 6-cyl",
          "family": "Ford Barra",
          "url": "/collections/all/bt-fit-route-ford-falcon-fg-fgx-barra?bbt_vehicle=1&bbt_route=bt-fit-route-ford-falcon-fg-fgx-barra&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-falcon-fg-fgx-barra",
          "engineTag": "bt-fit-engine-barra",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "clutch",
            "transmission-driveline",
            "suspension-brakes",
            "tools-accessories"
          ],
          "systemCounts": {
            "engine-management": 1,
            "wiring-sensors-displays": 4,
            "turbo-forced-induction": 24,
            "intercooler": 8,
            "fuel-system": 7,
            "intake": 11,
            "exhaust": 13,
            "engine-parts": 47,
            "ignition": 3,
            "clutch": 5,
            "transmission-driveline": 7,
            "suspension-brakes": 2,
            "tools-accessories": 1
          },
          "productCount": 112,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "5.0 Coyote / Miami V8",
          "family": "Ford Coyote",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-falcon-fg-fgx-coyote",
          "engineTag": "bt-fit-engine-coyote",
          "systems": [
            "turbo-forced-induction",
            "fuel-system",
            "intake",
            "exhaust",
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "turbo-forced-induction": 8,
            "fuel-system": 1,
            "intake": 1,
            "exhaust": 5,
            "clutch": 2,
            "transmission-driveline": 2,
            "suspension-brakes": 1
          },
          "url": "/collections/all/bt-fit-route-ford-falcon-fg-fgx-coyote?bbt_vehicle=1&bbt_route=bt-fit-route-ford-falcon-fg-fgx-coyote&sort_by=price-ascending",
          "productCount": 18,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "BOSS 5.4L V8 (FG XR8)",
          "family": "Ford BOSS 5.4",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-falcon-fg-boss-5-4",
          "systems": [
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "clutch",
            "transmission-driveline",
            "cooling"
          ],
          "systemCounts": {
            "turbo-forced-induction": 3,
            "intercooler": 1,
            "fuel-system": 1,
            "intake": 4,
            "exhaust": 4,
            "engine-parts": 11,
            "clutch": 2,
            "transmission-driveline": 2,
            "cooling": 1
          },
          "url": "/collections/all/bt-fit-route-ford-falcon-fg-boss-5-4?bbt_vehicle=1&bbt_route=bt-fit-route-ford-falcon-fg-boss-5-4&sort_by=price-ascending",
          "productCount": 21,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Mustang": {
      "S550 (2015–2023)": [
        {
          "label": "5.0L Coyote V8",
          "family": "Ford Mustang S550",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-mustang-s550-s650-5-0-coyote",
          "systems": [
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "clutch",
            "transmission-driveline",
            "cooling",
            "suspension-brakes"
          ],
          "systemCounts": {
            "wiring-sensors-displays": 1,
            "turbo-forced-induction": 6,
            "intercooler": 1,
            "fuel-system": 5,
            "intake": 11,
            "exhaust": 3,
            "engine-parts": 2,
            "clutch": 1,
            "transmission-driveline": 2,
            "cooling": 2,
            "suspension-brakes": 3
          },
          "url": "/collections/all/bt-fit-route-ford-mustang-s550-s650-5-0-coyote?bbt_vehicle=1&bbt_route=bt-fit-route-ford-mustang-s550-s650-5-0-coyote&sort_by=price-ascending",
          "productCount": 34,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "2.3L EcoBoost",
          "family": "Ford Mustang S550",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-mustang-s550-2-3-ecoboost",
          "systems": [
            "turbo-forced-induction",
            "fuel-system"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2,
            "fuel-system": 2
          },
          "url": "/collections/all/bt-fit-route-ford-mustang-s550-2-3-ecoboost?bbt_vehicle=1&bbt_route=bt-fit-route-ford-mustang-s550-2-3-ecoboost&sort_by=price-ascending",
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "S650 (2024+)": [
        {
          "label": "5.0L Coyote V8",
          "family": "Ford Mustang S650",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-mustang-s650-5-0-coyote",
          "systems": [
            "intake",
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "intake": 2,
            "clutch": 1,
            "transmission-driveline": 1
          },
          "url": "/collections/all/bt-fit-route-ford-mustang-s650-5-0-coyote?bbt_vehicle=1&bbt_route=bt-fit-route-ford-mustang-s650-5-0-coyote&sort_by=price-ascending",
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "2.3L EcoBoost",
          "family": "Ford Mustang S650",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-mustang-s650-2-3-ecoboost",
          "systems": [
            "intake"
          ],
          "systemCounts": {
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-ford-mustang-s650-2-3-ecoboost?bbt_vehicle=1&bbt_route=bt-fit-route-ford-mustang-s650-2-3-ecoboost&sort_by=price-ascending",
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Ranger": {
      "PJ / PK": [
        {
          "label": "PJ / PK",
          "family": "Ford Ranger PJ/PK",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-ranger-pj-pk-pj-pk",
          "systems": [
            "exhaust",
            "transmission-driveline"
          ],
          "systemCounts": {
            "exhaust": 2,
            "transmission-driveline": 4
          },
          "url": "/collections/all/bt-fit-route-ford-ranger-pj-pk-pj-pk?bbt_vehicle=1&bbt_route=bt-fit-route-ford-ranger-pj-pk-pj-pk&sort_by=price-ascending",
          "productCount": 6,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "PX / PX2": [
        {
          "label": "PX / PX2",
          "family": "Ford Ranger PX/PX2",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-ranger-px-px2-px-px2",
          "systems": [
            "intercooler",
            "intake",
            "exhaust",
            "transmission-driveline"
          ],
          "systemCounts": {
            "intercooler": 2,
            "intake": 1,
            "exhaust": 4,
            "transmission-driveline": 5
          },
          "url": "/collections/all/bt-fit-route-ford-ranger-px-px2-px-px2?bbt_vehicle=1&bbt_route=bt-fit-route-ford-ranger-px-px2-px-px2&sort_by=price-ascending",
          "productCount": 12,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "PY / Next Gen (2023+)": [
        {
          "label": "3.0L V6 Turbo Diesel",
          "family": "Ford Ranger PY",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-ranger-py-v6-diesel",
          "systems": [
            "intercooler",
            "engine-parts",
            "transmission-driveline",
            "cooling",
            "suspension-brakes"
          ],
          "systemCounts": {
            "intercooler": 1,
            "engine-parts": 1,
            "transmission-driveline": 2,
            "cooling": 1,
            "suspension-brakes": 1
          },
          "url": "/collections/all/bt-fit-route-ford-ranger-py-v6-diesel?bbt_vehicle=1&bbt_route=bt-fit-route-ford-ranger-py-v6-diesel&sort_by=price-ascending",
          "productCount": 5,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "PX3 (2018–2022)": [
        {
          "label": "3.2L Turbo Diesel",
          "family": "Ford Ranger PX3",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-ranger-px3-32-diesel",
          "systems": [
            "intercooler",
            "intake",
            "exhaust",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "intercooler": 2,
            "intake": 1,
            "exhaust": 1,
            "transmission-driveline": 1,
            "suspension-brakes": 1
          },
          "url": "/collections/all/bt-fit-route-ford-ranger-px3-32-diesel?bbt_vehicle=1&bbt_route=bt-fit-route-ford-ranger-px3-32-diesel&sort_by=price-ascending",
          "productCount": 6,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "2.0L Bi-Turbo Diesel",
          "family": "Ford Ranger PX3",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-ranger-px3-20-biturbo-diesel",
          "systems": [
            "intercooler",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "intercooler": 1,
            "transmission-driveline": 1,
            "suspension-brakes": 1
          },
          "url": "/collections/all/bt-fit-route-ford-ranger-px3-20-biturbo-diesel?bbt_vehicle=1&bbt_route=bt-fit-route-ford-ranger-px3-20-biturbo-diesel&sort_by=price-ascending",
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "Raptor 2.0L Bi-Turbo Diesel",
          "family": "Ford Ranger PX3 Raptor",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-ranger-px3-raptor-20-biturbo-diesel",
          "systems": [
            "intercooler",
            "exhaust",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "intercooler": 1,
            "exhaust": 1,
            "transmission-driveline": 1,
            "suspension-brakes": 1
          },
          "url": "/collections/all/bt-fit-route-ford-ranger-px3-raptor-20-biturbo-diesel?bbt_vehicle=1&bbt_route=bt-fit-route-ford-ranger-px3-raptor-20-biturbo-diesel&sort_by=price-ascending",
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "Next Gen Raptor (2023+)": [
        {
          "label": "3.0L Twin-Turbo V6 Petrol",
          "family": "Ford Ranger Raptor",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-ranger-next-gen-raptor-30-v6-petrol",
          "systems": [
            "turbo-forced-induction",
            "intercooler",
            "intake",
            "exhaust",
            "engine-parts",
            "transmission-driveline",
            "cooling"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "intercooler": 5,
            "intake": 1,
            "exhaust": 1,
            "engine-parts": 1,
            "transmission-driveline": 2,
            "cooling": 1
          },
          "url": "/collections/all/bt-fit-route-ford-ranger-next-gen-raptor-30-v6-petrol?bbt_vehicle=1&bbt_route=bt-fit-route-ford-ranger-next-gen-raptor-30-v6-petrol&sort_by=price-ascending",
          "productCount": 10,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "USA 2019+": [
        {
          "label": "2.3L EcoBoost — Kompact EM",
          "family": "Ford Ranger US",
          "url": "/collections/all/bt-fit-route-ford-ranger-us-2019-23-ecoboost?bbt_vehicle=1&bbt_route=bt-fit-route-ford-ranger-us-2019-23-ecoboost&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-ranger-us-2019-23-ecoboost",
          "engineTag": "bt-fit-engine-ford-23-ecoboost",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Territory": {
      "SX / SY / SZ": [
        {
          "label": "Territory",
          "family": "Ford Territory",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-territory-sx-sy-sz-territory",
          "systems": [
            "intake",
            "exhaust",
            "transmission-driveline"
          ],
          "systemCounts": {
            "intake": 1,
            "exhaust": 3,
            "transmission-driveline": 2
          },
          "url": "/collections/all/bt-fit-route-ford-territory-sx-sy-sz-territory?bbt_vehicle=1&bbt_route=bt-fit-route-ford-territory-sx-sy-sz-territory&sort_by=price-ascending",
          "productCount": 6,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Focus RS": {
      "Mk3 / LZ": [
        {
          "label": "2.3 EcoBoost",
          "family": "Ford Focus RS",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-focus-rs-mk3-lz-2-3-ecoboost",
          "systems": [
            "turbo-forced-induction",
            "intake"
          ],
          "systemCounts": {
            "turbo-forced-induction": 3,
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-ford-focus-rs-mk3-lz-2-3-ecoboost?bbt_vehicle=1&bbt_route=bt-fit-route-ford-focus-rs-mk3-lz-2-3-ecoboost&sort_by=price-ascending",
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "Mk1 (2002–2003)": [
        {
          "label": "2.0L Turbo",
          "family": "Ford Focus RS",
          "url": "/collections/all/bt-fit-route-ford-focus-rs-mk1-20-turbo?bbt_vehicle=1&bbt_route=bt-fit-route-ford-focus-rs-mk1-20-turbo&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-focus-rs-mk1-20-turbo",
          "engineTag": "bt-fit-engine-focus-rs-mk1",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Focus XR5": {
      "Mk2 (2006–2011)": [
        {
          "label": "2.5L Turbo",
          "family": "Ford Focus XR5",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-focus-xr5-mk2-2-5-turbo",
          "systems": [
            "turbo-forced-induction",
            "intake"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2,
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-ford-focus-xr5-mk2-2-5-turbo?bbt_vehicle=1&bbt_route=bt-fit-route-ford-focus-xr5-mk2-2-5-turbo&sort_by=price-ascending",
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Focus ST": {
      "Mk3 (2013–2018)": [
        {
          "label": "2.0L EcoBoost",
          "family": "Ford Focus ST",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-focus-st-mk3-2-0-ecoboost",
          "systems": [
            "turbo-forced-induction",
            "intake"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2,
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-ford-focus-st-mk3-2-0-ecoboost?bbt_vehicle=1&bbt_route=bt-fit-route-ford-focus-st-mk3-2-0-ecoboost&sort_by=price-ascending",
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "F-150": {
      "2011–2014": [
        {
          "label": "5.0L Coyote V8",
          "family": "Ford F-150",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-f150-2011-2014-50-coyote",
          "systems": [
            "intake"
          ],
          "systemCounts": {
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-ford-f150-2011-2014-50-coyote?bbt_vehicle=1&bbt_route=bt-fit-route-ford-f150-2011-2014-50-coyote&sort_by=price-ascending",
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "2015–2019": [
        {
          "label": "5.0L Coyote V8",
          "family": "Ford F-150",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-f150-2015-2019-50-coyote",
          "systems": [
            "intake"
          ],
          "systemCounts": {
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-ford-f150-2015-2019-50-coyote?bbt_vehicle=1&bbt_route=bt-fit-route-ford-f150-2015-2019-50-coyote&sort_by=price-ascending",
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "2021–2025": [
        {
          "label": "2.7L EcoBoost",
          "family": "Ford F-150",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-f150-2021-2025-27-ecoboost",
          "systems": [
            "intercooler",
            "intake"
          ],
          "systemCounts": {
            "intercooler": 1,
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-ford-f150-2021-2025-27-ecoboost?bbt_vehicle=1&bbt_route=bt-fit-route-ford-f150-2021-2025-27-ecoboost&sort_by=price-ascending",
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "3.5L EcoBoost — non-PowerBoost",
          "family": "Ford F-150",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-f150-2021-2025-35-ecoboost-non-powerboost",
          "systems": [
            "intercooler",
            "intake"
          ],
          "systemCounts": {
            "intercooler": 1,
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-ford-f150-2021-2025-35-ecoboost-non-powerboost?bbt_vehicle=1&bbt_route=bt-fit-route-ford-f150-2021-2025-35-ecoboost-non-powerboost&sort_by=price-ascending",
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "Raptor 3.5L EcoBoost",
          "family": "Ford F-150 Raptor",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-f150-raptor-2021-2025-35-ecoboost",
          "systems": [
            "intercooler",
            "intake"
          ],
          "systemCounts": {
            "intercooler": 1,
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-ford-f150-raptor-2021-2025-35-ecoboost?bbt_vehicle=1&bbt_route=bt-fit-route-ford-f150-raptor-2021-2025-35-ecoboost&sort_by=price-ascending",
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "2011–2012": [
        {
          "label": "3.5L EcoBoost",
          "family": "Ford EcoBoost",
          "url": "/collections/all/bt-fit-route-ford-f150-2011-2012-35-ecoboost?bbt_vehicle=1&bbt_route=bt-fit-route-ford-f150-2011-2012-35-ecoboost&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-f150-2011-2012-35-ecoboost",
          "engineTag": "bt-fit-engine-ford-35-ecoboost",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Maverick": {
      "1988–1997": [
        {
          "label": "4WD / H233 driveline",
          "family": "Ford Maverick",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-maverick-1988-1997",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 5
          },
          "url": "/collections/all/bt-fit-route-ford-maverick-1988-1997?bbt_vehicle=1&bbt_route=bt-fit-route-ford-maverick-1988-1997&sort_by=price-ascending",
          "productCount": 5,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Engine Family / Custom": {
      "7.3 Godzilla": [
        {
          "label": "7.3L Godzilla V8 — crate / swap",
          "family": "Ford Engine Family",
          "url": "/collections/all/bt-fit-route-ford-engine-family-7-3-godzilla?bbt_vehicle=1&bbt_route=bt-fit-route-ford-engine-family-7-3-godzilla&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-engine-family-7-3-godzilla",
          "engineTag": "bt-fit-engine-ford-7-3-godzilla",
          "systems": [
            "turbo-forced-induction",
            "intake",
            "engine-parts"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2,
            "intake": 1,
            "engine-parts": 1
          },
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "Small Block Ford": [
        {
          "label": "Small Block Ford V8 — 8.2 / 9.5 deck",
          "family": "Ford Engine Family",
          "url": "/collections/all/bt-fit-route-ford-engine-family-small-block-ford?bbt_vehicle=1&bbt_route=bt-fit-route-ford-engine-family-small-block-ford&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-engine-family-small-block-ford",
          "engineTag": "bt-fit-engine-small-block-ford",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "EA–AU SOHC": [
        {
          "label": "4.0L SOHC / Intech — EA to AU",
          "family": "Ford Engine Family",
          "url": "/collections/all/bt-fit-route-ford-engine-family-ea-au-sohc?bbt_vehicle=1&bbt_route=bt-fit-route-ford-engine-family-ea-au-sohc&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-engine-family-ea-au-sohc",
          "engineTag": "bt-fit-engine-ford-ea-au-sohc",
          "systems": [
            "turbo-forced-induction",
            "exhaust",
            "engine-parts"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "exhaust": 1,
            "engine-parts": 3
          },
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "X-Series SOHC": [
        {
          "label": "Ford X-Series SOHC",
          "family": "Ford Engine Family",
          "url": "/collections/all/bt-fit-route-ford-engine-family-x-series-sohc?bbt_vehicle=1&bbt_route=bt-fit-route-ford-engine-family-x-series-sohc&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-engine-family-x-series-sohc",
          "engineTag": "bt-fit-engine-ford-x-series-sohc",
          "systems": [
            "turbo-forced-induction",
            "exhaust"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "exhaust": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "250 Crossflow": [
        {
          "label": "250 Crossflow — Falcon / Cortina applications",
          "family": "Ford Engine Family",
          "url": "/collections/all/bt-fit-route-ford-engine-family-250-crossflow?bbt_vehicle=1&bbt_route=bt-fit-route-ford-engine-family-250-crossflow&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-engine-family-250-crossflow",
          "engineTag": "bt-fit-engine-ford-250-crossflow",
          "systems": [
            "turbo-forced-induction",
            "exhaust",
            "engine-parts"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "exhaust": 1,
            "engine-parts": 2
          },
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Differential Family / Custom": {
      "Ford 9in / 28 spline": [
        {
          "label": "Ford 9in / 28 spline",
          "family": "Ford Differential Family",
          "url": "/collections/all/bt-fit-route-ford-driveline-ford9-28spline?bbt_vehicle=1&bbt_route=bt-fit-route-ford-driveline-ford9-28spline&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-driveline-ford9-28spline",
          "engineTag": "bt-fit-diff-ford-9-28",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 2
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "Ford 9in / 31 spline": [
        {
          "label": "Ford 9in / 31 spline",
          "family": "Ford Differential Family",
          "url": "/collections/all/bt-fit-route-ford-driveline-ford9-31spline?bbt_vehicle=1&bbt_route=bt-fit-route-ford-driveline-ford9-31spline&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-driveline-ford9-31spline",
          "engineTag": "bt-fit-diff-ford-9-31",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 3
          },
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "Ford 9in / 35 spline": [
        {
          "label": "Ford 9in / 35 spline",
          "family": "Ford Differential Family",
          "url": "/collections/all/bt-fit-route-ford-driveline-ford9-35spline?bbt_vehicle=1&bbt_route=bt-fit-route-ford-driveline-ford9-35spline&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-driveline-ford9-35spline",
          "engineTag": "bt-fit-diff-ford-9-35",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 4
          },
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "Ford 8in / 28 spline": [
        {
          "label": "Ford 8in / 28 spline",
          "family": "Ford Differential Family",
          "url": "/collections/all/bt-fit-route-ford-driveline-ford8-28spline?bbt_vehicle=1&bbt_route=bt-fit-route-ford-driveline-ford8-28spline&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-driveline-ford8-28spline",
          "engineTag": "bt-fit-diff-ford-8-28",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "Ford 7.5in C-Clip / 28 spline": [
        {
          "label": "Ford 7.5in C-Clip / 28 spline",
          "family": "Ford Differential Family",
          "url": "/collections/all/bt-fit-route-ford-driveline-ford75-28spline?bbt_vehicle=1&bbt_route=bt-fit-route-ford-driveline-ford75-28spline&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-driveline-ford75-28spline",
          "engineTag": "bt-fit-diff-ford-7-5-28",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Fiesta ST": {
      "1.6 EcoBoost": [
        {
          "label": "1.6L EcoBoost Turbo",
          "family": "Ford EcoBoost",
          "url": "/collections/all/bt-fit-route-ford-fiesta-st-16-ecoboost?bbt_vehicle=1&bbt_route=bt-fit-route-ford-fiesta-st-16-ecoboost&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-fiesta-st-16-ecoboost",
          "engineTag": "bt-fit-engine-ford-16-ecoboost",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Fiesta": {
      "EcoBoost": [
        {
          "label": "EcoBoost turbo — Turbosmart direct-fit",
          "family": "Ford EcoBoost",
          "url": "/collections/all/bt-fit-route-ford-fiesta-ecoboost-turbosmart?bbt_vehicle=1&bbt_route=bt-fit-route-ford-fiesta-ecoboost-turbosmart&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-fiesta-ecoboost-turbosmart",
          "engineTag": "bt-fit-engine-ford-ecoboost",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Focus": {
      "Mk3": [
        {
          "label": "1.5 / 1.6 EcoBoost",
          "family": "Ford EcoBoost",
          "url": "/collections/all/bt-fit-route-ford-focus-mk3-15-16-ecoboost?bbt_vehicle=1&bbt_route=bt-fit-route-ford-focus-mk3-15-16-ecoboost&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-focus-mk3-15-16-ecoboost",
          "engineTag": "bt-fit-engine-ford-15-16-ecoboost",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Explorer ST": {
      "2020–2022": [
        {
          "label": "3.0L EcoBoost",
          "family": "Ford Explorer ST",
          "url": "/collections/all/bt-fit-route-ford-explorer-st-2020-2022-30-ecoboost?bbt_vehicle=1&bbt_route=bt-fit-route-ford-explorer-st-2020-2022-30-ecoboost&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-explorer-st-2020-2022-30-ecoboost",
          "engineTag": "bt-fit-engine-ford-30-ecoboost",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Component Family / Custom": {
      "EcoBoost Kompact EM VR2": [
        {
          "label": "Kompact EM",
          "family": "Turbosmart Component Family",
          "url": "/collections/all/bt-fit-route-ford-ecoboost-kompact-em-vr2?bbt_vehicle=1&bbt_route=bt-fit-route-ford-ecoboost-kompact-em-vr2&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-ecoboost-kompact-em-vr2",
          "engineTag": "bt-fit-component-ford-ecoboost-kompact-em-vr2",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "Kompact EM VR19 — EcoBoost / Ranger Raptor": [
        {
          "label": "Kompact EM",
          "family": "Turbosmart Component Family",
          "url": "/collections/all/bt-fit-route-ford-kompact-em-vr19?bbt_vehicle=1&bbt_route=bt-fit-route-ford-kompact-em-vr19&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ford-kompact-em-vr19",
          "engineTag": "bt-fit-component-ford-kompact-em-vr19",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "Mazda": {
    "BT-50": {
      "UN": [
        {
          "label": "UN",
          "family": "Mazda BT-50 UN",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-mazda-bt-50-un-un",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 5
          },
          "url": "/collections/all/bt-fit-route-mazda-bt-50-un-un?bbt_vehicle=1&bbt_route=bt-fit-route-mazda-bt-50-un-un&sort_by=price-ascending",
          "productCount": 5,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "UP / UR": [
        {
          "label": "UP / UR",
          "family": "Mazda BT-50 UP/UR",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-mazda-bt-50-up-ur-up-ur",
          "systems": [
            "intercooler",
            "transmission-driveline"
          ],
          "systemCounts": {
            "intercooler": 2,
            "transmission-driveline": 4
          },
          "url": "/collections/all/bt-fit-route-mazda-bt-50-up-ur-up-ur?bbt_vehicle=1&bbt_route=bt-fit-route-mazda-bt-50-up-ur-up-ur&sort_by=price-ascending",
          "productCount": 6,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "MX-5": {
      "NA": [
        {
          "label": "NA",
          "family": "Mazda MX-5 NA",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-mazda-mx5-na",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "engine-parts",
            "clutch",
            "transmission-driveline",
            "suspension-brakes",
            "tools-accessories"
          ],
          "systemCounts": {
            "engine-management": 3,
            "wiring-sensors-displays": 6,
            "engine-parts": 4,
            "clutch": 1,
            "transmission-driveline": 1,
            "suspension-brakes": 6,
            "tools-accessories": 1
          },
          "url": "/collections/all/bt-fit-route-mazda-mx5-na?bbt_vehicle=1&bbt_route=bt-fit-route-mazda-mx5-na&sort_by=price-ascending",
          "productCount": 18,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "NB": [
        {
          "label": "NB",
          "family": "Mazda MX-5 NB",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-mazda-mx5-nb",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "engine-parts",
            "clutch",
            "transmission-driveline",
            "suspension-brakes",
            "tools-accessories"
          ],
          "systemCounts": {
            "engine-management": 3,
            "wiring-sensors-displays": 6,
            "engine-parts": 3,
            "clutch": 1,
            "transmission-driveline": 1,
            "suspension-brakes": 6,
            "tools-accessories": 1
          },
          "url": "/collections/all/bt-fit-route-mazda-mx5-nb?bbt_vehicle=1&bbt_route=bt-fit-route-mazda-mx5-nb&sort_by=price-ascending",
          "productCount": 17,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "ND": [
        {
          "label": "ND",
          "family": "Mazda MX-5 ND",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-mazda-mx5-nd",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 1
          },
          "url": "/collections/all/bt-fit-route-mazda-mx5-nd?bbt_vehicle=1&bbt_route=bt-fit-route-mazda-mx5-nd&sort_by=price-ascending",
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "RX-7": {
      "FD Series 6": [
        {
          "label": "13B-REW",
          "family": "Mazda RX-7 FD Series 6",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-mazda-rx7-fd-series-6",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 3,
            "wiring-sensors-displays": 5,
            "suspension-brakes": 1
          },
          "url": "/collections/all/bt-fit-route-mazda-rx7-fd-series-6?bbt_vehicle=1&bbt_route=bt-fit-route-mazda-rx7-fd-series-6&sort_by=price-ascending",
          "productCount": 6,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "FD Series 7 / 8": [
        {
          "label": "13B-REW",
          "family": "Mazda RX-7 FD Series 7/8",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-mazda-rx7-fd-series-7-8",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 3,
            "wiring-sensors-displays": 5,
            "suspension-brakes": 1
          },
          "url": "/collections/all/bt-fit-route-mazda-rx7-fd-series-7-8?bbt_vehicle=1&bbt_route=bt-fit-route-mazda-rx7-fd-series-7-8&sort_by=price-ascending",
          "productCount": 6,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "RX-8": {
      "Series 1": [
        {
          "label": "13B-MSP Renesis",
          "family": "Mazda RX-8 Series 1",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-mazda-rx8-series-1",
          "systems": [
            "engine-management",
            "wiring-sensors-displays"
          ],
          "systemCounts": {
            "engine-management": 2,
            "wiring-sensors-displays": 1
          },
          "url": "/collections/all/bt-fit-route-mazda-rx8-series-1?bbt_vehicle=1&bbt_route=bt-fit-route-mazda-rx8-series-1&sort_by=price-ascending",
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "6": {
      "GG / GY (2002–2007)": [
        {
          "label": "1.8 / 2.0 / 2.3L",
          "family": "Mazda 6 GG / GY",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-mazda-6-gg-gy-2002-2007",
          "systems": [
            "intake"
          ],
          "systemCounts": {
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-mazda-6-gg-gy-2002-2007?bbt_vehicle=1&bbt_route=bt-fit-route-mazda-6-gg-gy-2002-2007&sort_by=price-ascending",
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "GH (2008–2010)": [
        {
          "label": "1.8 / 2.0 / 2.5L",
          "family": "Mazda 6 GH",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-mazda-6-gh-2008-2010",
          "systems": [
            "intake"
          ],
          "systemCounts": {
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-mazda-6-gh-2008-2010?bbt_vehicle=1&bbt_route=bt-fit-route-mazda-6-gh-2008-2010&sort_by=price-ascending",
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "3 MPS": {
      "BK (2007–2009)": [
        {
          "label": "2.3L MZR Turbo — RHD",
          "family": "Mazda MPS 2.3 MZR",
          "url": "/collections/all/bt-fit-route-mazda-3-mps-bk-23-mzr-turbo?bbt_vehicle=1&bbt_route=bt-fit-route-mazda-3-mps-bk-23-mzr-turbo&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-mazda-3-mps-bk-23-mzr-turbo",
          "engineTag": "bt-fit-engine-mzr-23-turbo",
          "systems": [
            "turbo-forced-induction",
            "engine-parts"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2,
            "engine-parts": 1
          },
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "BL (2010+)": [
        {
          "label": "2.3L MZR Turbo — RHD",
          "family": "Mazda MPS 2.3 MZR",
          "url": "/collections/all/bt-fit-route-mazda-3-mps-bl-23-mzr-turbo?bbt_vehicle=1&bbt_route=bt-fit-route-mazda-3-mps-bl-23-mzr-turbo&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-mazda-3-mps-bl-23-mzr-turbo",
          "engineTag": "bt-fit-engine-mzr-23-turbo",
          "systems": [
            "turbo-forced-induction",
            "engine-parts"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2,
            "engine-parts": 1
          },
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "6 MPS": {
      "GG (2005–2007)": [
        {
          "label": "2.3L MZR Turbo — RHD",
          "family": "Mazda MPS 2.3 MZR",
          "url": "/collections/all/bt-fit-route-mazda-6-mps-gg-23-mzr-turbo?bbt_vehicle=1&bbt_route=bt-fit-route-mazda-6-mps-gg-23-mzr-turbo&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-mazda-6-mps-gg-23-mzr-turbo",
          "engineTag": "bt-fit-engine-mzr-23-turbo",
          "systems": [
            "turbo-forced-induction",
            "engine-parts"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2,
            "engine-parts": 1
          },
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "CX-7": {
      "2007+": [
        {
          "label": "2.3L MZR Turbo — RHD",
          "family": "Mazda MPS 2.3 MZR",
          "url": "/collections/all/bt-fit-route-mazda-cx7-23-mzr-turbo?bbt_vehicle=1&bbt_route=bt-fit-route-mazda-cx7-23-mzr-turbo&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-mazda-cx7-23-mzr-turbo",
          "engineTag": "bt-fit-engine-mzr-23-turbo",
          "systems": [
            "turbo-forced-induction",
            "engine-parts"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2,
            "engine-parts": 1
          },
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Protegé": {
      "BJ / 2003": [
        {
          "label": "FS-DET 2.0L Turbo",
          "family": "Mazda Protegé",
          "url": "/collections/all/bt-fit-route-mazda-protege-bj-2003-fsdet?bbt_vehicle=1&bbt_route=bt-fit-route-mazda-protege-bj-2003-fsdet&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-mazda-protege-bj-2003-fsdet",
          "engineTag": "bt-fit-engine-fs-det",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "Nissan": {
    "Skyline": {
      "R32": [
        {
          "label": "RB20",
          "family": "Nissan RB",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-rb20",
          "routeTag": "bt-fit-route-nissan-skyline-r32-rb20",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "clutch",
            "transmission-driveline",
            "cooling",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 6,
            "wiring-sensors-displays": 9,
            "turbo-forced-induction": 6,
            "intercooler": 1,
            "fuel-system": 1,
            "intake": 1,
            "exhaust": 2,
            "engine-parts": 13,
            "ignition": 2,
            "clutch": 5,
            "transmission-driveline": 6,
            "cooling": 1,
            "suspension-brakes": 28
          },
          "url": "/collections/all/bt-fit-route-nissan-skyline-r32-rb20?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-skyline-r32-rb20&sort_by=price-ascending",
          "productCount": 65,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "RB25",
          "family": "Nissan RB",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-rb25",
          "routeTag": "bt-fit-route-nissan-skyline-r32-rb25",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "clutch",
            "transmission-driveline",
            "cooling",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 2,
            "wiring-sensors-displays": 6,
            "turbo-forced-induction": 7,
            "intercooler": 1,
            "fuel-system": 2,
            "intake": 2,
            "exhaust": 3,
            "engine-parts": 21,
            "ignition": 2,
            "clutch": 5,
            "transmission-driveline": 5,
            "cooling": 2,
            "suspension-brakes": 26
          },
          "url": "/collections/all/bt-fit-route-nissan-skyline-r32-rb25?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-skyline-r32-rb25&sort_by=price-ascending",
          "productCount": 68,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "RB26",
          "family": "Nissan RB",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-rb26",
          "routeTag": "bt-fit-route-nissan-skyline-r32-rb26",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "clutch",
            "transmission-driveline",
            "cooling",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 6,
            "wiring-sensors-displays": 9,
            "turbo-forced-induction": 9,
            "intercooler": 2,
            "fuel-system": 4,
            "intake": 6,
            "exhaust": 4,
            "engine-parts": 22,
            "ignition": 2,
            "clutch": 7,
            "transmission-driveline": 9,
            "cooling": 2,
            "suspension-brakes": 25
          },
          "url": "/collections/all/bt-fit-route-nissan-skyline-r32-rb26?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-skyline-r32-rb26&sort_by=price-ascending",
          "productCount": 84,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "RB30",
          "family": "Nissan RB",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-rb30",
          "routeTag": "bt-fit-route-nissan-skyline-r32-rb30",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "clutch",
            "transmission-driveline",
            "cooling",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 2,
            "wiring-sensors-displays": 5,
            "turbo-forced-induction": 10,
            "intercooler": 1,
            "fuel-system": 3,
            "intake": 4,
            "exhaust": 6,
            "engine-parts": 30,
            "ignition": 2,
            "clutch": 2,
            "transmission-driveline": 2,
            "cooling": 1,
            "suspension-brakes": 21
          },
          "url": "/collections/all/bt-fit-route-nissan-skyline-r32-rb30?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-skyline-r32-rb30&sort_by=price-ascending",
          "productCount": 73,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "R33": [
        {
          "label": "RB25",
          "family": "Nissan RB",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-rb25",
          "routeTag": "bt-fit-route-nissan-skyline-r33-rb25",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "clutch",
            "transmission-driveline",
            "cooling",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 6,
            "wiring-sensors-displays": 9,
            "turbo-forced-induction": 7,
            "intercooler": 1,
            "fuel-system": 3,
            "intake": 5,
            "exhaust": 3,
            "engine-parts": 22,
            "ignition": 2,
            "clutch": 6,
            "transmission-driveline": 7,
            "cooling": 2,
            "suspension-brakes": 26
          },
          "url": "/collections/all/bt-fit-route-nissan-skyline-r33-rb25?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-skyline-r33-rb25&sort_by=price-ascending",
          "productCount": 78,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "RB26",
          "family": "Nissan RB",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-rb26",
          "routeTag": "bt-fit-route-nissan-skyline-r33-rb26",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "clutch",
            "transmission-driveline",
            "cooling",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 6,
            "wiring-sensors-displays": 9,
            "turbo-forced-induction": 9,
            "intercooler": 2,
            "fuel-system": 4,
            "intake": 6,
            "exhaust": 4,
            "engine-parts": 24,
            "ignition": 2,
            "clutch": 7,
            "transmission-driveline": 8,
            "cooling": 2,
            "suspension-brakes": 27
          },
          "url": "/collections/all/bt-fit-route-nissan-skyline-r33-rb26?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-skyline-r33-rb26&sort_by=price-ascending",
          "productCount": 87,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "RB30",
          "family": "Nissan RB",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-rb30",
          "routeTag": "bt-fit-route-nissan-skyline-r33-rb30",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "clutch",
            "transmission-driveline",
            "cooling",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 2,
            "wiring-sensors-displays": 5,
            "turbo-forced-induction": 10,
            "intercooler": 1,
            "fuel-system": 3,
            "intake": 4,
            "exhaust": 6,
            "engine-parts": 31,
            "ignition": 2,
            "clutch": 2,
            "transmission-driveline": 2,
            "cooling": 1,
            "suspension-brakes": 21
          },
          "url": "/collections/all/bt-fit-route-nissan-skyline-r33-rb30?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-skyline-r33-rb30&sort_by=price-ascending",
          "productCount": 74,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "R34": [
        {
          "label": "RB25",
          "family": "Nissan RB",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-rb25",
          "routeTag": "bt-fit-route-nissan-skyline-r34-rb25",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "clutch",
            "transmission-driveline",
            "cooling",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 6,
            "wiring-sensors-displays": 9,
            "turbo-forced-induction": 7,
            "intercooler": 1,
            "fuel-system": 4,
            "intake": 5,
            "exhaust": 3,
            "engine-parts": 21,
            "ignition": 2,
            "clutch": 6,
            "transmission-driveline": 7,
            "cooling": 2,
            "suspension-brakes": 27
          },
          "url": "/collections/all/bt-fit-route-nissan-skyline-r34-rb25?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-skyline-r34-rb25&sort_by=price-ascending",
          "productCount": 78,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "RB26",
          "family": "Nissan RB",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-rb26",
          "routeTag": "bt-fit-route-nissan-skyline-r34-rb26",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "clutch",
            "transmission-driveline",
            "cooling",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 7,
            "wiring-sensors-displays": 10,
            "turbo-forced-induction": 9,
            "intercooler": 2,
            "fuel-system": 4,
            "intake": 7,
            "exhaust": 4,
            "engine-parts": 23,
            "ignition": 2,
            "clutch": 7,
            "transmission-driveline": 8,
            "cooling": 2,
            "suspension-brakes": 22
          },
          "url": "/collections/all/bt-fit-route-nissan-skyline-r34-rb26?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-skyline-r34-rb26&sort_by=price-ascending",
          "productCount": 82,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "RB30",
          "family": "Nissan RB",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-rb30",
          "routeTag": "bt-fit-route-nissan-skyline-r34-rb30",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "clutch",
            "transmission-driveline",
            "cooling",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 2,
            "wiring-sensors-displays": 5,
            "turbo-forced-induction": 10,
            "intercooler": 1,
            "fuel-system": 3,
            "intake": 5,
            "exhaust": 6,
            "engine-parts": 30,
            "ignition": 2,
            "clutch": 2,
            "transmission-driveline": 2,
            "cooling": 1,
            "suspension-brakes": 19
          },
          "url": "/collections/all/bt-fit-route-nissan-skyline-r34-rb30?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-skyline-r34-rb30&sort_by=price-ascending",
          "productCount": 71,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "V35": [
        {
          "label": "V35",
          "family": "Nissan Skyline V35",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-nissan-skyline-v35-v35",
          "systems": [
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "clutch": 2,
            "transmission-driveline": 2,
            "suspension-brakes": 8
          },
          "url": "/collections/all/bt-fit-route-nissan-skyline-v35-v35?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-skyline-v35-v35&sort_by=price-ascending",
          "productCount": 10,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "V36": [
        {
          "label": "V36",
          "family": "Nissan Skyline V36",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-nissan-skyline-v36-v36",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 1
          },
          "url": "/collections/all/bt-fit-route-nissan-skyline-v36-v36?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-skyline-v36-v36&sort_by=price-ascending",
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Silvia / 180SX": {
      "S13 / 180SX": [
        {
          "label": "SR20",
          "family": "Nissan SR",
          "url": "/collections/all/bt-fit-route-nissan-silvia-180sx-s13-sr20?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-silvia-180sx-s13-sr20&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-nissan-silvia-180sx-s13-sr20",
          "engineTag": "bt-fit-engine-sr",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "intake",
            "exhaust",
            "engine-parts",
            "clutch",
            "transmission-driveline",
            "suspension-brakes",
            "tools-accessories"
          ],
          "systemCounts": {
            "engine-management": 4,
            "wiring-sensors-displays": 5,
            "turbo-forced-induction": 6,
            "intercooler": 3,
            "intake": 1,
            "exhaust": 3,
            "engine-parts": 13,
            "clutch": 4,
            "transmission-driveline": 4,
            "suspension-brakes": 29,
            "tools-accessories": 1
          },
          "productCount": 60,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "CA18DET",
          "family": "Nissan CA18DET",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-nissan-silvia-180sx-s13-ca18det",
          "systems": [
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "exhaust",
            "engine-parts",
            "suspension-brakes",
            "tools-accessories"
          ],
          "systemCounts": {
            "wiring-sensors-displays": 1,
            "turbo-forced-induction": 1,
            "exhaust": 1,
            "engine-parts": 3,
            "suspension-brakes": 2,
            "tools-accessories": 1
          },
          "url": "/collections/all/bt-fit-route-nissan-silvia-180sx-s13-ca18det?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-silvia-180sx-s13-ca18det&sort_by=price-ascending",
          "productCount": 8,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "S14": [
        {
          "label": "SR20",
          "family": "Nissan SR",
          "url": "/collections/all/bt-fit-route-nissan-silvia-s14-sr20?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-silvia-s14-sr20&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-nissan-silvia-s14-sr20",
          "engineTag": "bt-fit-engine-sr",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "clutch",
            "transmission-driveline",
            "suspension-brakes",
            "tools-accessories"
          ],
          "systemCounts": {
            "engine-management": 5,
            "wiring-sensors-displays": 6,
            "turbo-forced-induction": 6,
            "intercooler": 2,
            "fuel-system": 2,
            "intake": 3,
            "exhaust": 3,
            "engine-parts": 13,
            "clutch": 3,
            "transmission-driveline": 3,
            "suspension-brakes": 32,
            "tools-accessories": 1
          },
          "productCount": 64,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "S15": [
        {
          "label": "SR20",
          "family": "Nissan SR",
          "url": "/collections/all/bt-fit-route-nissan-silvia-s15-sr20?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-silvia-s15-sr20&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-nissan-silvia-s15-sr20",
          "engineTag": "bt-fit-engine-sr",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "clutch",
            "transmission-driveline",
            "suspension-brakes",
            "tools-accessories"
          ],
          "systemCounts": {
            "engine-management": 5,
            "wiring-sensors-displays": 5,
            "turbo-forced-induction": 6,
            "intercooler": 2,
            "fuel-system": 2,
            "intake": 3,
            "exhaust": 3,
            "engine-parts": 13,
            "clutch": 2,
            "transmission-driveline": 2,
            "suspension-brakes": 32,
            "tools-accessories": 1
          },
          "productCount": 63,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Patrol": {
      "GQ / Y60": [
        {
          "label": "TB42 4.2L Petrol",
          "family": "Nissan Patrol Y60",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-nissan-patrol-gq-y60-tb42",
          "engineTag": "bt-fit-engine-tb42",
          "systems": [
            "turbo-forced-induction",
            "exhaust",
            "engine-parts"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "exhaust": 3,
            "engine-parts": 7
          },
          "url": "/collections/all/bt-fit-route-nissan-patrol-gq-y60-tb42?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-patrol-gq-y60-tb42&sort_by=price-ascending",
          "productCount": 10,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "TB45",
          "family": "Nissan Patrol Y60",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-nissan-patrol-gq-y60-tb45",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "exhaust",
            "engine-parts",
            "transmission-driveline"
          ],
          "systemCounts": {
            "engine-management": 2,
            "wiring-sensors-displays": 3,
            "turbo-forced-induction": 1,
            "exhaust": 1,
            "engine-parts": 10,
            "transmission-driveline": 2
          },
          "url": "/collections/all/bt-fit-route-nissan-patrol-gq-y60-tb45?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-patrol-gq-y60-tb45&sort_by=price-ascending",
          "productCount": 16,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "GQ",
          "family": "Nissan Patrol GQ",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-nissan-patrol-gq-y60-gq",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "exhaust",
            "transmission-driveline"
          ],
          "systemCounts": {
            "engine-management": 2,
            "wiring-sensors-displays": 5,
            "exhaust": 4,
            "transmission-driveline": 4
          },
          "url": "/collections/all/bt-fit-route-nissan-patrol-gq-y60-gq?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-patrol-gq-y60-gq&sort_by=price-ascending",
          "productCount": 13,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "TD42 4.2L Diesel",
          "family": "Nissan Exact Engine",
          "url": "/collections/all/bt-fit-route-nissan-patrol-gq-y60-td42?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-patrol-gq-y60-td42&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-nissan-patrol-gq-y60-td42",
          "engineTag": "bt-fit-engine-td42",
          "systems": [
            "exhaust",
            "engine-parts"
          ],
          "systemCounts": {
            "exhaust": 3,
            "engine-parts": 2
          },
          "productCount": 5,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "RB30 3.0L Petrol",
          "family": "Nissan Exact Engine",
          "url": "/collections/all/bt-fit-route-nissan-patrol-gq-y60-rb30?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-patrol-gq-y60-rb30&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-nissan-patrol-gq-y60-rb30",
          "engineTag": "bt-fit-engine-rb30",
          "systems": [
            "exhaust"
          ],
          "systemCounts": {
            "exhaust": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "GU / Y61": [
        {
          "label": "TB45",
          "family": "Nissan Patrol Y61",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-nissan-patrol-gu-y61-tb45",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "exhaust",
            "engine-parts",
            "transmission-driveline"
          ],
          "systemCounts": {
            "engine-management": 2,
            "wiring-sensors-displays": 3,
            "turbo-forced-induction": 1,
            "exhaust": 2,
            "engine-parts": 10,
            "transmission-driveline": 4
          },
          "url": "/collections/all/bt-fit-route-nissan-patrol-gu-y61-tb45?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-patrol-gu-y61-tb45&sort_by=price-ascending",
          "productCount": 19,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "TB48",
          "family": "Nissan Patrol Y61",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-nissan-patrol-gu-y61-tb48",
          "systems": [
            "turbo-forced-induction",
            "fuel-system",
            "exhaust",
            "engine-parts"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "fuel-system": 1,
            "exhaust": 2,
            "engine-parts": 15
          },
          "url": "/collections/all/bt-fit-route-nissan-patrol-gu-y61-tb48?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-patrol-gu-y61-tb48&sort_by=price-ascending",
          "productCount": 18,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "GU",
          "family": "Nissan Patrol GU",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-nissan-patrol-gu-y61-gu",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "exhaust",
            "transmission-driveline"
          ],
          "systemCounts": {
            "engine-management": 2,
            "wiring-sensors-displays": 5,
            "exhaust": 9,
            "transmission-driveline": 6
          },
          "url": "/collections/all/bt-fit-route-nissan-patrol-gu-y61-gu?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-patrol-gu-y61-gu&sort_by=price-ascending",
          "productCount": 20,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "TD42 4.2L Diesel",
          "family": "Nissan Exact Engine",
          "url": "/collections/all/bt-fit-route-nissan-patrol-gu-y61-td42?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-patrol-gu-y61-td42&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-nissan-patrol-gu-y61-td42",
          "engineTag": "bt-fit-engine-td42",
          "systems": [
            "exhaust",
            "engine-parts"
          ],
          "systemCounts": {
            "exhaust": 3,
            "engine-parts": 2
          },
          "productCount": 5,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "ZD30 3.0L Diesel",
          "family": "Nissan Exact Engine",
          "url": "/collections/all/bt-fit-route-nissan-patrol-gu-y61-zd30?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-patrol-gu-y61-zd30&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-nissan-patrol-gu-y61-zd30",
          "engineTag": "bt-fit-engine-zd30",
          "systems": [
            "exhaust"
          ],
          "systemCounts": {
            "exhaust": 3
          },
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "RD28 2.8L Diesel",
          "family": "Nissan Exact Engine",
          "url": "/collections/all/bt-fit-route-nissan-patrol-gu-y61-rd28?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-patrol-gu-y61-rd28&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-nissan-patrol-gu-y61-rd28",
          "engineTag": "bt-fit-engine-rd28",
          "systems": [
            "exhaust"
          ],
          "systemCounts": {
            "exhaust": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "Y62": [
        {
          "label": "VK56VD 5.6L V8",
          "family": "Nissan Patrol Y62",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-nissan-patrol-y62-vk56vd-5-6l-v8",
          "systems": [
            "turbo-forced-induction",
            "fuel-system",
            "intake",
            "exhaust",
            "transmission-driveline"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "fuel-system": 1,
            "intake": 2,
            "exhaust": 1,
            "transmission-driveline": 1
          },
          "url": "/collections/all/bt-fit-route-nissan-patrol-y62-vk56vd-5-6l-v8?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-patrol-y62-vk56vd-5-6l-v8&sort_by=price-ascending",
          "productCount": 6,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Navara": {
      "D21 / D22": [
        {
          "label": "D21 / D22",
          "family": "Nissan Navara D21/D22",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-nissan-navara-d21-d22-d21-d22",
          "systems": [
            "exhaust",
            "transmission-driveline"
          ],
          "systemCounts": {
            "exhaust": 2,
            "transmission-driveline": 4
          },
          "url": "/collections/all/bt-fit-route-nissan-navara-d21-d22-d21-d22?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-navara-d21-d22-d21-d22&sort_by=price-ascending",
          "productCount": 6,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "D40": [
        {
          "label": "D40",
          "family": "Nissan Navara D40",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-nissan-navara-d40-d40",
          "systems": [
            "exhaust",
            "transmission-driveline"
          ],
          "systemCounts": {
            "exhaust": 7,
            "transmission-driveline": 3
          },
          "url": "/collections/all/bt-fit-route-nissan-navara-d40-d40?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-navara-d40-d40&sort_by=price-ascending",
          "productCount": 10,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "YD25 2.5L Diesel",
          "family": "Nissan Exact Engine",
          "url": "/collections/all/bt-fit-route-nissan-navara-d40-yd25?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-navara-d40-yd25&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-nissan-navara-d40-yd25",
          "engineTag": "bt-fit-engine-yd25",
          "systems": [
            "exhaust"
          ],
          "systemCounts": {
            "exhaust": 6
          },
          "productCount": 6,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "V9X 3.0L V6 Diesel",
          "family": "Nissan Exact Engine",
          "url": "/collections/all/bt-fit-route-nissan-navara-d40-v9x?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-navara-d40-v9x&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-nissan-navara-d40-v9x",
          "engineTag": "bt-fit-engine-v9x",
          "systems": [
            "exhaust"
          ],
          "systemCounts": {
            "exhaust": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "D23 / NP300": [
        {
          "label": "D23 / NP300",
          "family": "Nissan Navara D23 / NP300",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-nissan-navara-d23-np300-d23-np300",
          "systems": [
            "exhaust",
            "transmission-driveline"
          ],
          "systemCounts": {
            "exhaust": 1,
            "transmission-driveline": 2
          },
          "url": "/collections/all/bt-fit-route-nissan-navara-d23-np300-d23-np300?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-navara-d23-np300-d23-np300&sort_by=price-ascending",
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "YS23 2.3L Diesel",
          "family": "Nissan Exact Engine",
          "url": "/collections/all/bt-fit-route-nissan-navara-d23-ys23?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-navara-d23-ys23&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-nissan-navara-d23-ys23",
          "engineTag": "bt-fit-engine-ys23",
          "systems": [
            "exhaust"
          ],
          "systemCounts": {
            "exhaust": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "D22": [
        {
          "label": "ZD30 3.0L Diesel",
          "family": "Nissan Exact Engine",
          "url": "/collections/all/bt-fit-route-nissan-navara-d22-zd30?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-navara-d22-zd30&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-nissan-navara-d22-zd30",
          "engineTag": "bt-fit-engine-zd30",
          "systems": [
            "exhaust"
          ],
          "systemCounts": {
            "exhaust": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "YD25 2.5L Diesel",
          "family": "Nissan Exact Engine",
          "url": "/collections/all/bt-fit-route-nissan-navara-d22-yd25?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-navara-d22-yd25&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-nissan-navara-d22-yd25",
          "engineTag": "bt-fit-engine-yd25",
          "systems": [
            "exhaust"
          ],
          "systemCounts": {
            "exhaust": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Pathfinder": {
      "R51": [
        {
          "label": "R51",
          "family": "Nissan Pathfinder R51",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-nissan-pathfinder-r51-r51",
          "systems": [
            "exhaust",
            "transmission-driveline"
          ],
          "systemCounts": {
            "exhaust": 5,
            "transmission-driveline": 4
          },
          "url": "/collections/all/bt-fit-route-nissan-pathfinder-r51-r51?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-pathfinder-r51-r51&sort_by=price-ascending",
          "productCount": 9,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "YD25 2.5L Diesel",
          "family": "Nissan Exact Engine",
          "url": "/collections/all/bt-fit-route-nissan-pathfinder-r51-yd25?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-pathfinder-r51-yd25&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-nissan-pathfinder-r51-yd25",
          "engineTag": "bt-fit-engine-yd25",
          "systems": [
            "exhaust"
          ],
          "systemCounts": {
            "exhaust": 4
          },
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "V9X 3.0L V6 Diesel",
          "family": "Nissan Exact Engine",
          "url": "/collections/all/bt-fit-route-nissan-pathfinder-r51-v9x?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-pathfinder-r51-v9x&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-nissan-pathfinder-r51-v9x",
          "engineTag": "bt-fit-engine-v9x",
          "systems": [
            "exhaust"
          ],
          "systemCounts": {
            "exhaust": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "R50": [
        {
          "label": "H233B front differential applications",
          "family": "Nissan Pathfinder R50",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-nissan-pathfinder-r50-1995-2005",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 1
          },
          "url": "/collections/all/bt-fit-route-nissan-pathfinder-r50-1995-2005?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-pathfinder-r50-1995-2005&sort_by=price-ascending",
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "350Z": {
      "Z33": [
        {
          "label": "Z33",
          "family": "Nissan 350Z Z33",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-nissan-350z-z33-z33",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "engine-parts",
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 2,
            "wiring-sensors-displays": 1,
            "engine-parts": 2,
            "clutch": 4,
            "transmission-driveline": 4,
            "suspension-brakes": 10
          },
          "url": "/collections/all/bt-fit-route-nissan-350z-z33-z33?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-350z-z33-z33&sort_by=price-ascending",
          "productCount": 18,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "370Z": {
      "Z34": [
        {
          "label": "Z34",
          "family": "Nissan 370Z Z34",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-nissan-370z-z34-z34",
          "systems": [
            "intake",
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "intake": 1,
            "clutch": 3,
            "transmission-driveline": 3,
            "suspension-brakes": 8
          },
          "url": "/collections/all/bt-fit-route-nissan-370z-z34-z34?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-370z-z34-z34&sort_by=price-ascending",
          "productCount": 12,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Z": {
      "RZ34": [
        {
          "label": "RZ34",
          "family": "Nissan Z RZ34",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-nissan-z-rz34-rz34",
          "systems": [
            "turbo-forced-induction",
            "intake",
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "intake": 1,
            "clutch": 1,
            "transmission-driveline": 1
          },
          "url": "/collections/all/bt-fit-route-nissan-z-rz34-rz34?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-z-rz34-rz34&sort_by=price-ascending",
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Pulsar": {
      "GTI-R / RNN14": [
        {
          "label": "SR20DET",
          "family": "Nissan Pulsar GTI-R",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-nissan-pulsar-gti-r-rnn14-sr20det",
          "systems": [
            "turbo-forced-induction",
            "exhaust",
            "engine-parts",
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2,
            "exhaust": 1,
            "engine-parts": 2,
            "clutch": 1,
            "transmission-driveline": 1,
            "suspension-brakes": 20
          },
          "url": "/collections/all/bt-fit-route-nissan-pulsar-gti-r-rnn14-sr20det?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-pulsar-gti-r-rnn14-sr20det&sort_by=price-ascending",
          "productCount": 25,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "SSS B17": [
        {
          "label": "B17",
          "family": "Nissan Pulsar SSS B17",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-nissan-pulsar-sss-b17-b17",
          "systems": [
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "clutch": 1,
            "transmission-driveline": 1
          },
          "url": "/collections/all/bt-fit-route-nissan-pulsar-sss-b17-b17?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-pulsar-sss-b17-b17&sort_by=price-ascending",
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "300ZX": {
      "Z32": [
        {
          "label": "Z32",
          "family": "Nissan 300ZX Z32",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-nissan-300zx-z32",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "engine-parts"
          ],
          "systemCounts": {
            "engine-management": 2,
            "wiring-sensors-displays": 4,
            "engine-parts": 1
          },
          "url": "/collections/all/bt-fit-route-nissan-300zx-z32?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-300zx-z32&sort_by=price-ascending",
          "productCount": 5,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "GT-R": {
      "R35 (2007+)": [
        {
          "label": "VR38DETT 3.8L Twin-Turbo V6",
          "family": "Nissan GT-R R35",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-nissan-gt-r-r35-vr38dett",
          "systems": [
            "turbo-forced-induction",
            "fuel-system",
            "engine-parts",
            "ignition"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2,
            "fuel-system": 4,
            "engine-parts": 3,
            "ignition": 1
          },
          "url": "/collections/all/bt-fit-route-nissan-gt-r-r35-vr38dett?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-gt-r-r35-vr38dett&sort_by=price-ascending",
          "productCount": 10,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Engine Family / Custom": {
      "FJ20": [
        {
          "label": "FJ20",
          "family": "Nissan Engine Family",
          "url": "/collections/all/bt-fit-route-nissan-engine-family-fj20?bbt_vehicle=1&bbt_route=bt-fit-route-nissan-engine-family-fj20&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-nissan-engine-family-fj20",
          "engineTag": "bt-fit-engine-fj20",
          "systems": [
            "turbo-forced-induction",
            "exhaust"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "exhaust": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "Toyota": {
    "Corolla Levin / Sprinter Trueno": {
      "AE86": [
        {
          "label": "4A-GE 16V",
          "family": "Toyota 4A-GE",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-corolla-levin-sprinter-trueno-ae86-4age",
          "engineTag": "bt-fit-engine-4age",
          "systems": [
            "turbo-forced-induction",
            "intake",
            "exhaust",
            "engine-parts",
            "suspension-brakes"
          ],
          "systemCounts": {
            "turbo-forced-induction": 6,
            "intake": 1,
            "exhaust": 1,
            "engine-parts": 3,
            "suspension-brakes": 1
          },
          "url": "/collections/all/bt-fit-route-toyota-corolla-levin-sprinter-trueno-ae86-4age?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-corolla-levin-sprinter-trueno-ae86-4age&sort_by=price-ascending",
          "productCount": 11,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "86": {
      "ZN6 / first generation": [
        {
          "label": "FA20",
          "family": "Toyota 86 ZN6",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-86-zn6-first-generation-fa20",
          "systems": [
            "turbo-forced-induction",
            "fuel-system",
            "intake",
            "engine-parts",
            "clutch",
            "transmission-driveline",
            "cooling",
            "suspension-brakes"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "fuel-system": 2,
            "intake": 1,
            "engine-parts": 1,
            "clutch": 5,
            "transmission-driveline": 6,
            "cooling": 2,
            "suspension-brakes": 21
          },
          "url": "/collections/all/bt-fit-route-toyota-86-zn6-first-generation-fa20?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-86-zn6-first-generation-fa20&sort_by=price-ascending",
          "productCount": 34,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Supra": {
      "JZA80": [
        {
          "label": "2JZ-GE",
          "family": "Toyota JZ",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-2jz-ge",
          "routeTag": "bt-fit-route-toyota-supra-jza80-2jz-ge",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 2,
            "wiring-sensors-displays": 5,
            "turbo-forced-induction": 7,
            "intercooler": 1,
            "fuel-system": 3,
            "intake": 4,
            "exhaust": 4,
            "engine-parts": 10,
            "ignition": 3,
            "clutch": 1,
            "transmission-driveline": 2,
            "suspension-brakes": 1
          },
          "url": "/collections/all/bt-fit-route-toyota-supra-jza80-2jz-ge?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-supra-jza80-2jz-ge&sort_by=price-ascending",
          "productCount": 30,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "2JZ-GTE",
          "family": "Toyota JZ",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-2jz-gte",
          "routeTag": "bt-fit-route-toyota-supra-jza80-2jz-gte",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 4,
            "wiring-sensors-displays": 6,
            "turbo-forced-induction": 7,
            "intercooler": 4,
            "fuel-system": 4,
            "intake": 5,
            "exhaust": 4,
            "engine-parts": 15,
            "ignition": 3,
            "clutch": 1,
            "transmission-driveline": 2,
            "suspension-brakes": 1
          },
          "url": "/collections/all/bt-fit-route-toyota-supra-jza80-2jz-gte?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-supra-jza80-2jz-gte&sort_by=price-ascending",
          "productCount": 42,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "2JZ",
          "family": "Toyota JZ",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-2jz",
          "routeTag": "bt-fit-route-toyota-supra-jza80-2jz",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 2,
            "wiring-sensors-displays": 6,
            "turbo-forced-induction": 8,
            "intercooler": 1,
            "fuel-system": 5,
            "intake": 5,
            "exhaust": 5,
            "engine-parts": 14,
            "ignition": 3,
            "clutch": 1,
            "transmission-driveline": 2,
            "suspension-brakes": 1
          },
          "url": "/collections/all/bt-fit-route-toyota-supra-jza80-2jz?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-supra-jza80-2jz&sort_by=price-ascending",
          "productCount": 37,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "A90 / A91": [
        {
          "label": "B58",
          "family": "BMW / Toyota B58",
          "url": "/collections/all/bt-fit-route-toyota-supra-a90-a91-b58?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-supra-a90-a91-b58&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-supra-a90-a91-b58",
          "engineTag": "bt-fit-engine-b58",
          "systems": [
            "turbo-forced-induction",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "suspension-brakes"
          ],
          "systemCounts": {
            "turbo-forced-induction": 4,
            "fuel-system": 1,
            "intake": 2,
            "exhaust": 2,
            "engine-parts": 3,
            "suspension-brakes": 1
          },
          "productCount": 10,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "Chassis fitment (suspension / coding)",
          "family": "Toyota Supra A90/A91",
          "url": "/collections/all/bt-fit-route-toyota-supra-a90-a91-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-supra-a90-a91-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-supra-a90-a91-chassis",
          "engineTag": "bt-fit-chassis-a90-a91",
          "systems": [
            "engine-management",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 1,
            "suspension-brakes": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Chaser / Mark II": {
      "JZX90": [
        {
          "label": "1JZ-GTE Non-VVTi",
          "family": "Toyota JZ",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-1jz-gte-non-vvti",
          "routeTag": "bt-fit-route-toyota-chaser-mark-ii-jzx90-1jz-gte-non-vvti",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 4,
            "wiring-sensors-displays": 5,
            "turbo-forced-induction": 5,
            "fuel-system": 2,
            "intake": 1,
            "exhaust": 2,
            "engine-parts": 9,
            "ignition": 2,
            "transmission-driveline": 1,
            "suspension-brakes": 1
          },
          "url": "/collections/all/bt-fit-route-toyota-chaser-mark-ii-jzx90-1jz-gte-non-vvti?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-chaser-mark-ii-jzx90-1jz-gte-non-vvti&sort_by=price-ascending",
          "productCount": 24,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "1JZ",
          "family": "Toyota JZ",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-1jz",
          "routeTag": "bt-fit-route-toyota-chaser-mark-ii-jzx90-1jz",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 2,
            "wiring-sensors-displays": 4,
            "turbo-forced-induction": 5,
            "fuel-system": 3,
            "intake": 2,
            "exhaust": 2,
            "engine-parts": 9,
            "ignition": 2,
            "clutch": 2,
            "transmission-driveline": 3,
            "suspension-brakes": 1
          },
          "url": "/collections/all/bt-fit-route-toyota-chaser-mark-ii-jzx90-1jz?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-chaser-mark-ii-jzx90-1jz&sort_by=price-ascending",
          "productCount": 24,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "JZX100": [
        {
          "label": "1JZ-GTE VVTi",
          "family": "Toyota JZ",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-1jz-gte-vvti",
          "routeTag": "bt-fit-route-toyota-chaser-mark-ii-jzx100-1jz-gte-vvti",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 4,
            "wiring-sensors-displays": 6,
            "turbo-forced-induction": 5,
            "fuel-system": 2,
            "intake": 1,
            "exhaust": 2,
            "engine-parts": 9,
            "ignition": 2,
            "transmission-driveline": 1,
            "suspension-brakes": 1
          },
          "url": "/collections/all/bt-fit-route-toyota-chaser-mark-ii-jzx100-1jz-gte-vvti?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-chaser-mark-ii-jzx100-1jz-gte-vvti&sort_by=price-ascending",
          "productCount": 25,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "1JZ",
          "family": "Toyota JZ",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-1jz",
          "routeTag": "bt-fit-route-toyota-chaser-mark-ii-jzx100-1jz",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 2,
            "wiring-sensors-displays": 5,
            "turbo-forced-induction": 5,
            "fuel-system": 3,
            "intake": 2,
            "exhaust": 2,
            "engine-parts": 9,
            "ignition": 2,
            "clutch": 2,
            "transmission-driveline": 3,
            "suspension-brakes": 1
          },
          "url": "/collections/all/bt-fit-route-toyota-chaser-mark-ii-jzx100-1jz?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-chaser-mark-ii-jzx100-1jz&sort_by=price-ascending",
          "productCount": 25,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "JZX110": [
        {
          "label": "1JZ-GTE VVTi",
          "family": "Toyota JZ",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-1jz-gte-vvti",
          "routeTag": "bt-fit-route-toyota-chaser-mark-ii-jzx110-1jz-gte-vvti",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 4,
            "wiring-sensors-displays": 5,
            "turbo-forced-induction": 5,
            "fuel-system": 2,
            "intake": 1,
            "exhaust": 2,
            "engine-parts": 9,
            "ignition": 2,
            "transmission-driveline": 1,
            "suspension-brakes": 1
          },
          "url": "/collections/all/bt-fit-route-toyota-chaser-mark-ii-jzx110-1jz-gte-vvti?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-chaser-mark-ii-jzx110-1jz-gte-vvti&sort_by=price-ascending",
          "productCount": 24,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "1JZ",
          "family": "Toyota JZ",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-1jz",
          "routeTag": "bt-fit-route-toyota-chaser-mark-ii-jzx110-1jz",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 2,
            "wiring-sensors-displays": 4,
            "turbo-forced-induction": 5,
            "fuel-system": 3,
            "intake": 2,
            "exhaust": 2,
            "engine-parts": 9,
            "ignition": 2,
            "clutch": 2,
            "transmission-driveline": 3,
            "suspension-brakes": 1
          },
          "url": "/collections/all/bt-fit-route-toyota-chaser-mark-ii-jzx110-1jz?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-chaser-mark-ii-jzx110-1jz&sort_by=price-ascending",
          "productCount": 24,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Soarer": {
      "JZZ30": [
        {
          "label": "1JZ-GTE Non-VVTi",
          "family": "Toyota JZ",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-1jz-gte-non-vvti",
          "routeTag": "bt-fit-route-toyota-soarer-jzz30-1jz-gte-non-vvti",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 4,
            "wiring-sensors-displays": 6,
            "turbo-forced-induction": 5,
            "intercooler": 3,
            "fuel-system": 2,
            "intake": 1,
            "exhaust": 2,
            "engine-parts": 9,
            "ignition": 2,
            "transmission-driveline": 1,
            "suspension-brakes": 1
          },
          "url": "/collections/all/bt-fit-route-toyota-soarer-jzz30-1jz-gte-non-vvti?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-soarer-jzz30-1jz-gte-non-vvti&sort_by=price-ascending",
          "productCount": 28,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "1JZ-GTE VVTi",
          "family": "Toyota JZ",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-1jz-gte-vvti",
          "routeTag": "bt-fit-route-toyota-soarer-jzz30-1jz-gte-vvti",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 4,
            "wiring-sensors-displays": 6,
            "turbo-forced-induction": 5,
            "fuel-system": 2,
            "intake": 1,
            "exhaust": 2,
            "engine-parts": 9,
            "ignition": 2,
            "transmission-driveline": 1,
            "suspension-brakes": 1
          },
          "url": "/collections/all/bt-fit-route-toyota-soarer-jzz30-1jz-gte-vvti?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-soarer-jzz30-1jz-gte-vvti&sort_by=price-ascending",
          "productCount": 25,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "1JZ",
          "family": "Toyota JZ",
          "routeType": "precision-route-tag",
          "engineTag": "bt-fit-engine-1jz",
          "routeTag": "bt-fit-route-toyota-soarer-jzz30-1jz",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 2,
            "wiring-sensors-displays": 5,
            "turbo-forced-induction": 5,
            "fuel-system": 3,
            "intake": 2,
            "exhaust": 2,
            "engine-parts": 9,
            "ignition": 2,
            "clutch": 2,
            "transmission-driveline": 3,
            "suspension-brakes": 1
          },
          "url": "/collections/all/bt-fit-route-toyota-soarer-jzz30-1jz?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-soarer-jzz30-1jz&sort_by=price-ascending",
          "productCount": 25,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "GR86": {
      "ZN8 / second generation": [
        {
          "label": "FA24",
          "family": "Toyota GR86 ZN8",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-gr86-zn8-second-generation-fa24",
          "systems": [
            "turbo-forced-induction",
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "clutch": 1,
            "transmission-driveline": 1,
            "suspension-brakes": 3
          },
          "url": "/collections/all/bt-fit-route-toyota-gr86-zn8-second-generation-fa24?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-gr86-zn8-second-generation-fa24&sort_by=price-ascending",
          "productCount": 5,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "GR Yaris": {
      "GXPA16": [
        {
          "label": "G16E-GTS",
          "family": "Toyota GR Yaris",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-gr-yaris-gxpa16-g16e-gts",
          "systems": [
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "clutch": 1,
            "transmission-driveline": 1
          },
          "url": "/collections/all/bt-fit-route-toyota-gr-yaris-gxpa16-g16e-gts?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-gr-yaris-gxpa16-g16e-gts&sort_by=price-ascending",
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "GR Corolla": {
      "GZEA14": [
        {
          "label": "G16E-GTS",
          "family": "Toyota GR Corolla",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-gr-corolla-gzea14-g16e-gts",
          "systems": [
            "intake",
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "intake": 1,
            "clutch": 1,
            "transmission-driveline": 1
          },
          "url": "/collections/all/bt-fit-route-toyota-gr-corolla-gzea14-g16e-gts?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-gr-corolla-gzea14-g16e-gts&sort_by=price-ascending",
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Hilux": {
      "N70 / N80 / current": [
        {
          "label": "Hilux",
          "family": "Toyota Hilux",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-hilux-n70-n80-current-hilux",
          "systems": [
            "intake",
            "exhaust",
            "transmission-driveline"
          ],
          "systemCounts": {
            "intake": 1,
            "exhaust": 2,
            "transmission-driveline": 7
          },
          "url": "/collections/all/bt-fit-route-toyota-hilux-n70-n80-current-hilux?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-hilux-n70-n80-current-hilux&sort_by=price-ascending",
          "productCount": 10,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "N70": [
        {
          "label": "1KD-FTV 3.0L Diesel",
          "family": "Toyota Exact Engine",
          "url": "/collections/all/bt-fit-route-toyota-hilux-n70-1kd-ftv?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-hilux-n70-1kd-ftv&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-hilux-n70-1kd-ftv",
          "engineTag": "bt-fit-engine-1kd-ftv",
          "systems": [
            "exhaust"
          ],
          "systemCounts": {
            "exhaust": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "N80": [
        {
          "label": "1GD-FTV 2.8L Diesel",
          "family": "Toyota Exact Engine",
          "url": "/collections/all/bt-fit-route-toyota-hilux-n80-1gd-ftv?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-hilux-n80-1gd-ftv&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-hilux-n80-1gd-ftv",
          "engineTag": "bt-fit-engine-1gd-ftv",
          "systems": [
            "exhaust"
          ],
          "systemCounts": {
            "exhaust": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Fortuner": {
      "AN160": [
        {
          "label": "2.8L",
          "family": "Toyota Fortuner",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-fortuner-an160-2-8l",
          "systems": [
            "intake",
            "exhaust",
            "transmission-driveline"
          ],
          "systemCounts": {
            "intake": 1,
            "exhaust": 1,
            "transmission-driveline": 1
          },
          "url": "/collections/all/bt-fit-route-toyota-fortuner-an160-2-8l?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-fortuner-an160-2-8l&sort_by=price-ascending",
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "1GD-FTV 2.8L Diesel",
          "family": "Toyota Exact Engine",
          "url": "/collections/all/bt-fit-route-toyota-fortuner-an160-1gd-ftv?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-fortuner-an160-1gd-ftv&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-fortuner-an160-1gd-ftv",
          "engineTag": "bt-fit-engine-1gd-ftv",
          "systems": [
            "exhaust"
          ],
          "systemCounts": {
            "exhaust": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "LandCruiser": {
      "70 Series": [
        {
          "label": "70 Series",
          "family": "Toyota LandCruiser 70",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-landcruiser-70-series-70-series",
          "systems": [
            "exhaust",
            "transmission-driveline"
          ],
          "systemCounts": {
            "exhaust": 19,
            "transmission-driveline": 2
          },
          "url": "/collections/all/bt-fit-route-toyota-landcruiser-70-series-70-series?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-landcruiser-70-series-70-series&sort_by=price-ascending",
          "productCount": 21,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "1VD-FTV 4.5L V8 Diesel",
          "family": "Toyota Exact Engine",
          "url": "/collections/all/bt-fit-route-toyota-landcruiser-70-1vd-ftv?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-landcruiser-70-1vd-ftv&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-landcruiser-70-1vd-ftv",
          "engineTag": "bt-fit-engine-1vd-ftv",
          "systems": [
            "exhaust"
          ],
          "systemCounts": {
            "exhaust": 7
          },
          "productCount": 7,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "1HZ 4.2L Diesel",
          "family": "Toyota Exact Engine",
          "url": "/collections/all/bt-fit-route-toyota-landcruiser-70-1hz?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-landcruiser-70-1hz&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-landcruiser-70-1hz",
          "engineTag": "bt-fit-engine-1hz",
          "systems": [
            "exhaust"
          ],
          "systemCounts": {
            "exhaust": 4
          },
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "1HD 4.2L Turbo Diesel",
          "family": "Toyota Exact Engine",
          "url": "/collections/all/bt-fit-route-toyota-landcruiser-70-1hd?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-landcruiser-70-1hd&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-landcruiser-70-1hd",
          "engineTag": "bt-fit-engine-1hd",
          "systems": [
            "exhaust"
          ],
          "systemCounts": {
            "exhaust": 2
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "1FZ-FE 4.5L Petrol",
          "family": "Toyota Exact Engine",
          "url": "/collections/all/bt-fit-route-toyota-landcruiser-70-1fz-fe?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-landcruiser-70-1fz-fe&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-landcruiser-70-1fz-fe",
          "engineTag": "bt-fit-engine-1fz-fe",
          "systems": [
            "exhaust",
            "engine-parts"
          ],
          "systemCounts": {
            "exhaust": 2,
            "engine-parts": 3
          },
          "productCount": 5,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "2H 4.0L Diesel",
          "family": "Toyota Exact Engine",
          "url": "/collections/all/bt-fit-route-toyota-landcruiser-70-2h?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-landcruiser-70-2h&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-landcruiser-70-2h",
          "engineTag": "bt-fit-engine-2h",
          "systems": [
            "exhaust"
          ],
          "systemCounts": {
            "exhaust": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "3F 4.0L Petrol",
          "family": "Toyota Exact Engine",
          "url": "/collections/all/bt-fit-route-toyota-landcruiser-70-3f?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-landcruiser-70-3f&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-landcruiser-70-3f",
          "engineTag": "bt-fit-engine-3f",
          "systems": [
            "exhaust"
          ],
          "systemCounts": {
            "exhaust": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "1GD-FTV 2.8L Diesel",
          "family": "Toyota Exact Engine",
          "url": "/collections/all/bt-fit-route-toyota-landcruiser-70-1gd-ftv?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-landcruiser-70-1gd-ftv&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-landcruiser-70-1gd-ftv",
          "engineTag": "bt-fit-engine-1gd-ftv",
          "systems": [
            "exhaust"
          ],
          "systemCounts": {
            "exhaust": 2
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "100 Series": [
        {
          "label": "100 Series",
          "family": "Toyota LandCruiser 100",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-landcruiser-100-series-100-series",
          "systems": [
            "exhaust",
            "transmission-driveline"
          ],
          "systemCounts": {
            "exhaust": 4,
            "transmission-driveline": 2
          },
          "url": "/collections/all/bt-fit-route-toyota-landcruiser-100-series-100-series?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-landcruiser-100-series-100-series&sort_by=price-ascending",
          "productCount": 6,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "1HD 4.2L Turbo Diesel",
          "family": "Toyota Exact Engine",
          "url": "/collections/all/bt-fit-route-toyota-landcruiser-100-1hd?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-landcruiser-100-1hd&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-landcruiser-100-1hd",
          "engineTag": "bt-fit-engine-1hd",
          "systems": [
            "exhaust"
          ],
          "systemCounts": {
            "exhaust": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "1HZ 4.2L Diesel",
          "family": "Toyota Exact Engine",
          "url": "/collections/all/bt-fit-route-toyota-landcruiser-100-1hz?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-landcruiser-100-1hz&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-landcruiser-100-1hz",
          "engineTag": "bt-fit-engine-1hz",
          "systems": [
            "exhaust"
          ],
          "systemCounts": {
            "exhaust": 2
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "1FZ-FE 4.5L Petrol",
          "family": "Toyota Exact Engine",
          "url": "/collections/all/bt-fit-route-toyota-landcruiser-100-1fz-fe?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-landcruiser-100-1fz-fe&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-landcruiser-100-1fz-fe",
          "engineTag": "bt-fit-engine-1fz-fe",
          "systems": [
            "exhaust",
            "engine-parts"
          ],
          "systemCounts": {
            "exhaust": 1,
            "engine-parts": 3
          },
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "200 Series": [
        {
          "label": "200 Series",
          "family": "Toyota LandCruiser 200",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-landcruiser-200-series-200-series",
          "systems": [
            "turbo-forced-induction",
            "fuel-system",
            "intake",
            "exhaust",
            "transmission-driveline"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "fuel-system": 1,
            "intake": 1,
            "exhaust": 3,
            "transmission-driveline": 1
          },
          "url": "/collections/all/bt-fit-route-toyota-landcruiser-200-series-200-series?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-landcruiser-200-series-200-series&sort_by=price-ascending",
          "productCount": 7,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "1VD-FTV 4.5L V8 Diesel",
          "family": "Toyota Exact Engine",
          "url": "/collections/all/bt-fit-route-toyota-landcruiser-200-1vd-ftv?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-landcruiser-200-1vd-ftv&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-landcruiser-200-1vd-ftv",
          "engineTag": "bt-fit-engine-1vd-ftv",
          "systems": [
            "exhaust"
          ],
          "systemCounts": {
            "exhaust": 2
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "2UZ-FE 4.7L V8 Petrol",
          "family": "Toyota Exact Engine",
          "url": "/collections/all/bt-fit-route-toyota-landcruiser-200-2uz-fe?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-landcruiser-200-2uz-fe&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-landcruiser-200-2uz-fe",
          "engineTag": "bt-fit-engine-2uz-fe",
          "systems": [
            "exhaust"
          ],
          "systemCounts": {
            "exhaust": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "300 Series": [
        {
          "label": "300 Series",
          "family": "Toyota LandCruiser 300",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-landcruiser-300-series-300-series",
          "systems": [
            "exhaust",
            "transmission-driveline"
          ],
          "systemCounts": {
            "exhaust": 1,
            "transmission-driveline": 2
          },
          "url": "/collections/all/bt-fit-route-toyota-landcruiser-300-series-300-series?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-landcruiser-300-series-300-series&sort_by=price-ascending",
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "F33A-FTV 3.3L V6 Diesel",
          "family": "Toyota Exact Engine",
          "url": "/collections/all/bt-fit-route-toyota-landcruiser-300-f33a-ftv?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-landcruiser-300-f33a-ftv&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-landcruiser-300-f33a-ftv",
          "engineTag": "bt-fit-engine-f33a-ftv",
          "systems": [
            "exhaust"
          ],
          "systemCounts": {
            "exhaust": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "80 Series": [
        {
          "label": "1FZ-FE",
          "family": "Toyota LandCruiser 80",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-landcruiser-80-series-1fz-fe",
          "systems": [
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "exhaust",
            "engine-parts",
            "transmission-driveline"
          ],
          "systemCounts": {
            "wiring-sensors-displays": 2,
            "turbo-forced-induction": 1,
            "exhaust": 5,
            "engine-parts": 11,
            "transmission-driveline": 1
          },
          "url": "/collections/all/bt-fit-route-toyota-landcruiser-80-series-1fz-fe?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-landcruiser-80-series-1fz-fe&sort_by=price-ascending",
          "productCount": 19,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "1HZ 4.2L Diesel",
          "family": "Toyota Exact Engine",
          "url": "/collections/all/bt-fit-route-toyota-landcruiser-80-1hz?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-landcruiser-80-1hz&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-landcruiser-80-1hz",
          "engineTag": "bt-fit-engine-1hz",
          "systems": [
            "exhaust"
          ],
          "systemCounts": {
            "exhaust": 2
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "1HD 4.2L Turbo Diesel",
          "family": "Toyota Exact Engine",
          "url": "/collections/all/bt-fit-route-toyota-landcruiser-80-1hd?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-landcruiser-80-1hd&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-landcruiser-80-1hd",
          "engineTag": "bt-fit-engine-1hd",
          "systems": [
            "exhaust"
          ],
          "systemCounts": {
            "exhaust": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Prado": {
      "150 Series": [
        {
          "label": "150 Series",
          "family": "Toyota Prado 150",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-prado-150-series-150-series",
          "systems": [
            "exhaust",
            "transmission-driveline"
          ],
          "systemCounts": {
            "exhaust": 2,
            "transmission-driveline": 3
          },
          "url": "/collections/all/bt-fit-route-toyota-prado-150-series-150-series?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-prado-150-series-150-series&sort_by=price-ascending",
          "productCount": 5,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "1GD-FTV 2.8L Diesel",
          "family": "Toyota Exact Engine",
          "url": "/collections/all/bt-fit-route-toyota-prado-150-1gd-ftv?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-prado-150-1gd-ftv&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-prado-150-1gd-ftv",
          "engineTag": "bt-fit-engine-1gd-ftv",
          "systems": [
            "exhaust"
          ],
          "systemCounts": {
            "exhaust": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "120 / 150 Series": [
        {
          "label": "1KD-FTV 3.0L Diesel",
          "family": "Toyota Exact Engine",
          "url": "/collections/all/bt-fit-route-toyota-prado-120-150-1kd-ftv?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-prado-120-150-1kd-ftv&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-prado-120-150-1kd-ftv",
          "engineTag": "bt-fit-engine-1kd-ftv",
          "systems": [
            "exhaust"
          ],
          "systemCounts": {
            "exhaust": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "FJ Cruiser": {
      "2010+": [
        {
          "label": "1GR-FE 4.0L Dual VVT-i",
          "family": "Toyota FJ Cruiser",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-fj-cruiser-1gr-fe",
          "systems": [
            "turbo-forced-induction",
            "intake",
            "exhaust",
            "engine-parts"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "intake": 1,
            "exhaust": 1,
            "engine-parts": 1
          },
          "url": "/collections/all/bt-fit-route-toyota-fj-cruiser-1gr-fe?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-fj-cruiser-1gr-fe&sort_by=price-ascending",
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "MR2": {
      "SW20": [
        {
          "label": "3S-GTE Turbo",
          "family": "Toyota MR2 SW20",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-mr2-sw20-3sgte",
          "systems": [
            "turbo-forced-induction",
            "exhaust",
            "engine-parts"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "exhaust": 1,
            "engine-parts": 3
          },
          "url": "/collections/all/bt-fit-route-toyota-mr2-sw20-3sgte?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-mr2-sw20-3sgte&sort_by=price-ascending",
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Celica GT-Four": {
      "ST205": [
        {
          "label": "3S-GTE Turbo",
          "family": "Toyota Celica GT-Four ST205",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-celica-st205-3sgte",
          "systems": [
            "turbo-forced-induction",
            "exhaust",
            "engine-parts"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "exhaust": 1,
            "engine-parts": 3
          },
          "url": "/collections/all/bt-fit-route-toyota-celica-st205-3sgte?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-celica-st205-3sgte&sort_by=price-ascending",
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Engine Family / Custom": {
      "3RZ-FE": [
        {
          "label": "3RZ-FE 2.7L",
          "family": "Toyota Engine Family",
          "url": "/collections/all/bt-fit-route-toyota-engine-family-3rz-fe?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-engine-family-3rz-fe&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-engine-family-3rz-fe",
          "engineTag": "bt-fit-engine-3rz-fe",
          "systems": [
            "turbo-forced-induction",
            "exhaust"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "exhaust": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "1G-GTE": [
        {
          "label": "1G-GTE",
          "family": "Toyota Engine Family",
          "url": "/collections/all/bt-fit-route-toyota-engine-family-1g-gte?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-engine-family-1g-gte&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-engine-family-1g-gte",
          "engineTag": "bt-fit-engine-1g-gte",
          "systems": [
            "turbo-forced-induction",
            "exhaust"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "exhaust": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "20R / 22R": [
        {
          "label": "20R / 22R SOHC",
          "family": "Toyota Engine Family",
          "url": "/collections/all/bt-fit-route-toyota-engine-family-20r-22r?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-engine-family-20r-22r&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-engine-family-20r-22r",
          "engineTag": "bt-fit-engine-20r-22r",
          "systems": [
            "engine-parts"
          ],
          "systemCounts": {
            "engine-parts": 2
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "2RZ OHC": [
        {
          "label": "2RZ OHC",
          "family": "Toyota Engine Family",
          "url": "/collections/all/bt-fit-route-toyota-engine-family-2rz-ohc?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-engine-family-2rz-ohc&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-engine-family-2rz-ohc",
          "engineTag": "bt-fit-engine-2rz",
          "systems": [
            "engine-parts"
          ],
          "systemCounts": {
            "engine-parts": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Tacoma": {
      "Rear shim-type differential": [
        {
          "label": "Rear shim-type differential",
          "family": "Toyota Harrop ELocker",
          "url": "/collections/all/bt-fit-route-toyota-tacoma-rear-shim-diff?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-tacoma-rear-shim-diff&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-tacoma-rear-shim-diff",
          "engineTag": "bt-fit-driveline-harrop-elocker",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Tundra": {
      "1993–2006 rear": [
        {
          "label": "Rear shim-type differential",
          "family": "Toyota Harrop ELocker",
          "url": "/collections/all/bt-fit-route-toyota-tundra-1993-2006-rear-shim-diff?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-tundra-1993-2006-rear-shim-diff&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-tundra-1993-2006-rear-shim-diff",
          "engineTag": "bt-fit-driveline-harrop-elocker",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "V6 Turbo": [
        {
          "label": "Kompact EM VR20 direct-fit",
          "family": "Toyota Tundra",
          "url": "/collections/all/bt-fit-route-toyota-tundra-v6-turbosmart-em?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-tundra-v6-turbosmart-em&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-tundra-v6-turbosmart-em",
          "engineTag": "bt-fit-component-vr20",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Sequoia": {
      "1993–2006 rear": [
        {
          "label": "Rear shim-type differential",
          "family": "Toyota Harrop ELocker",
          "url": "/collections/all/bt-fit-route-toyota-sequoia-1993-2006-rear-shim-diff?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-sequoia-1993-2006-rear-shim-diff&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-sequoia-1993-2006-rear-shim-diff",
          "engineTag": "bt-fit-driveline-harrop-elocker",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "T100": {
      "1993–2006 rear": [
        {
          "label": "Rear shim-type differential",
          "family": "Toyota Harrop ELocker",
          "url": "/collections/all/bt-fit-route-toyota-t100-1993-2006-rear-shim-diff?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-t100-1993-2006-rear-shim-diff&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-t100-1993-2006-rear-shim-diff",
          "engineTag": "bt-fit-driveline-harrop-elocker",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Component Family / Custom": {
      "Kompact EM VR17": [
        {
          "label": "Kompact EM",
          "family": "Turbosmart Component Family",
          "url": "/collections/all/bt-fit-route-toyota-kompact-em-vr17?bbt_vehicle=1&bbt_route=bt-fit-route-toyota-kompact-em-vr17&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-toyota-kompact-em-vr17",
          "engineTag": "bt-fit-component-toyota-kompact-em-vr17",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "Subaru": {
    "BRZ": {
      "ZC6 / first generation": [
        {
          "label": "FA20 / BRZ",
          "family": "Subaru BRZ ZC6",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-subaru-brz-zc6-first-generation-fa20-brz",
          "systems": [
            "turbo-forced-induction",
            "fuel-system",
            "intake",
            "engine-parts",
            "clutch",
            "transmission-driveline",
            "cooling",
            "suspension-brakes"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "fuel-system": 2,
            "intake": 1,
            "engine-parts": 1,
            "clutch": 5,
            "transmission-driveline": 6,
            "cooling": 2,
            "suspension-brakes": 20
          },
          "url": "/collections/all/bt-fit-route-subaru-brz-zc6-first-generation-fa20-brz?bbt_vehicle=1&bbt_route=bt-fit-route-subaru-brz-zc6-first-generation-fa20-brz&sort_by=price-ascending",
          "productCount": 33,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "ZD8 / second generation": [
        {
          "label": "FA24 / BRZ ZD8",
          "family": "Subaru BRZ ZD8",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-subaru-brz-zd8-second-generation-fa24-brz-zd8",
          "systems": [
            "turbo-forced-induction",
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "clutch": 1,
            "transmission-driveline": 1,
            "suspension-brakes": 5
          },
          "url": "/collections/all/bt-fit-route-subaru-brz-zd8-second-generation-fa24-brz-zd8?bbt_vehicle=1&bbt_route=bt-fit-route-subaru-brz-zd8-second-generation-fa24-brz-zd8&sort_by=price-ascending",
          "productCount": 7,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Impreza WRX": {
      "MY93–96": [
        {
          "label": "WRX",
          "family": "Subaru WRX",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-subaru-impreza-wrx-my93-96",
          "systems": [
            "wiring-sensors-displays",
            "engine-parts"
          ],
          "systemCounts": {
            "wiring-sensors-displays": 1,
            "engine-parts": 1
          },
          "url": "/collections/all/bt-fit-route-subaru-impreza-wrx-my93-96?bbt_vehicle=1&bbt_route=bt-fit-route-subaru-impreza-wrx-my93-96&sort_by=price-ascending",
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "MY97–98": [
        {
          "label": "WRX",
          "family": "Subaru WRX",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-subaru-impreza-wrx-my97-98",
          "systems": [
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "engine-parts"
          ],
          "systemCounts": {
            "wiring-sensors-displays": 1,
            "turbo-forced-induction": 1,
            "engine-parts": 1
          },
          "url": "/collections/all/bt-fit-route-subaru-impreza-wrx-my97-98?bbt_vehicle=1&bbt_route=bt-fit-route-subaru-impreza-wrx-my97-98&sort_by=price-ascending",
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "MY99–00": [
        {
          "label": "WRX",
          "family": "Subaru WRX",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-subaru-impreza-wrx-my99-00",
          "systems": [
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "engine-parts"
          ],
          "systemCounts": {
            "wiring-sensors-displays": 1,
            "turbo-forced-induction": 2,
            "engine-parts": 1
          },
          "url": "/collections/all/bt-fit-route-subaru-impreza-wrx-my99-00?bbt_vehicle=1&bbt_route=bt-fit-route-subaru-impreza-wrx-my99-00&sort_by=price-ascending",
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "MY06–10": [
        {
          "label": "WRX",
          "family": "Subaru WRX",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-subaru-impreza-wrx-my06-10",
          "systems": [
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "fuel-system",
            "engine-parts"
          ],
          "systemCounts": {
            "wiring-sensors-displays": 1,
            "turbo-forced-induction": 1,
            "fuel-system": 1,
            "engine-parts": 2
          },
          "url": "/collections/all/bt-fit-route-subaru-impreza-wrx-my06-10?bbt_vehicle=1&bbt_route=bt-fit-route-subaru-impreza-wrx-my06-10&sort_by=price-ascending",
          "productCount": 5,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Impreza WRX STI": {
      "2008–2014": [
        {
          "label": "2.5L Turbo",
          "family": "Subaru WRX STI",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-subaru-impreza-wrx-sti-2008-2014",
          "systems": [
            "turbo-forced-induction",
            "fuel-system",
            "intake",
            "engine-parts"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "fuel-system": 1,
            "intake": 1,
            "engine-parts": 2
          },
          "url": "/collections/all/bt-fit-route-subaru-impreza-wrx-sti-2008-2014?bbt_vehicle=1&bbt_route=bt-fit-route-subaru-impreza-wrx-sti-2008-2014&sort_by=price-ascending",
          "productCount": 5,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "WRX STI": {
      "GDB Spec C": [
        {
          "label": "EJ207 / VF36-VF37",
          "family": "Subaru IWG",
          "url": "/collections/all/bt-fit-route-subaru-wrx-sti-gdb-spec-c-ej207-vf36-vf37?bbt_vehicle=1&bbt_route=bt-fit-route-subaru-wrx-sti-gdb-spec-c-ej207-vf36-vf37&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-subaru-wrx-sti-gdb-spec-c-ej207-vf36-vf37",
          "engineTag": "bt-fit-engine-ej207",
          "systems": [
            "turbo-forced-induction",
            "engine-parts"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "engine-parts": 1
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "WRX": {
      "VA / 2015+": [
        {
          "label": "FA20DIT 2.0L Turbo",
          "family": "Subaru WRX",
          "url": "/collections/all/bt-fit-route-subaru-wrx-va-2015-current-fa20dit?bbt_vehicle=1&bbt_route=bt-fit-route-subaru-wrx-va-2015-current-fa20dit&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-subaru-wrx-va-2015-current-fa20dit",
          "engineTag": "bt-fit-engine-fa20dit",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "VB / FA24F": [
        {
          "label": "2.4L Turbo",
          "family": "Subaru WRX",
          "url": "/collections/all/bt-fit-route-subaru-wrx-vb-fa24f?bbt_vehicle=1&bbt_route=bt-fit-route-subaru-wrx-vb-fa24f&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-subaru-wrx-vb-fa24f",
          "engineTag": "bt-fit-engine-fa24f",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "Lexus": {
    "IS200": {
      "XE10": [
        {
          "label": "IS200",
          "family": "Lexus IS200",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-lexus-is200-xe10-is200",
          "systems": [
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "clutch": 1,
            "transmission-driveline": 1
          },
          "url": "/collections/all/bt-fit-route-lexus-is200-xe10-is200?bbt_vehicle=1&bbt_route=bt-fit-route-lexus-is200-xe10-is200&sort_by=price-ascending",
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "IS250 / IS350": {
      "XE20": [
        {
          "label": "IS250 / IS350",
          "family": "Lexus IS250 / IS350",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-lexus-is250-is350-xe20-is250-is350",
          "systems": [
            "intake",
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "intake": 1,
            "clutch": 1,
            "transmission-driveline": 1
          },
          "url": "/collections/all/bt-fit-route-lexus-is250-is350-xe20-is250-is350?bbt_vehicle=1&bbt_route=bt-fit-route-lexus-is250-is350-xe20-is250-is350&sort_by=price-ascending",
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Component Family / Custom": {
      "Kompact EM VR17": [
        {
          "label": "Kompact EM",
          "family": "Turbosmart Component Family",
          "url": "/collections/all/bt-fit-route-lexus-kompact-em-vr17?bbt_vehicle=1&bbt_route=bt-fit-route-lexus-kompact-em-vr17&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-lexus-kompact-em-vr17",
          "engineTag": "bt-fit-component-lexus-kompact-em-vr17",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "Mitsubishi": {
    "Lancer Evolution": {
      "Evo 1–3": [
        {
          "label": "4G63",
          "family": "Mitsubishi 4G63",
          "url": "/collections/all/bt-fit-route-mitsubishi-lancer-evolution-evo-1-3-4g63?bbt_vehicle=1&bbt_route=bt-fit-route-mitsubishi-lancer-evolution-evo-1-3-4g63&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-mitsubishi-lancer-evolution-evo-1-3-4g63",
          "engineTag": "bt-fit-engine-4g63",
          "systems": [
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "wiring-sensors-displays": 1,
            "turbo-forced-induction": 3,
            "intercooler": 2,
            "fuel-system": 1,
            "intake": 2,
            "exhaust": 1,
            "engine-parts": 3,
            "clutch": 1,
            "transmission-driveline": 1,
            "suspension-brakes": 1
          },
          "productCount": 14,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "Evo 4–6": [
        {
          "label": "4G63",
          "family": "Mitsubishi 4G63",
          "url": "/collections/all/bt-fit-route-mitsubishi-lancer-evolution-evo-4-6-4g63?bbt_vehicle=1&bbt_route=bt-fit-route-mitsubishi-lancer-evolution-evo-4-6-4g63&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-mitsubishi-lancer-evolution-evo-4-6-4g63",
          "engineTag": "bt-fit-engine-4g63",
          "systems": [
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "turbo-forced-induction": 7,
            "intercooler": 6,
            "fuel-system": 3,
            "intake": 5,
            "exhaust": 3,
            "engine-parts": 2,
            "clutch": 1,
            "transmission-driveline": 1,
            "suspension-brakes": 1
          },
          "productCount": 23,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "Evo 7–9": [
        {
          "label": "4G63",
          "family": "Mitsubishi 4G63",
          "url": "/collections/all/bt-fit-route-mitsubishi-lancer-evolution-evo-7-9-4g63?bbt_vehicle=1&bbt_route=bt-fit-route-mitsubishi-lancer-evolution-evo-7-9-4g63&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-mitsubishi-lancer-evolution-evo-7-9-4g63",
          "engineTag": "bt-fit-engine-4g63",
          "systems": [
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "turbo-forced-induction": 7,
            "intercooler": 9,
            "fuel-system": 3,
            "intake": 6,
            "exhaust": 4,
            "engine-parts": 7,
            "clutch": 4,
            "transmission-driveline": 4,
            "suspension-brakes": 1
          },
          "productCount": 36,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "Evo X / 10": [
        {
          "label": "4B11T",
          "family": "Mitsubishi Evo X",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-mitsubishi-lancer-evolution-evo-x-10-4b11t",
          "systems": [
            "turbo-forced-induction",
            "fuel-system",
            "exhaust",
            "engine-parts"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2,
            "fuel-system": 1,
            "exhaust": 1,
            "engine-parts": 1
          },
          "url": "/collections/all/bt-fit-route-mitsubishi-lancer-evolution-evo-x-10-4b11t?bbt_vehicle=1&bbt_route=bt-fit-route-mitsubishi-lancer-evolution-evo-x-10-4b11t&sort_by=price-ascending",
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "Evo 7–8": [
        {
          "label": "4G63",
          "family": "Mitsubishi Evo",
          "url": "/collections/all/bt-fit-route-mitsubishi-lancer-evolution-evo-7-8-4g63?bbt_vehicle=1&bbt_route=bt-fit-route-mitsubishi-lancer-evolution-evo-7-8-4g63&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-mitsubishi-lancer-evolution-evo-7-8-4g63",
          "engineTag": "bt-fit-engine-4g63",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Lancer": {
      "2009–2014": [
        {
          "label": "2.0L / 2.4L",
          "family": "Mitsubishi Lancer",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-mitsubishi-lancer-2009-2014-20-24",
          "systems": [
            "intake"
          ],
          "systemCounts": {
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-mitsubishi-lancer-2009-2014-20-24?bbt_vehicle=1&bbt_route=bt-fit-route-mitsubishi-lancer-2009-2014-20-24&sort_by=price-ascending",
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Engine Family / Custom": {
      "4G54": [
        {
          "label": "4G54",
          "family": "Mitsubishi Engine Family",
          "url": "/collections/all/bt-fit-route-mitsubishi-engine-family-4g54?bbt_vehicle=1&bbt_route=bt-fit-route-mitsubishi-engine-family-4g54&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-mitsubishi-engine-family-4g54",
          "engineTag": "bt-fit-engine-4g54",
          "systems": [
            "engine-parts"
          ],
          "systemCounts": {
            "engine-parts": 3
          },
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Pajero": {
      "Harrop ELocker applications": [
        {
          "label": "Driveline / ELocker-compatible axle",
          "family": "Harrop ELocker",
          "url": "/collections/all/bt-fit-route-mitsubishi-pajero-harrop-driveline?bbt_vehicle=1&bbt_route=bt-fit-route-mitsubishi-pajero-harrop-driveline&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-mitsubishi-pajero-harrop-driveline",
          "engineTag": "bt-fit-driveline-harrop-elocker",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 4
          },
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Pajero Sport / Challenger": {
      "Harrop ELocker applications": [
        {
          "label": "Driveline / ELocker-compatible axle",
          "family": "Harrop ELocker",
          "url": "/collections/all/bt-fit-route-mitsubishi-pajero-sport-challenger-harrop-driveline?bbt_vehicle=1&bbt_route=bt-fit-route-mitsubishi-pajero-sport-challenger-harrop-driveline&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-mitsubishi-pajero-sport-challenger-harrop-driveline",
          "engineTag": "bt-fit-driveline-harrop-elocker",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 4
          },
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Triton": {
      "Harrop ELocker applications": [
        {
          "label": "Driveline / ELocker-compatible axle",
          "family": "Harrop ELocker",
          "url": "/collections/all/bt-fit-route-mitsubishi-triton-harrop-driveline?bbt_vehicle=1&bbt_route=bt-fit-route-mitsubishi-triton-harrop-driveline&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-mitsubishi-triton-harrop-driveline",
          "engineTag": "bt-fit-driveline-harrop-elocker",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 3
          },
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Delica": {
      "L300 / L400": [
        {
          "label": "Driveline / ELocker-compatible axle",
          "family": "Harrop ELocker",
          "url": "/collections/all/bt-fit-route-mitsubishi-delica-l300-l400-harrop-driveline?bbt_vehicle=1&bbt_route=bt-fit-route-mitsubishi-delica-l300-l400-harrop-driveline&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-mitsubishi-delica-l300-l400-harrop-driveline",
          "engineTag": "bt-fit-driveline-harrop-elocker",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 3
          },
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "BMW": {
    "M2": {
      "G87": [
        {
          "label": "S58",
          "family": "BMW S58",
          "url": "/collections/all/bt-fit-route-bmw-m2-g87-s58?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m2-g87-s58&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m2-g87-s58",
          "engineTag": "bt-fit-engine-s58",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "transmission-driveline",
            "cooling",
            "suspension-brakes",
            "service-maintenance"
          ],
          "systemCounts": {
            "engine-management": 4,
            "wiring-sensors-displays": 2,
            "turbo-forced-induction": 11,
            "intercooler": 2,
            "fuel-system": 12,
            "intake": 4,
            "exhaust": 8,
            "engine-parts": 16,
            "transmission-driveline": 2,
            "cooling": 1,
            "suspension-brakes": 34,
            "service-maintenance": 1
          },
          "productCount": 80,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW M2 G87",
          "url": "/collections/all/bt-fit-route-bmw-m2-g87-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m2-g87-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m2-g87-chassis",
          "systems": [
            "engine-management",
            "suspension-brakes",
            "exterior-aero"
          ],
          "systemCounts": {
            "engine-management": 1,
            "suspension-brakes": 42,
            "exterior-aero": 4
          },
          "productCount": 46,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "S58 — ZF8HP76 automatic",
          "family": "BMW S58 ZF8",
          "url": "/collections/all/bt-fit-route-bmw-m2-g87-s58-zf8hp76?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m2-g87-s58-zf8hp76&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m2-g87-s58-zf8hp76",
          "engineTag": "bt-fit-transmission-zf8hp75-76",
          "systems": [
            "engine-management",
            "transmission-driveline",
            "cooling",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 1,
            "transmission-driveline": 7,
            "cooling": 1,
            "suspension-brakes": 33
          },
          "productCount": 40,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "F87": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW M2 F87",
          "url": "/collections/all/bt-fit-route-bmw-m2-f87-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m2-f87-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m2-f87-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 37
          },
          "productCount": 37,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "N55 3.0L Turbo",
          "family": "BMW N55",
          "url": "/collections/all/bt-fit-route-bmw-m2-f87-n55?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m2-f87-n55&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m2-f87-n55",
          "engineTag": "bt-fit-engine-n55",
          "systems": [
            "turbo-forced-induction",
            "fuel-system",
            "engine-parts",
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "fuel-system": 4,
            "engine-parts": 2,
            "clutch": 1,
            "transmission-driveline": 1,
            "suspension-brakes": 34
          },
          "productCount": 42,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "S55 3.0L Twin-Turbo (Competition / CS)",
          "family": "BMW S55",
          "url": "/collections/all/bt-fit-route-bmw-m2-f87-s55?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m2-f87-s55&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m2-f87-s55",
          "engineTag": "bt-fit-engine-s55",
          "systems": [
            "turbo-forced-induction",
            "fuel-system",
            "exhaust",
            "engine-parts",
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "fuel-system": 1,
            "exhaust": 1,
            "engine-parts": 2,
            "clutch": 1,
            "transmission-driveline": 1,
            "suspension-brakes": 36
          },
          "productCount": 41,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "M3": {
      "G80 / G81": [
        {
          "label": "S58",
          "family": "BMW S58",
          "url": "/collections/all/bt-fit-route-bmw-m3-g80-g81-s58?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m3-g80-g81-s58&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m3-g80-g81-s58",
          "engineTag": "bt-fit-engine-s58",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "transmission-driveline",
            "cooling",
            "suspension-brakes",
            "service-maintenance"
          ],
          "systemCounts": {
            "engine-management": 5,
            "wiring-sensors-displays": 2,
            "turbo-forced-induction": 6,
            "intercooler": 2,
            "fuel-system": 10,
            "intake": 4,
            "exhaust": 5,
            "engine-parts": 12,
            "transmission-driveline": 2,
            "cooling": 1,
            "suspension-brakes": 38,
            "service-maintenance": 1
          },
          "productCount": 74,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "E90 / E92 / E93": [
        {
          "label": "S65 4.0L V8",
          "family": "BMW S65",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m3-e9x-s65",
          "systems": [
            "turbo-forced-induction",
            "engine-parts",
            "suspension-brakes"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "engine-parts": 7,
            "suspension-brakes": 19
          },
          "url": "/collections/all/bt-fit-route-bmw-m3-e9x-s65?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m3-e9x-s65&sort_by=price-ascending",
          "productCount": 27,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "E46": [
        {
          "label": "S54 3.2L",
          "family": "BMW E46 M3",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m3-e46-s54",
          "systems": [
            "engine-parts",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-parts": 6,
            "suspension-brakes": 10
          },
          "url": "/collections/all/bt-fit-route-bmw-m3-e46-s54?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m3-e46-s54&sort_by=price-ascending",
          "productCount": 16,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "F80": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW M3 F80",
          "url": "/collections/all/bt-fit-route-bmw-m3-f80-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m3-f80-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m3-f80-chassis",
          "systems": [
            "suspension-brakes",
            "exterior-aero"
          ],
          "systemCounts": {
            "suspension-brakes": 20,
            "exterior-aero": 3
          },
          "productCount": 23,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "S55 3.0L Twin-Turbo",
          "family": "BMW S55",
          "url": "/collections/all/bt-fit-route-bmw-m3-f80-s55?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m3-f80-s55&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m3-f80-s55",
          "engineTag": "bt-fit-engine-s55",
          "systems": [
            "turbo-forced-induction",
            "fuel-system",
            "exhaust",
            "engine-parts",
            "clutch",
            "transmission-driveline",
            "suspension-brakes",
            "exterior-aero"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2,
            "fuel-system": 1,
            "exhaust": 2,
            "engine-parts": 2,
            "clutch": 1,
            "transmission-driveline": 1,
            "suspension-brakes": 35,
            "exterior-aero": 3
          },
          "productCount": 44,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "G80": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW M3 G80",
          "url": "/collections/all/bt-fit-route-bmw-m3-g80-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m3-g80-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m3-g80-chassis",
          "systems": [
            "engine-management",
            "suspension-brakes",
            "exterior-aero"
          ],
          "systemCounts": {
            "engine-management": 1,
            "suspension-brakes": 43,
            "exterior-aero": 3
          },
          "productCount": 46,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "S58",
          "family": "BMW M3 G80",
          "url": "/collections/all/bt-fit-route-bmw-m3-g80-s58?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m3-g80-s58&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m3-g80-s58",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "transmission-driveline",
            "cooling",
            "suspension-brakes",
            "service-maintenance"
          ],
          "systemCounts": {
            "engine-management": 5,
            "wiring-sensors-displays": 2,
            "turbo-forced-induction": 7,
            "intercooler": 2,
            "fuel-system": 14,
            "intake": 4,
            "exhaust": 7,
            "engine-parts": 15,
            "transmission-driveline": 2,
            "cooling": 1,
            "suspension-brakes": 43,
            "service-maintenance": 1
          },
          "engineTag": "bt-fit-engine-s58",
          "productCount": 86,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "S58 — ZF8HP76 automatic",
          "family": "BMW S58 ZF8",
          "url": "/collections/all/bt-fit-route-bmw-m3-g80-s58-zf8hp76?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m3-g80-s58-zf8hp76&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m3-g80-s58-zf8hp76",
          "engineTag": "bt-fit-transmission-zf8hp75-76",
          "systems": [
            "engine-management",
            "transmission-driveline",
            "cooling",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 2,
            "transmission-driveline": 7,
            "cooling": 1,
            "suspension-brakes": 43
          },
          "productCount": 50,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "M3 Competition xDrive — ATC-13",
          "family": "BMW ATC-13 xDrive",
          "url": "/collections/all/bt-fit-route-bmw-g80-m3-xdrive-atc13?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-g80-m3-xdrive-atc13&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-g80-m3-xdrive-atc13",
          "engineTag": "bt-fit-transfer-atc13",
          "systems": [
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "transmission-driveline": 1,
            "suspension-brakes": 5
          },
          "productCount": 6,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "M4": {
      "G82 / G83": [
        {
          "label": "S58",
          "family": "BMW S58",
          "url": "/collections/all/bt-fit-route-bmw-m4-g82-g83-s58?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m4-g82-g83-s58&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m4-g82-g83-s58",
          "engineTag": "bt-fit-engine-s58",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "transmission-driveline",
            "cooling",
            "suspension-brakes",
            "service-maintenance"
          ],
          "systemCounts": {
            "engine-management": 5,
            "wiring-sensors-displays": 2,
            "turbo-forced-induction": 7,
            "intercooler": 2,
            "fuel-system": 11,
            "intake": 4,
            "exhaust": 6,
            "engine-parts": 12,
            "transmission-driveline": 2,
            "cooling": 1,
            "suspension-brakes": 26,
            "service-maintenance": 1
          },
          "productCount": 64,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "F82": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW M4 F82",
          "url": "/collections/all/bt-fit-route-bmw-m4-f82-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m4-f82-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m4-f82-chassis",
          "systems": [
            "suspension-brakes",
            "exterior-aero"
          ],
          "systemCounts": {
            "suspension-brakes": 19,
            "exterior-aero": 3
          },
          "productCount": 22,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "S55 3.0L Twin-Turbo",
          "family": "BMW S55",
          "url": "/collections/all/bt-fit-route-bmw-m4-f82-s55?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m4-f82-s55&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m4-f82-s55",
          "engineTag": "bt-fit-engine-s55",
          "systems": [
            "turbo-forced-induction",
            "fuel-system",
            "exhaust",
            "engine-parts",
            "clutch",
            "transmission-driveline",
            "suspension-brakes",
            "exterior-aero"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2,
            "fuel-system": 1,
            "exhaust": 2,
            "engine-parts": 2,
            "clutch": 1,
            "transmission-driveline": 1,
            "suspension-brakes": 34,
            "exterior-aero": 3
          },
          "productCount": 43,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "F83": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW M4 F83",
          "url": "/collections/all/bt-fit-route-bmw-m4-f83-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m4-f83-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m4-f83-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "S55 3.0L Twin-Turbo",
          "family": "BMW S55",
          "url": "/collections/all/bt-fit-route-bmw-m4-f83-s55?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m4-f83-s55&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m4-f83-s55",
          "engineTag": "bt-fit-engine-s55",
          "systems": [
            "turbo-forced-induction",
            "fuel-system",
            "exhaust",
            "engine-parts",
            "suspension-brakes"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "fuel-system": 1,
            "exhaust": 1,
            "engine-parts": 2,
            "suspension-brakes": 1
          },
          "productCount": 5,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "G82": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW M4 G82",
          "url": "/collections/all/bt-fit-route-bmw-m4-g82-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m4-g82-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m4-g82-chassis",
          "systems": [
            "engine-management",
            "suspension-brakes",
            "exterior-aero"
          ],
          "systemCounts": {
            "engine-management": 1,
            "suspension-brakes": 42,
            "exterior-aero": 4
          },
          "productCount": 46,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "S58",
          "family": "BMW M4 G82",
          "url": "/collections/all/bt-fit-route-bmw-m4-g82-s58?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m4-g82-s58&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m4-g82-s58",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "transmission-driveline",
            "cooling",
            "suspension-brakes",
            "service-maintenance"
          ],
          "systemCounts": {
            "engine-management": 5,
            "wiring-sensors-displays": 2,
            "turbo-forced-induction": 7,
            "intercooler": 2,
            "fuel-system": 14,
            "intake": 4,
            "exhaust": 7,
            "engine-parts": 15,
            "transmission-driveline": 2,
            "cooling": 1,
            "suspension-brakes": 42,
            "service-maintenance": 1
          },
          "engineTag": "bt-fit-engine-s58",
          "productCount": 85,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "S58 — ZF8HP76 automatic",
          "family": "BMW S58 ZF8",
          "url": "/collections/all/bt-fit-route-bmw-m4-g82-s58-zf8hp76?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m4-g82-s58-zf8hp76&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m4-g82-s58-zf8hp76",
          "engineTag": "bt-fit-transmission-zf8hp75-76",
          "systems": [
            "engine-management",
            "transmission-driveline",
            "cooling",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 2,
            "transmission-driveline": 7,
            "cooling": 1,
            "suspension-brakes": 42
          },
          "productCount": 49,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "M4 Competition xDrive — ATC-13",
          "family": "BMW ATC-13 xDrive",
          "url": "/collections/all/bt-fit-route-bmw-g82-m4-xdrive-atc13?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-g82-m4-xdrive-atc13&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-g82-m4-xdrive-atc13",
          "engineTag": "bt-fit-transfer-atc13",
          "systems": [
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "transmission-driveline": 1,
            "suspension-brakes": 5
          },
          "productCount": 6,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "340i / M340i": {
      "G20 / G21": [
        {
          "label": "B58",
          "family": "BMW / Toyota B58",
          "url": "/collections/all/bt-fit-route-bmw-340i-m340i-g20-g21-b58?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-340i-m340i-g20-g21-b58&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-340i-m340i-g20-g21-b58",
          "engineTag": "bt-fit-engine-b58",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 2,
            "wiring-sensors-displays": 2,
            "turbo-forced-induction": 9,
            "intercooler": 1,
            "fuel-system": 13,
            "intake": 2,
            "exhaust": 6,
            "engine-parts": 5,
            "suspension-brakes": 1
          },
          "productCount": 28,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B58 — ZF8HP50/51 automatic",
          "family": "BMW B58 ZF8",
          "url": "/collections/all/bt-fit-route-bmw-m340i-g20-g21-b58-zf8hp5x?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m340i-g20-g21-b58-zf8hp5x&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m340i-g20-g21-b58-zf8hp5x",
          "engineTag": "bt-fit-transmission-zf8hp45-50-51",
          "systems": [
            "engine-management",
            "transmission-driveline",
            "cooling"
          ],
          "systemCounts": {
            "engine-management": 1,
            "transmission-driveline": 7,
            "cooling": 1
          },
          "productCount": 7,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "330i": {
      "E46 (2001–2005)": [
        {
          "label": "M54B30 3.0L",
          "family": "BMW 330i E46",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-330i-e46-m54b30",
          "systems": [
            "intake",
            "engine-parts",
            "suspension-brakes"
          ],
          "systemCounts": {
            "intake": 1,
            "engine-parts": 3,
            "suspension-brakes": 3
          },
          "url": "/collections/all/bt-fit-route-bmw-330i-e46-m54b30?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-330i-e46-m54b30&sort_by=price-ascending",
          "productCount": 7,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "125i": {
      "F20 / F21 (2012–2016)": [
        {
          "label": "N20 2.0L Turbo",
          "family": "BMW 125i",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-125i-f20-f21-n20",
          "systems": [
            "turbo-forced-induction",
            "fuel-system",
            "intake"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2,
            "fuel-system": 3,
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-bmw-125i-f20-f21-n20?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-125i-f20-f21-n20&sort_by=price-ascending",
          "productCount": 6,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "220i / 228i": {
      "F22 / F23 (2014–2016)": [
        {
          "label": "N20 2.0L Turbo",
          "family": "BMW 2 Series",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-220i-228i-f22-f23-n20",
          "systems": [
            "turbo-forced-induction",
            "fuel-system",
            "intake",
            "suspension-brakes"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2,
            "fuel-system": 3,
            "intake": 1,
            "suspension-brakes": 2
          },
          "url": "/collections/all/bt-fit-route-bmw-220i-228i-f22-f23-n20?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-220i-228i-f22-f23-n20&sort_by=price-ascending",
          "productCount": 8,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "320i / 328i": {
      "F30 / F31 (2012–2015)": [
        {
          "label": "N20 2.0L Turbo",
          "family": "BMW 3 Series",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-320i-328i-f30-f31-n20",
          "systems": [
            "turbo-forced-induction",
            "fuel-system",
            "intake"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2,
            "fuel-system": 3,
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-bmw-320i-328i-f30-f31-n20?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-320i-328i-f30-f31-n20&sort_by=price-ascending",
          "productCount": 6,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "420i / 428i": {
      "F32 / F33 / F36 (2013–2016)": [
        {
          "label": "N20 2.0L Turbo",
          "family": "BMW 4 Series",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-420i-428i-f32-f33-f36-n20",
          "systems": [
            "turbo-forced-induction",
            "fuel-system",
            "intake"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2,
            "fuel-system": 3,
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-bmw-420i-428i-f32-f33-f36-n20?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-420i-428i-f32-f33-f36-n20&sort_by=price-ascending",
          "productCount": 6,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "1M": {
      "E82": [
        {
          "label": "N54 3.0L Twin-Turbo",
          "family": "BMW 1M",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-1m-e82-n54",
          "systems": [
            "engine-parts",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-parts": 3,
            "suspension-brakes": 17
          },
          "url": "/collections/all/bt-fit-route-bmw-1m-e82-n54?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-1m-e82-n54&sort_by=price-ascending",
          "productCount": 20,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "1 Series": {
      "E81": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 1 Series E81",
          "url": "/collections/all/bt-fit-route-bmw-1-series-e81-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-1-series-e81-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-1-series-e81-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 4
          },
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "E82": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 1 Series E82",
          "url": "/collections/all/bt-fit-route-bmw-1-series-e82-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-1-series-e82-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-1-series-e82-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 16
          },
          "productCount": 16,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "N54 3.0L Twin-Turbo (135i)",
          "family": "BMW N54",
          "url": "/collections/all/bt-fit-route-bmw-1-series-e82-n54?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-1-series-e82-n54&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-1-series-e82-n54",
          "engineTag": "bt-fit-engine-n54",
          "systems": [
            "turbo-forced-induction",
            "fuel-system",
            "exhaust",
            "engine-parts",
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2,
            "fuel-system": 5,
            "exhaust": 1,
            "engine-parts": 3,
            "clutch": 1,
            "transmission-driveline": 1,
            "suspension-brakes": 2
          },
          "productCount": 13,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "N55 3.0L Turbo (135i)",
          "family": "BMW N55",
          "url": "/collections/all/bt-fit-route-bmw-1-series-e82-n55?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-1-series-e82-n55&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-1-series-e82-n55",
          "engineTag": "bt-fit-engine-n55",
          "systems": [
            "fuel-system",
            "engine-parts",
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "fuel-system": 5,
            "engine-parts": 2,
            "clutch": 1,
            "transmission-driveline": 1,
            "suspension-brakes": 2
          },
          "productCount": 10,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "E87": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 1 Series E87",
          "url": "/collections/all/bt-fit-route-bmw-1-series-e87-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-1-series-e87-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-1-series-e87-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 4
          },
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "E88": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 1 Series E88",
          "url": "/collections/all/bt-fit-route-bmw-1-series-e88-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-1-series-e88-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-1-series-e88-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "N54 3.0L Twin-Turbo (135i)",
          "family": "BMW N54",
          "url": "/collections/all/bt-fit-route-bmw-1-series-e88-n54?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-1-series-e88-n54&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-1-series-e88-n54",
          "engineTag": "bt-fit-engine-n54",
          "systems": [
            "turbo-forced-induction",
            "fuel-system",
            "exhaust",
            "engine-parts",
            "suspension-brakes"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2,
            "fuel-system": 5,
            "exhaust": 1,
            "engine-parts": 3,
            "suspension-brakes": 1
          },
          "productCount": 11,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "N55 3.0L Turbo (135i)",
          "family": "BMW N55",
          "url": "/collections/all/bt-fit-route-bmw-1-series-e88-n55?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-1-series-e88-n55&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-1-series-e88-n55",
          "engineTag": "bt-fit-engine-n55",
          "systems": [
            "fuel-system",
            "engine-parts",
            "suspension-brakes"
          ],
          "systemCounts": {
            "fuel-system": 5,
            "engine-parts": 2,
            "suspension-brakes": 1
          },
          "productCount": 8,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "F20": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 1 Series F20",
          "url": "/collections/all/bt-fit-route-bmw-1-series-f20-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-1-series-f20-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-1-series-f20-chassis",
          "systems": [
            "engine-management",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 1,
            "suspension-brakes": 34
          },
          "productCount": 34,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "N55 3.0L Turbo (M135i)",
          "family": "BMW N55",
          "url": "/collections/all/bt-fit-route-bmw-1-series-f20-n55?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-1-series-f20-n55&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-1-series-f20-n55",
          "engineTag": "bt-fit-engine-n55",
          "systems": [
            "fuel-system",
            "engine-parts",
            "suspension-brakes"
          ],
          "systemCounts": {
            "fuel-system": 4,
            "engine-parts": 2,
            "suspension-brakes": 26
          },
          "productCount": 32,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B46/B48 2.0L Turbo",
          "family": "BMW B46/B48",
          "url": "/collections/all/bt-fit-route-bmw-1-series-f20-b46-b48?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-1-series-f20-b46-b48&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-1-series-f20-b46-b48",
          "engineTag": "bt-fit-engine-b48",
          "systems": [
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "suspension-brakes"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "intercooler": 1,
            "fuel-system": 2,
            "intake": 1,
            "suspension-brakes": 2
          },
          "productCount": 5,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "F20 LCI": [
        {
          "label": "B58",
          "family": "BMW 1 Series F20 LCI",
          "url": "/collections/all/bt-fit-route-bmw-1-series-f20-lci-b58?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-1-series-f20-lci-b58&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-1-series-f20-lci-b58",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 1,
            "wiring-sensors-displays": 1,
            "turbo-forced-induction": 8,
            "intercooler": 1,
            "fuel-system": 10,
            "intake": 1,
            "exhaust": 5,
            "engine-parts": 1,
            "transmission-driveline": 1,
            "suspension-brakes": 26
          },
          "engineTag": "bt-fit-engine-b58",
          "productCount": 46,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "F21": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 1 Series F21",
          "url": "/collections/all/bt-fit-route-bmw-1-series-f21-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-1-series-f21-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-1-series-f21-chassis",
          "systems": [
            "engine-management",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 1,
            "suspension-brakes": 5
          },
          "productCount": 5,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "N55 3.0L Turbo (M135i)",
          "family": "BMW N55",
          "url": "/collections/all/bt-fit-route-bmw-1-series-f21-n55?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-1-series-f21-n55&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-1-series-f21-n55",
          "engineTag": "bt-fit-engine-n55",
          "systems": [
            "fuel-system",
            "engine-parts"
          ],
          "systemCounts": {
            "fuel-system": 2,
            "engine-parts": 2
          },
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B46/B48 2.0L Turbo",
          "family": "BMW B46/B48",
          "url": "/collections/all/bt-fit-route-bmw-1-series-f21-b46-b48?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-1-series-f21-b46-b48&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-1-series-f21-b46-b48",
          "engineTag": "bt-fit-engine-b48",
          "systems": [
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "intercooler": 1,
            "fuel-system": 2,
            "intake": 1
          },
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "F21 LCI": [
        {
          "label": "B58",
          "family": "BMW 1 Series F21 LCI",
          "url": "/collections/all/bt-fit-route-bmw-1-series-f21-lci-b58?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-1-series-f21-lci-b58&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-1-series-f21-lci-b58",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "transmission-driveline"
          ],
          "systemCounts": {
            "engine-management": 1,
            "wiring-sensors-displays": 1,
            "turbo-forced-induction": 8,
            "intercooler": 1,
            "fuel-system": 10,
            "intake": 1,
            "exhaust": 5,
            "engine-parts": 1,
            "transmission-driveline": 1
          },
          "engineTag": "bt-fit-engine-b58",
          "productCount": 20,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "F40": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 1 Series F40",
          "url": "/collections/all/bt-fit-route-bmw-1-series-f40-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-1-series-f40-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-1-series-f40-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 3
          },
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "F70": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 1 Series F70",
          "url": "/collections/all/bt-fit-route-bmw-1-series-f70-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-1-series-f70-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-1-series-f70-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "2 Series": {
      "F22": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 2 Series F22",
          "url": "/collections/all/bt-fit-route-bmw-2-series-f22-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-2-series-f22-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-2-series-f22-chassis",
          "systems": [
            "engine-management",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 1,
            "suspension-brakes": 31
          },
          "productCount": 31,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "N55 3.0L Turbo (M235i)",
          "family": "BMW N55",
          "url": "/collections/all/bt-fit-route-bmw-2-series-f22-n55?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-2-series-f22-n55&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-2-series-f22-n55",
          "engineTag": "bt-fit-engine-n55",
          "systems": [
            "fuel-system",
            "engine-parts",
            "suspension-brakes"
          ],
          "systemCounts": {
            "fuel-system": 4,
            "engine-parts": 2,
            "suspension-brakes": 25
          },
          "productCount": 31,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B46/B48 2.0L Turbo (220i / 230i)",
          "family": "BMW B46/B48",
          "url": "/collections/all/bt-fit-route-bmw-2-series-f22-b46-b48?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-2-series-f22-b46-b48&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-2-series-f22-b46-b48",
          "engineTag": "bt-fit-engine-b48",
          "systems": [
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "suspension-brakes"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2,
            "intercooler": 1,
            "fuel-system": 3,
            "intake": 1,
            "exhaust": 1,
            "suspension-brakes": 3
          },
          "productCount": 8,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "F22 LCI": [
        {
          "label": "B58",
          "family": "BMW 2 Series F22 LCI",
          "url": "/collections/all/bt-fit-route-bmw-2-series-f22-lci-b58?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-2-series-f22-lci-b58&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-2-series-f22-lci-b58",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 1,
            "wiring-sensors-displays": 1,
            "turbo-forced-induction": 7,
            "intercooler": 1,
            "fuel-system": 11,
            "intake": 1,
            "exhaust": 5,
            "engine-parts": 1,
            "transmission-driveline": 1,
            "suspension-brakes": 25
          },
          "engineTag": "bt-fit-engine-b58",
          "productCount": 45,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B58 — ZF8HP45/50/51 automatic",
          "family": "BMW B58 ZF8",
          "url": "/collections/all/bt-fit-route-bmw-2-series-f22-lci-b58-zf8hp5x?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-2-series-f22-lci-b58-zf8hp5x&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-2-series-f22-lci-b58-zf8hp5x",
          "engineTag": "bt-fit-transmission-zf8hp45-50-51",
          "systems": [
            "engine-management",
            "transmission-driveline",
            "cooling",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 1,
            "transmission-driveline": 7,
            "cooling": 1,
            "suspension-brakes": 25
          },
          "productCount": 32,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "F23": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 2 Series F23",
          "url": "/collections/all/bt-fit-route-bmw-2-series-f23-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-2-series-f23-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-2-series-f23-chassis",
          "systems": [
            "engine-management",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 1,
            "suspension-brakes": 3
          },
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "N55 3.0L Turbo (M235i)",
          "family": "BMW N55",
          "url": "/collections/all/bt-fit-route-bmw-2-series-f23-n55?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-2-series-f23-n55&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-2-series-f23-n55",
          "engineTag": "bt-fit-engine-n55",
          "systems": [
            "fuel-system",
            "engine-parts"
          ],
          "systemCounts": {
            "fuel-system": 2,
            "engine-parts": 2
          },
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B46/B48 2.0L Turbo (220i / 230i)",
          "family": "BMW B46/B48",
          "url": "/collections/all/bt-fit-route-bmw-2-series-f23-b46-b48?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-2-series-f23-b46-b48&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-2-series-f23-b46-b48",
          "engineTag": "bt-fit-engine-b48",
          "systems": [
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "suspension-brakes"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "intercooler": 1,
            "fuel-system": 2,
            "intake": 1,
            "suspension-brakes": 2
          },
          "productCount": 5,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "F23 LCI": [
        {
          "label": "B58",
          "family": "BMW 2 Series F23 LCI",
          "url": "/collections/all/bt-fit-route-bmw-2-series-f23-lci-b58?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-2-series-f23-lci-b58&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-2-series-f23-lci-b58",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "transmission-driveline"
          ],
          "systemCounts": {
            "engine-management": 1,
            "wiring-sensors-displays": 1,
            "turbo-forced-induction": 7,
            "intercooler": 1,
            "fuel-system": 11,
            "intake": 1,
            "exhaust": 5,
            "engine-parts": 1,
            "transmission-driveline": 1
          },
          "engineTag": "bt-fit-engine-b58",
          "productCount": 20,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B58 — ZF8HP45/50/51 automatic",
          "family": "BMW B58 ZF8",
          "url": "/collections/all/bt-fit-route-bmw-2-series-f23-lci-b58-zf8hp5x?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-2-series-f23-lci-b58-zf8hp5x&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-2-series-f23-lci-b58-zf8hp5x",
          "engineTag": "bt-fit-transmission-zf8hp45-50-51",
          "systems": [
            "engine-management",
            "transmission-driveline",
            "cooling"
          ],
          "systemCounts": {
            "engine-management": 1,
            "transmission-driveline": 7,
            "cooling": 1
          },
          "productCount": 7,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "2 Series Gran Coupe": {
      "F44": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 2 Series Gran Coupe F44",
          "url": "/collections/all/bt-fit-route-bmw-2-series-gran-coupe-f44-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-2-series-gran-coupe-f44-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-2-series-gran-coupe-f44-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "2 Series / M240i": {
      "G42": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 2 Series / M240i G42",
          "url": "/collections/all/bt-fit-route-bmw-2-series-m240i-g42-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-2-series-m240i-g42-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-2-series-m240i-g42-chassis",
          "systems": [
            "engine-management",
            "turbo-forced-induction",
            "intake",
            "exhaust",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 1,
            "turbo-forced-induction": 2,
            "intake": 1,
            "exhaust": 2,
            "suspension-brakes": 20
          },
          "productCount": 22,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B58 3.0L Turbo (M240i)",
          "family": "BMW B58",
          "url": "/collections/all/bt-fit-route-bmw-2-series-m240i-g42-b58?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-2-series-m240i-g42-b58&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-2-series-m240i-g42-b58",
          "engineTag": "bt-fit-engine-b58",
          "systems": [
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "turbo-forced-induction": 5,
            "intercooler": 1,
            "fuel-system": 8,
            "intake": 1,
            "exhaust": 4,
            "engine-parts": 2,
            "transmission-driveline": 1,
            "suspension-brakes": 18
          },
          "productCount": 34,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B58 — ZF8HP50/51 automatic",
          "family": "BMW B58 ZF8",
          "url": "/collections/all/bt-fit-route-bmw-m240i-g42-b58-zf8hp5x?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m240i-g42-b58-zf8hp5x&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m240i-g42-b58-zf8hp5x",
          "engineTag": "bt-fit-transmission-zf8hp45-50-51",
          "systems": [
            "engine-management",
            "transmission-driveline",
            "cooling",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 1,
            "transmission-driveline": 7,
            "cooling": 1,
            "suspension-brakes": 18
          },
          "productCount": 25,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "M240i xDrive / 230i xDrive — ATC-13",
          "family": "BMW ATC-13 xDrive",
          "url": "/collections/all/bt-fit-route-bmw-g42-xdrive-atc13?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-g42-xdrive-atc13&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-g42-xdrive-atc13",
          "engineTag": "bt-fit-transfer-atc13",
          "systems": [
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "transmission-driveline": 1,
            "suspension-brakes": 5
          },
          "productCount": 6,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "3 Series": {
      "E30": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 3 Series E30",
          "url": "/collections/all/bt-fit-route-bmw-3-series-e30-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-3-series-e30-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-3-series-e30-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 3
          },
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "E36": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 3 Series E36",
          "url": "/collections/all/bt-fit-route-bmw-3-series-e36-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-3-series-e36-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-3-series-e36-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 8
          },
          "productCount": 8,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "E46": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 3 Series E46",
          "url": "/collections/all/bt-fit-route-bmw-3-series-e46-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-3-series-e46-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-3-series-e46-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 14
          },
          "productCount": 14,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "E90": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 3 Series E90",
          "url": "/collections/all/bt-fit-route-bmw-3-series-e90-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-3-series-e90-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-3-series-e90-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 24
          },
          "productCount": 24,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "N54 3.0L Twin-Turbo (335i / 335is)",
          "family": "BMW N54",
          "url": "/collections/all/bt-fit-route-bmw-3-series-e90-n54?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-3-series-e90-n54&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-3-series-e90-n54",
          "engineTag": "bt-fit-engine-n54",
          "systems": [
            "turbo-forced-induction",
            "fuel-system",
            "exhaust",
            "engine-parts",
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2,
            "fuel-system": 5,
            "exhaust": 1,
            "engine-parts": 3,
            "clutch": 1,
            "transmission-driveline": 1,
            "suspension-brakes": 1
          },
          "productCount": 12,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "N55 3.0L Turbo (335i)",
          "family": "BMW N55",
          "url": "/collections/all/bt-fit-route-bmw-3-series-e90-n55?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-3-series-e90-n55&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-3-series-e90-n55",
          "engineTag": "bt-fit-engine-n55",
          "systems": [
            "fuel-system",
            "engine-parts",
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "fuel-system": 5,
            "engine-parts": 2,
            "clutch": 1,
            "transmission-driveline": 1,
            "suspension-brakes": 1
          },
          "productCount": 9,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "E91": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 3 Series E91",
          "url": "/collections/all/bt-fit-route-bmw-3-series-e91-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-3-series-e91-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-3-series-e91-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "N54 3.0L Twin-Turbo (335i / 335is)",
          "family": "BMW N54",
          "url": "/collections/all/bt-fit-route-bmw-3-series-e91-n54?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-3-series-e91-n54&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-3-series-e91-n54",
          "engineTag": "bt-fit-engine-n54",
          "systems": [
            "turbo-forced-induction",
            "fuel-system",
            "exhaust",
            "engine-parts"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2,
            "fuel-system": 5,
            "exhaust": 1,
            "engine-parts": 3
          },
          "productCount": 10,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "N55 3.0L Turbo (335i)",
          "family": "BMW N55",
          "url": "/collections/all/bt-fit-route-bmw-3-series-e91-n55?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-3-series-e91-n55&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-3-series-e91-n55",
          "engineTag": "bt-fit-engine-n55",
          "systems": [
            "fuel-system",
            "engine-parts"
          ],
          "systemCounts": {
            "fuel-system": 5,
            "engine-parts": 2
          },
          "productCount": 7,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "E92": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 3 Series E92",
          "url": "/collections/all/bt-fit-route-bmw-3-series-e92-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-3-series-e92-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-3-series-e92-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 21
          },
          "productCount": 21,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "N54 3.0L Twin-Turbo (335i / 335is)",
          "family": "BMW N54",
          "url": "/collections/all/bt-fit-route-bmw-3-series-e92-n54?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-3-series-e92-n54&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-3-series-e92-n54",
          "engineTag": "bt-fit-engine-n54",
          "systems": [
            "turbo-forced-induction",
            "fuel-system",
            "exhaust",
            "engine-parts",
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2,
            "fuel-system": 5,
            "exhaust": 1,
            "engine-parts": 3,
            "clutch": 1,
            "transmission-driveline": 1
          },
          "productCount": 11,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "N55 3.0L Turbo (335i)",
          "family": "BMW N55",
          "url": "/collections/all/bt-fit-route-bmw-3-series-e92-n55?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-3-series-e92-n55&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-3-series-e92-n55",
          "engineTag": "bt-fit-engine-n55",
          "systems": [
            "fuel-system",
            "engine-parts",
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "fuel-system": 5,
            "engine-parts": 2,
            "clutch": 1,
            "transmission-driveline": 1
          },
          "productCount": 8,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "E93": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 3 Series E93",
          "url": "/collections/all/bt-fit-route-bmw-3-series-e93-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-3-series-e93-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-3-series-e93-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 2
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "N54 3.0L Twin-Turbo (335i / 335is)",
          "family": "BMW N54",
          "url": "/collections/all/bt-fit-route-bmw-3-series-e93-n54?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-3-series-e93-n54&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-3-series-e93-n54",
          "engineTag": "bt-fit-engine-n54",
          "systems": [
            "turbo-forced-induction",
            "fuel-system",
            "exhaust",
            "engine-parts",
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2,
            "fuel-system": 5,
            "exhaust": 1,
            "engine-parts": 3,
            "clutch": 1,
            "transmission-driveline": 1,
            "suspension-brakes": 1
          },
          "productCount": 12,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "N55 3.0L Turbo (335i)",
          "family": "BMW N55",
          "url": "/collections/all/bt-fit-route-bmw-3-series-e93-n55?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-3-series-e93-n55&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-3-series-e93-n55",
          "engineTag": "bt-fit-engine-n55",
          "systems": [
            "fuel-system",
            "engine-parts",
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "fuel-system": 5,
            "engine-parts": 2,
            "clutch": 1,
            "transmission-driveline": 1,
            "suspension-brakes": 1
          },
          "productCount": 9,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "F30": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 3 Series F30",
          "url": "/collections/all/bt-fit-route-bmw-3-series-f30-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-3-series-f30-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-3-series-f30-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 10
          },
          "productCount": 10,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "N55 3.0L Turbo (335i)",
          "family": "BMW N55",
          "url": "/collections/all/bt-fit-route-bmw-3-series-f30-n55?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-3-series-f30-n55&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-3-series-f30-n55",
          "engineTag": "bt-fit-engine-n55",
          "systems": [
            "fuel-system",
            "engine-parts",
            "suspension-brakes"
          ],
          "systemCounts": {
            "fuel-system": 4,
            "engine-parts": 2,
            "suspension-brakes": 3
          },
          "productCount": 9,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B46/B48 2.0L Turbo (320i / 330i)",
          "family": "BMW B46/B48",
          "url": "/collections/all/bt-fit-route-bmw-3-series-f30-b46-b48?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-3-series-f30-b46-b48&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-3-series-f30-b46-b48",
          "engineTag": "bt-fit-engine-b48",
          "systems": [
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "suspension-brakes"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2,
            "intercooler": 1,
            "fuel-system": 3,
            "intake": 1,
            "exhaust": 1,
            "suspension-brakes": 4
          },
          "productCount": 9,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "F30 LCI": [
        {
          "label": "B58",
          "family": "BMW 3 Series F30 LCI",
          "url": "/collections/all/bt-fit-route-bmw-3-series-f30-lci-b58?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-3-series-f30-lci-b58&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-3-series-f30-lci-b58",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 1,
            "wiring-sensors-displays": 1,
            "turbo-forced-induction": 7,
            "intercooler": 1,
            "fuel-system": 12,
            "intake": 1,
            "exhaust": 4,
            "engine-parts": 1,
            "suspension-brakes": 2
          },
          "engineTag": "bt-fit-engine-b58",
          "productCount": 22,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B58 — ZF8HP45/50/51 automatic",
          "family": "BMW B58 ZF8",
          "url": "/collections/all/bt-fit-route-bmw-3-series-f30-lci-b58-zf8hp5x?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-3-series-f30-lci-b58-zf8hp5x&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-3-series-f30-lci-b58-zf8hp5x",
          "engineTag": "bt-fit-transmission-zf8hp45-50-51",
          "systems": [
            "engine-management",
            "transmission-driveline",
            "cooling",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 1,
            "transmission-driveline": 7,
            "cooling": 1,
            "suspension-brakes": 2
          },
          "productCount": 9,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "F31": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 3 Series F31",
          "url": "/collections/all/bt-fit-route-bmw-3-series-f31-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-3-series-f31-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-3-series-f31-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 3
          },
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "N55 3.0L Turbo (335i)",
          "family": "BMW N55",
          "url": "/collections/all/bt-fit-route-bmw-3-series-f31-n55?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-3-series-f31-n55&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-3-series-f31-n55",
          "engineTag": "bt-fit-engine-n55",
          "systems": [
            "fuel-system",
            "engine-parts"
          ],
          "systemCounts": {
            "fuel-system": 2,
            "engine-parts": 2
          },
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B46/B48 2.0L Turbo",
          "family": "BMW B46/B48",
          "url": "/collections/all/bt-fit-route-bmw-3-series-f31-b46-b48?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-3-series-f31-b46-b48&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-3-series-f31-b46-b48",
          "engineTag": "bt-fit-engine-b48",
          "systems": [
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "intercooler": 1,
            "fuel-system": 2,
            "intake": 1
          },
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "F31 LCI": [
        {
          "label": "B58",
          "family": "BMW 3 Series F31 LCI",
          "url": "/collections/all/bt-fit-route-bmw-3-series-f31-lci-b58?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-3-series-f31-lci-b58&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-3-series-f31-lci-b58",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts"
          ],
          "systemCounts": {
            "engine-management": 1,
            "wiring-sensors-displays": 1,
            "turbo-forced-induction": 7,
            "intercooler": 1,
            "fuel-system": 12,
            "intake": 1,
            "exhaust": 4,
            "engine-parts": 1
          },
          "engineTag": "bt-fit-engine-b58",
          "productCount": 20,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B58 — ZF8HP45/50/51 automatic",
          "family": "BMW B58 ZF8",
          "url": "/collections/all/bt-fit-route-bmw-3-series-f31-lci-b58-zf8hp5x?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-3-series-f31-lci-b58-zf8hp5x&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-3-series-f31-lci-b58-zf8hp5x",
          "engineTag": "bt-fit-transmission-zf8hp45-50-51",
          "systems": [
            "engine-management",
            "transmission-driveline",
            "cooling"
          ],
          "systemCounts": {
            "engine-management": 1,
            "transmission-driveline": 7,
            "cooling": 1
          },
          "productCount": 7,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "G20": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 3 Series G20",
          "url": "/collections/all/bt-fit-route-bmw-3-series-g20-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-3-series-g20-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-3-series-g20-chassis",
          "systems": [
            "engine-management",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 1,
            "suspension-brakes": 6
          },
          "productCount": 6,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B48 2.0L Turbo (330i)",
          "family": "BMW B46/B48",
          "url": "/collections/all/bt-fit-route-bmw-3-series-g20-b48?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-3-series-g20-b48&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-3-series-g20-b48",
          "engineTag": "bt-fit-engine-b48",
          "systems": [
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "intercooler": 1,
            "fuel-system": 3,
            "intake": 1
          },
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "330i xDrive / M340i xDrive — ATC-13",
          "family": "BMW ATC-13 xDrive",
          "url": "/collections/all/bt-fit-route-bmw-g20-xdrive-atc13?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-g20-xdrive-atc13&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-g20-xdrive-atc13",
          "engineTag": "bt-fit-transfer-atc13",
          "systems": [
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "transmission-driveline": 1,
            "suspension-brakes": 3
          },
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "G21": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 3 Series G21",
          "url": "/collections/all/bt-fit-route-bmw-3-series-g21-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-3-series-g21-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-3-series-g21-chassis",
          "systems": [
            "engine-management",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 1,
            "suspension-brakes": 4
          },
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B48 2.0L Turbo (330i)",
          "family": "BMW B46/B48",
          "url": "/collections/all/bt-fit-route-bmw-3-series-g21-b48?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-3-series-g21-b48&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-3-series-g21-b48",
          "engineTag": "bt-fit-engine-b48",
          "systems": [
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "intercooler": 1,
            "fuel-system": 3,
            "intake": 1
          },
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "3 Series GT": {
      "F34": [
        {
          "label": "B58",
          "family": "BMW 3 Series GT F34",
          "url": "/collections/all/bt-fit-route-bmw-3-series-gt-f34-b58?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-3-series-gt-f34-b58&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-3-series-gt-f34-b58",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "fuel-system",
            "engine-parts",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 1,
            "wiring-sensors-displays": 1,
            "turbo-forced-induction": 2,
            "fuel-system": 12,
            "engine-parts": 1,
            "suspension-brakes": 1
          },
          "engineTag": "bt-fit-engine-b58",
          "productCount": 16,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 3 Series GT F34",
          "url": "/collections/all/bt-fit-route-bmw-3-series-gt-f34-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-3-series-gt-f34-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-3-series-gt-f34-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 2
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "N55 3.0L Turbo (335i GT)",
          "family": "BMW N55",
          "url": "/collections/all/bt-fit-route-bmw-3-series-gt-f34-n55?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-3-series-gt-f34-n55&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-3-series-gt-f34-n55",
          "engineTag": "bt-fit-engine-n55",
          "systems": [
            "fuel-system",
            "engine-parts",
            "suspension-brakes"
          ],
          "systemCounts": {
            "fuel-system": 2,
            "engine-parts": 2,
            "suspension-brakes": 1
          },
          "productCount": 5,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B46/B48 2.0L Turbo",
          "family": "BMW B46/B48",
          "url": "/collections/all/bt-fit-route-bmw-3-series-gt-f34-b46-b48?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-3-series-gt-f34-b46-b48&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-3-series-gt-f34-b46-b48",
          "engineTag": "bt-fit-engine-b48",
          "systems": [
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "suspension-brakes"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "intercooler": 1,
            "fuel-system": 2,
            "intake": 1,
            "suspension-brakes": 1
          },
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "3 Series / M3": {
      "E9x": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 3 Series / M3 E9x",
          "url": "/collections/all/bt-fit-route-bmw-3-series-m3-e9x-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-3-series-m3-e9x-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-3-series-m3-e9x-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 16
          },
          "productCount": 16,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "4 Series": {
      "F32": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 4 Series F32",
          "url": "/collections/all/bt-fit-route-bmw-4-series-f32-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-4-series-f32-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-4-series-f32-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 10
          },
          "productCount": 10,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "N55 3.0L Turbo (435i)",
          "family": "BMW N55",
          "url": "/collections/all/bt-fit-route-bmw-4-series-f32-n55?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-4-series-f32-n55&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-4-series-f32-n55",
          "engineTag": "bt-fit-engine-n55",
          "systems": [
            "fuel-system",
            "engine-parts",
            "suspension-brakes"
          ],
          "systemCounts": {
            "fuel-system": 4,
            "engine-parts": 2,
            "suspension-brakes": 3
          },
          "productCount": 9,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B46/B48 2.0L Turbo (420i / 430i)",
          "family": "BMW B46/B48",
          "url": "/collections/all/bt-fit-route-bmw-4-series-f32-b46-b48?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-4-series-f32-b46-b48&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-4-series-f32-b46-b48",
          "engineTag": "bt-fit-engine-b48",
          "systems": [
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "suspension-brakes"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2,
            "intercooler": 1,
            "fuel-system": 3,
            "intake": 1,
            "exhaust": 1,
            "suspension-brakes": 4
          },
          "productCount": 9,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "F32 LCI": [
        {
          "label": "B58",
          "family": "BMW 4 Series F32 LCI",
          "url": "/collections/all/bt-fit-route-bmw-4-series-f32-lci-b58?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-4-series-f32-lci-b58&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-4-series-f32-lci-b58",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 1,
            "wiring-sensors-displays": 1,
            "turbo-forced-induction": 6,
            "intercooler": 1,
            "fuel-system": 12,
            "intake": 1,
            "exhaust": 4,
            "engine-parts": 1,
            "suspension-brakes": 2
          },
          "engineTag": "bt-fit-engine-b58",
          "productCount": 21,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B58 — ZF8HP45/50/51 automatic",
          "family": "BMW B58 ZF8",
          "url": "/collections/all/bt-fit-route-bmw-4-series-f32-lci-b58-zf8hp5x?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-4-series-f32-lci-b58-zf8hp5x&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-4-series-f32-lci-b58-zf8hp5x",
          "engineTag": "bt-fit-transmission-zf8hp45-50-51",
          "systems": [
            "engine-management",
            "transmission-driveline",
            "cooling",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 1,
            "transmission-driveline": 7,
            "cooling": 1,
            "suspension-brakes": 2
          },
          "productCount": 9,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "F33": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 4 Series F33",
          "url": "/collections/all/bt-fit-route-bmw-4-series-f33-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-4-series-f33-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-4-series-f33-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "N55 3.0L Turbo (435i)",
          "family": "BMW N55",
          "url": "/collections/all/bt-fit-route-bmw-4-series-f33-n55?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-4-series-f33-n55&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-4-series-f33-n55",
          "engineTag": "bt-fit-engine-n55",
          "systems": [
            "fuel-system",
            "engine-parts"
          ],
          "systemCounts": {
            "fuel-system": 2,
            "engine-parts": 2
          },
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B46/B48 2.0L Turbo (420i / 430i)",
          "family": "BMW B46/B48",
          "url": "/collections/all/bt-fit-route-bmw-4-series-f33-b46-b48?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-4-series-f33-b46-b48&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-4-series-f33-b46-b48",
          "engineTag": "bt-fit-engine-b48",
          "systems": [
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2,
            "intercooler": 1,
            "fuel-system": 3,
            "intake": 1,
            "exhaust": 1
          },
          "productCount": 5,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "F33 LCI": [
        {
          "label": "B58",
          "family": "BMW 4 Series F33 LCI",
          "url": "/collections/all/bt-fit-route-bmw-4-series-f33-lci-b58?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-4-series-f33-lci-b58&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-4-series-f33-lci-b58",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts"
          ],
          "systemCounts": {
            "engine-management": 1,
            "wiring-sensors-displays": 1,
            "turbo-forced-induction": 6,
            "intercooler": 1,
            "fuel-system": 12,
            "intake": 1,
            "exhaust": 4,
            "engine-parts": 1
          },
          "engineTag": "bt-fit-engine-b58",
          "productCount": 19,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B58 — ZF8HP45/50/51 automatic",
          "family": "BMW B58 ZF8",
          "url": "/collections/all/bt-fit-route-bmw-4-series-f33-lci-b58-zf8hp5x?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-4-series-f33-lci-b58-zf8hp5x&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-4-series-f33-lci-b58-zf8hp5x",
          "engineTag": "bt-fit-transmission-zf8hp45-50-51",
          "systems": [
            "engine-management",
            "transmission-driveline",
            "cooling"
          ],
          "systemCounts": {
            "engine-management": 1,
            "transmission-driveline": 7,
            "cooling": 1
          },
          "productCount": 7,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "G22": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 4 Series G22",
          "url": "/collections/all/bt-fit-route-bmw-4-series-g22-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-4-series-g22-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-4-series-g22-chassis",
          "systems": [
            "engine-management",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 1,
            "suspension-brakes": 4
          },
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B48 2.0L Turbo (430i)",
          "family": "BMW B46/B48",
          "url": "/collections/all/bt-fit-route-bmw-4-series-g22-b48?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-4-series-g22-b48&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-4-series-g22-b48",
          "engineTag": "bt-fit-engine-b48",
          "systems": [
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "intercooler": 1,
            "fuel-system": 3,
            "intake": 1
          },
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B58 3.0L Turbo (M440i)",
          "family": "BMW B58",
          "url": "/collections/all/bt-fit-route-bmw-4-series-g22-b58?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-4-series-g22-b58&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-4-series-g22-b58",
          "engineTag": "bt-fit-engine-b58",
          "systems": [
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts"
          ],
          "systemCounts": {
            "turbo-forced-induction": 5,
            "intercooler": 1,
            "fuel-system": 9,
            "intake": 1,
            "exhaust": 4,
            "engine-parts": 2
          },
          "productCount": 16,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B58 — ZF8HP50/51 automatic",
          "family": "BMW B58 ZF8",
          "url": "/collections/all/bt-fit-route-bmw-4-series-g22-b58-zf8hp5x?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-4-series-g22-b58-zf8hp5x&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-4-series-g22-b58-zf8hp5x",
          "engineTag": "bt-fit-transmission-zf8hp45-50-51",
          "systems": [
            "engine-management",
            "transmission-driveline",
            "cooling"
          ],
          "systemCounts": {
            "engine-management": 1,
            "transmission-driveline": 7,
            "cooling": 1
          },
          "productCount": 7,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "430i xDrive / M440i xDrive — ATC-13",
          "family": "BMW ATC-13 xDrive",
          "url": "/collections/all/bt-fit-route-bmw-g22-xdrive-atc13?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-g22-xdrive-atc13&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-g22-xdrive-atc13",
          "engineTag": "bt-fit-transfer-atc13",
          "systems": [
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "transmission-driveline": 1,
            "suspension-brakes": 2
          },
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "G23": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 4 Series G23",
          "url": "/collections/all/bt-fit-route-bmw-4-series-g23-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-4-series-g23-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-4-series-g23-chassis",
          "systems": [
            "engine-management",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 1,
            "suspension-brakes": 2
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B58 3.0L Turbo (M440i)",
          "family": "BMW B58",
          "url": "/collections/all/bt-fit-route-bmw-4-series-g23-b58?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-4-series-g23-b58&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-4-series-g23-b58",
          "engineTag": "bt-fit-engine-b58",
          "systems": [
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts"
          ],
          "systemCounts": {
            "turbo-forced-induction": 5,
            "intercooler": 1,
            "fuel-system": 8,
            "intake": 1,
            "exhaust": 4,
            "engine-parts": 2
          },
          "productCount": 15,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B58 — ZF8HP50/51 automatic",
          "family": "BMW B58 ZF8",
          "url": "/collections/all/bt-fit-route-bmw-4-series-g23-b58-zf8hp5x?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-4-series-g23-b58-zf8hp5x&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-4-series-g23-b58-zf8hp5x",
          "engineTag": "bt-fit-transmission-zf8hp45-50-51",
          "systems": [
            "engine-management",
            "transmission-driveline",
            "cooling"
          ],
          "systemCounts": {
            "engine-management": 1,
            "transmission-driveline": 7,
            "cooling": 1
          },
          "productCount": 7,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "430i xDrive / M440i xDrive — ATC-13",
          "family": "BMW ATC-13 xDrive",
          "url": "/collections/all/bt-fit-route-bmw-g23-xdrive-atc13?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-g23-xdrive-atc13&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-g23-xdrive-atc13",
          "engineTag": "bt-fit-transfer-atc13",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "4 Series Gran Coupe": {
      "F36": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 4 Series Gran Coupe F36",
          "url": "/collections/all/bt-fit-route-bmw-4-series-gran-coupe-f36-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-4-series-gran-coupe-f36-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-4-series-gran-coupe-f36-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 5
          },
          "productCount": 5,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "N55 3.0L Turbo (435i)",
          "family": "BMW N55",
          "url": "/collections/all/bt-fit-route-bmw-4-series-gran-coupe-f36-n55?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-4-series-gran-coupe-f36-n55&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-4-series-gran-coupe-f36-n55",
          "engineTag": "bt-fit-engine-n55",
          "systems": [
            "fuel-system",
            "engine-parts",
            "suspension-brakes"
          ],
          "systemCounts": {
            "fuel-system": 2,
            "engine-parts": 2,
            "suspension-brakes": 3
          },
          "productCount": 7,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B46/B48 2.0L Turbo (420i / 430i)",
          "family": "BMW B46/B48",
          "url": "/collections/all/bt-fit-route-bmw-4-series-gran-coupe-f36-b46-b48?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-4-series-gran-coupe-f36-b46-b48&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-4-series-gran-coupe-f36-b46-b48",
          "engineTag": "bt-fit-engine-b48",
          "systems": [
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "suspension-brakes"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2,
            "intercooler": 1,
            "fuel-system": 3,
            "intake": 1,
            "exhaust": 1,
            "suspension-brakes": 3
          },
          "productCount": 8,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "F36 LCI": [
        {
          "label": "B58",
          "family": "BMW 4 Series Gran Coupe F36 LCI",
          "url": "/collections/all/bt-fit-route-bmw-4-series-gran-coupe-f36-lci-b58?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-4-series-gran-coupe-f36-lci-b58&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-4-series-gran-coupe-f36-lci-b58",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 1,
            "wiring-sensors-displays": 1,
            "turbo-forced-induction": 6,
            "intercooler": 1,
            "fuel-system": 12,
            "intake": 1,
            "exhaust": 4,
            "engine-parts": 1,
            "suspension-brakes": 3
          },
          "engineTag": "bt-fit-engine-b58",
          "productCount": 22,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B58 — ZF8HP45/50/51 automatic",
          "family": "BMW B58 ZF8",
          "url": "/collections/all/bt-fit-route-bmw-4-series-gran-coupe-f36-lci-b58-zf8hp5x?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-4-series-gran-coupe-f36-lci-b58-zf8hp5x&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-4-series-gran-coupe-f36-lci-b58-zf8hp5x",
          "engineTag": "bt-fit-transmission-zf8hp45-50-51",
          "systems": [
            "engine-management",
            "transmission-driveline",
            "cooling",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 1,
            "transmission-driveline": 7,
            "cooling": 1,
            "suspension-brakes": 3
          },
          "productCount": 10,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "G26": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 4 Series Gran Coupe G26",
          "url": "/collections/all/bt-fit-route-bmw-4-series-gran-coupe-g26-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-4-series-gran-coupe-g26-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-4-series-gran-coupe-g26-chassis",
          "systems": [
            "engine-management",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 1,
            "suspension-brakes": 2
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B58 3.0L Turbo (M440i)",
          "family": "BMW B58",
          "url": "/collections/all/bt-fit-route-bmw-4-series-gran-coupe-g26-b58?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-4-series-gran-coupe-g26-b58&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-4-series-gran-coupe-g26-b58",
          "engineTag": "bt-fit-engine-b58",
          "systems": [
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts"
          ],
          "systemCounts": {
            "turbo-forced-induction": 5,
            "intercooler": 1,
            "fuel-system": 9,
            "intake": 1,
            "exhaust": 4,
            "engine-parts": 2
          },
          "productCount": 16,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B58 — ZF8HP50/51 automatic",
          "family": "BMW B58 ZF8",
          "url": "/collections/all/bt-fit-route-bmw-4-series-gran-coupe-g26-b58-zf8hp5x?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-4-series-gran-coupe-g26-b58-zf8hp5x&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-4-series-gran-coupe-g26-b58-zf8hp5x",
          "engineTag": "bt-fit-transmission-zf8hp45-50-51",
          "systems": [
            "engine-management",
            "transmission-driveline",
            "cooling"
          ],
          "systemCounts": {
            "engine-management": 1,
            "transmission-driveline": 7,
            "cooling": 1
          },
          "productCount": 7,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "xDrive — ATC-13",
          "family": "BMW ATC-13 xDrive",
          "url": "/collections/all/bt-fit-route-bmw-g26-xdrive-atc13?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-g26-xdrive-atc13&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-g26-xdrive-atc13",
          "engineTag": "bt-fit-transfer-atc13",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "5 Series": {
      "E34": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 5 Series E34",
          "url": "/collections/all/bt-fit-route-bmw-5-series-e34-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-5-series-e34-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-5-series-e34-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 3
          },
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "E39": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 5 Series E39",
          "url": "/collections/all/bt-fit-route-bmw-5-series-e39-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-5-series-e39-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-5-series-e39-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 3
          },
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "E60": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 5 Series E60",
          "url": "/collections/all/bt-fit-route-bmw-5-series-e60-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-5-series-e60-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-5-series-e60-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 4
          },
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "F11": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 5 Series F11",
          "url": "/collections/all/bt-fit-route-bmw-5-series-f11-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-5-series-f11-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-5-series-f11-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "G30": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 5 Series G30",
          "url": "/collections/all/bt-fit-route-bmw-5-series-g30-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-5-series-g30-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-5-series-g30-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 3
          },
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B48 2.0L Turbo (530i)",
          "family": "BMW B46/B48",
          "url": "/collections/all/bt-fit-route-bmw-5-series-g30-b48?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-5-series-g30-b48&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-5-series-g30-b48",
          "engineTag": "bt-fit-engine-b48",
          "systems": [
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "suspension-brakes"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2,
            "intercooler": 1,
            "fuel-system": 3,
            "intake": 1,
            "exhaust": 1,
            "suspension-brakes": 2
          },
          "productCount": 7,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B58 3.0L Turbo (540i)",
          "family": "BMW B58",
          "url": "/collections/all/bt-fit-route-bmw-5-series-g30-b58?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-5-series-g30-b58&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-5-series-g30-b58",
          "engineTag": "bt-fit-engine-b58",
          "systems": [
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "suspension-brakes"
          ],
          "systemCounts": {
            "turbo-forced-induction": 5,
            "intercooler": 1,
            "fuel-system": 5,
            "intake": 1,
            "exhaust": 3,
            "engine-parts": 2,
            "suspension-brakes": 2
          },
          "productCount": 14,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B58 — ZF8HP50/51 automatic",
          "family": "BMW B58 ZF8",
          "url": "/collections/all/bt-fit-route-bmw-5-series-g30-b58-zf8hp5x?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-5-series-g30-b58-zf8hp5x&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-5-series-g30-b58-zf8hp5x",
          "engineTag": "bt-fit-transmission-zf8hp45-50-51",
          "systems": [
            "engine-management",
            "transmission-driveline",
            "cooling",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 1,
            "transmission-driveline": 7,
            "cooling": 1,
            "suspension-brakes": 2
          },
          "productCount": 9,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "530i / 540i xDrive — ATC-13",
          "family": "BMW ATC-13 xDrive",
          "url": "/collections/all/bt-fit-route-bmw-g30-xdrive-atc13?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-g30-xdrive-atc13&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-g30-xdrive-atc13",
          "engineTag": "bt-fit-transfer-atc13",
          "systems": [
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "transmission-driveline": 1,
            "suspension-brakes": 2
          },
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "G60": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 5 Series G60",
          "url": "/collections/all/bt-fit-route-bmw-5-series-g60-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-5-series-g60-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-5-series-g60-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "F10": [
        {
          "label": "N63 / N63TU 4.4L Twin-Turbo V8 (550i)",
          "family": "BMW N63",
          "url": "/collections/all/bt-fit-route-bmw-5-series-f10-n63?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-5-series-f10-n63&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-5-series-f10-n63",
          "engineTag": "bt-fit-engine-n63",
          "systems": [
            "fuel-system",
            "engine-parts",
            "suspension-brakes"
          ],
          "systemCounts": {
            "fuel-system": 1,
            "engine-parts": 2,
            "suspension-brakes": 1
          },
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "5 Series / M5": {
      "F10": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 5 Series / M5 F10",
          "url": "/collections/all/bt-fit-route-bmw-5-series-m5-f10-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-5-series-m5-f10-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-5-series-m5-f10-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 6
          },
          "productCount": 6,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "S63 / S63TU",
          "family": "BMW 5 Series / M5 F10",
          "url": "/collections/all/bt-fit-route-bmw-5-series-m5-f10-s63?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-5-series-m5-f10-s63&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-5-series-m5-f10-s63",
          "systems": [
            "fuel-system",
            "engine-parts",
            "suspension-brakes"
          ],
          "systemCounts": {
            "fuel-system": 2,
            "engine-parts": 9,
            "suspension-brakes": 3
          },
          "engineTag": "bt-fit-engine-s63",
          "productCount": 14,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "5 Series Touring": {
      "G31": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 5 Series Touring G31",
          "url": "/collections/all/bt-fit-route-bmw-5-series-touring-g31-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-5-series-touring-g31-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-5-series-touring-g31-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 2
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B48 2.0L Turbo (530i)",
          "family": "BMW B46/B48",
          "url": "/collections/all/bt-fit-route-bmw-5-series-touring-g31-b48?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-5-series-touring-g31-b48&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-5-series-touring-g31-b48",
          "engineTag": "bt-fit-engine-b48",
          "systems": [
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "suspension-brakes"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "intercooler": 1,
            "fuel-system": 3,
            "intake": 1,
            "suspension-brakes": 1
          },
          "productCount": 5,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B58 3.0L Turbo (540i)",
          "family": "BMW B58",
          "url": "/collections/all/bt-fit-route-bmw-5-series-touring-g31-b58?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-5-series-touring-g31-b58&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-5-series-touring-g31-b58",
          "engineTag": "bt-fit-engine-b58",
          "systems": [
            "fuel-system",
            "engine-parts",
            "suspension-brakes"
          ],
          "systemCounts": {
            "fuel-system": 2,
            "engine-parts": 2,
            "suspension-brakes": 1
          },
          "productCount": 5,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "G61": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 5 Series Touring G61",
          "url": "/collections/all/bt-fit-route-bmw-5-series-touring-g61-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-5-series-touring-g61-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-5-series-touring-g61-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "6 Series": {
      "E63": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 6 Series E63",
          "url": "/collections/all/bt-fit-route-bmw-6-series-e63-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-6-series-e63-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-6-series-e63-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 2
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "E64": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 6 Series E64",
          "url": "/collections/all/bt-fit-route-bmw-6-series-e64-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-6-series-e64-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-6-series-e64-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "6 Series / M6": {
      "F06": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 6 Series / M6 F06",
          "url": "/collections/all/bt-fit-route-bmw-6-series-m6-f06-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-6-series-m6-f06-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-6-series-m6-f06-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 4
          },
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "S63 / S63TU 4.4L Twin-Turbo V8",
          "family": "BMW S63",
          "url": "/collections/all/bt-fit-route-bmw-6-series-m6-f06-s63?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-6-series-m6-f06-s63&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-6-series-m6-f06-s63",
          "engineTag": "bt-fit-engine-s63",
          "systems": [
            "fuel-system",
            "engine-parts",
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "fuel-system": 2,
            "engine-parts": 1,
            "clutch": 1,
            "transmission-driveline": 1,
            "suspension-brakes": 3
          },
          "productCount": 7,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "F12": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 6 Series / M6 F12",
          "url": "/collections/all/bt-fit-route-bmw-6-series-m6-f12-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-6-series-m6-f12-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-6-series-m6-f12-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "S63 / S63TU 4.4L Twin-Turbo V8",
          "family": "BMW S63",
          "url": "/collections/all/bt-fit-route-bmw-6-series-m6-f12-s63?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-6-series-m6-f12-s63&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-6-series-m6-f12-s63",
          "engineTag": "bt-fit-engine-s63",
          "systems": [
            "fuel-system",
            "engine-parts",
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "fuel-system": 2,
            "engine-parts": 1,
            "clutch": 1,
            "transmission-driveline": 1
          },
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "F13": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 6 Series / M6 F13",
          "url": "/collections/all/bt-fit-route-bmw-6-series-m6-f13-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-6-series-m6-f13-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-6-series-m6-f13-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "S63 / S63TU 4.4L Twin-Turbo V8",
          "family": "BMW S63",
          "url": "/collections/all/bt-fit-route-bmw-6-series-m6-f13-s63?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-6-series-m6-f13-s63&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-6-series-m6-f13-s63",
          "engineTag": "bt-fit-engine-s63",
          "systems": [
            "fuel-system",
            "engine-parts",
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "fuel-system": 2,
            "engine-parts": 1,
            "clutch": 1,
            "transmission-driveline": 1
          },
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "7 Series": {
      "E32": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 7 Series E32",
          "url": "/collections/all/bt-fit-route-bmw-7-series-e32-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-7-series-e32-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-7-series-e32-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "E38": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 7 Series E38",
          "url": "/collections/all/bt-fit-route-bmw-7-series-e38-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-7-series-e38-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-7-series-e38-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 2
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "G11": [
        {
          "label": "740i B58 — ZF8HP50/51 automatic",
          "family": "BMW B58 ZF8",
          "url": "/collections/all/bt-fit-route-bmw-7-series-g11-740i-b58-zf8hp5x?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-7-series-g11-740i-b58-zf8hp5x&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-7-series-g11-740i-b58-zf8hp5x",
          "engineTag": "bt-fit-transmission-zf8hp45-50-51",
          "systems": [
            "engine-management",
            "transmission-driveline",
            "cooling"
          ],
          "systemCounts": {
            "engine-management": 1,
            "transmission-driveline": 7,
            "cooling": 1
          },
          "productCount": 7,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "740i / 750i xDrive — ATC-13",
          "family": "BMW ATC-13 xDrive",
          "url": "/collections/all/bt-fit-route-bmw-g11-xdrive-atc13?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-g11-xdrive-atc13&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-g11-xdrive-atc13",
          "engineTag": "bt-fit-transfer-atc13",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "G12": [
        {
          "label": "740Li B58 — ZF8HP50/51 automatic",
          "family": "BMW B58 ZF8",
          "url": "/collections/all/bt-fit-route-bmw-7-series-g12-740li-b58-zf8hp5x?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-7-series-g12-740li-b58-zf8hp5x&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-7-series-g12-740li-b58-zf8hp5x",
          "engineTag": "bt-fit-transmission-zf8hp45-50-51",
          "systems": [
            "engine-management",
            "transmission-driveline",
            "cooling"
          ],
          "systemCounts": {
            "engine-management": 1,
            "transmission-driveline": 7,
            "cooling": 1
          },
          "productCount": 7,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "740i / 750i xDrive — ATC-13",
          "family": "BMW ATC-13 xDrive",
          "url": "/collections/all/bt-fit-route-bmw-g12-xdrive-atc13?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-g12-xdrive-atc13&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-g12-xdrive-atc13",
          "engineTag": "bt-fit-transfer-atc13",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "G70": [
        {
          "label": "xDrive — ATC-13",
          "family": "BMW ATC-13 xDrive",
          "url": "/collections/all/bt-fit-route-bmw-g70-xdrive-atc13?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-g70-xdrive-atc13&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-g70-xdrive-atc13",
          "engineTag": "bt-fit-transfer-atc13",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "8 Series": {
      "G14": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 8 Series G14",
          "url": "/collections/all/bt-fit-route-bmw-8-series-g14-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-8-series-g14-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-8-series-g14-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "840i / M850i xDrive — ATC-13",
          "family": "BMW ATC-13 xDrive",
          "url": "/collections/all/bt-fit-route-bmw-g14-xdrive-atc13?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-g14-xdrive-atc13&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-g14-xdrive-atc13",
          "engineTag": "bt-fit-transfer-atc13",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "G15": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW 8 Series G15",
          "url": "/collections/all/bt-fit-route-bmw-8-series-g15-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-8-series-g15-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-8-series-g15-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "840i / M850i xDrive — ATC-13",
          "family": "BMW ATC-13 xDrive",
          "url": "/collections/all/bt-fit-route-bmw-g15-xdrive-atc13?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-g15-xdrive-atc13&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-g15-xdrive-atc13",
          "engineTag": "bt-fit-transfer-atc13",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "M3 / M4": {
      "F80 / F82": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW M3 / M4 F80 / F82",
          "url": "/collections/all/bt-fit-route-bmw-m3-m4-f80-f82-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m3-m4-f80-f82-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m3-m4-f80-f82-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 15
          },
          "productCount": 15,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "M3 Touring": {
      "G81": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW M3 Touring G81",
          "url": "/collections/all/bt-fit-route-bmw-m3-touring-g81-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m3-touring-g81-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m3-touring-g81-chassis",
          "systems": [
            "engine-management",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 1,
            "suspension-brakes": 29
          },
          "productCount": 29,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "S58",
          "family": "BMW M3 Touring G81",
          "url": "/collections/all/bt-fit-route-bmw-m3-touring-g81-s58?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m3-touring-g81-s58&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m3-touring-g81-s58",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "transmission-driveline",
            "cooling",
            "suspension-brakes",
            "service-maintenance"
          ],
          "systemCounts": {
            "engine-management": 4,
            "wiring-sensors-displays": 2,
            "turbo-forced-induction": 4,
            "intercooler": 2,
            "fuel-system": 10,
            "intake": 4,
            "exhaust": 6,
            "engine-parts": 11,
            "transmission-driveline": 2,
            "cooling": 1,
            "suspension-brakes": 22,
            "service-maintenance": 1
          },
          "engineTag": "bt-fit-engine-s58",
          "productCount": 55,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "S58 — ZF8HP76 automatic",
          "family": "BMW S58 ZF8",
          "url": "/collections/all/bt-fit-route-bmw-m3-g81-s58-zf8hp76?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m3-g81-s58-zf8hp76&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m3-g81-s58-zf8hp76",
          "engineTag": "bt-fit-transmission-zf8hp75-76",
          "systems": [
            "engine-management",
            "transmission-driveline",
            "cooling",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 2,
            "transmission-driveline": 7,
            "cooling": 1,
            "suspension-brakes": 29
          },
          "productCount": 36,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "M4 Convertible": {
      "G83": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW M4 Convertible G83",
          "url": "/collections/all/bt-fit-route-bmw-m4-convertible-g83-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m4-convertible-g83-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m4-convertible-g83-chassis",
          "systems": [
            "engine-management",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 1,
            "suspension-brakes": 13
          },
          "productCount": 13,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "S58",
          "family": "BMW M4 Convertible G83",
          "url": "/collections/all/bt-fit-route-bmw-m4-convertible-g83-s58?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m4-convertible-g83-s58&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m4-convertible-g83-s58",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "transmission-driveline",
            "cooling",
            "service-maintenance"
          ],
          "systemCounts": {
            "engine-management": 4,
            "wiring-sensors-displays": 2,
            "turbo-forced-induction": 5,
            "intercooler": 2,
            "fuel-system": 11,
            "intake": 4,
            "exhaust": 7,
            "engine-parts": 11,
            "transmission-driveline": 2,
            "cooling": 1,
            "service-maintenance": 1
          },
          "engineTag": "bt-fit-engine-s58",
          "productCount": 35,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "S58 — ZF8HP76 automatic",
          "family": "BMW S58 ZF8",
          "url": "/collections/all/bt-fit-route-bmw-m4-g83-s58-zf8hp76?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m4-g83-s58-zf8hp76&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m4-g83-s58-zf8hp76",
          "engineTag": "bt-fit-transmission-zf8hp75-76",
          "systems": [
            "engine-management",
            "transmission-driveline",
            "cooling",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 2,
            "transmission-driveline": 7,
            "cooling": 1,
            "suspension-brakes": 13
          },
          "productCount": 20,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "M4 Competition xDrive — ATC-13",
          "family": "BMW ATC-13 xDrive",
          "url": "/collections/all/bt-fit-route-bmw-g83-m4-xdrive-atc13?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-g83-m4-xdrive-atc13&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-g83-m4-xdrive-atc13",
          "engineTag": "bt-fit-transfer-atc13",
          "systems": [
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "transmission-driveline": 1,
            "suspension-brakes": 4
          },
          "productCount": 5,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "M5": {
      "F90": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW M5 F90",
          "url": "/collections/all/bt-fit-route-bmw-m5-f90-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m5-f90-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m5-f90-chassis",
          "systems": [
            "engine-management",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 1,
            "suspension-brakes": 9
          },
          "productCount": 9,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "S63 / S63TU",
          "family": "BMW M5 F90",
          "url": "/collections/all/bt-fit-route-bmw-m5-f90-s63?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m5-f90-s63&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m5-f90-s63",
          "systems": [
            "engine-management",
            "turbo-forced-induction",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "suspension-brakes",
            "service-maintenance"
          ],
          "systemCounts": {
            "engine-management": 2,
            "turbo-forced-induction": 2,
            "fuel-system": 5,
            "intake": 1,
            "exhaust": 3,
            "engine-parts": 7,
            "suspension-brakes": 8,
            "service-maintenance": 1
          },
          "engineTag": "bt-fit-engine-s63",
          "productCount": 25,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "S63 — ZF8HP75 automatic",
          "family": "BMW S63 ZF8",
          "url": "/collections/all/bt-fit-route-bmw-m5-f90-s63-zf8hp75?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m5-f90-s63-zf8hp75&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m5-f90-s63-zf8hp75",
          "engineTag": "bt-fit-transmission-zf8hp75",
          "systems": [
            "engine-management",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 2,
            "transmission-driveline": 5,
            "suspension-brakes": 8
          },
          "productCount": 13,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "M5 xDrive — ATC-13",
          "family": "BMW ATC-13 xDrive",
          "url": "/collections/all/bt-fit-route-bmw-f90-m5-atc13?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-f90-m5-atc13&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-f90-m5-atc13",
          "engineTag": "bt-fit-transfer-atc13",
          "systems": [
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "transmission-driveline": 1,
            "suspension-brakes": 6
          },
          "productCount": 7,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "G90": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW M5 G90",
          "url": "/collections/all/bt-fit-route-bmw-m5-g90-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m5-g90-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m5-g90-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 4
          },
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "S68 4.4L Twin-Turbo V8",
          "family": "BMW S68",
          "url": "/collections/all/bt-fit-route-bmw-m5-g90-s68?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m5-g90-s68&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m5-g90-s68",
          "engineTag": "bt-fit-engine-s68",
          "systems": [
            "turbo-forced-induction",
            "exhaust",
            "suspension-brakes"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "exhaust": 1,
            "suspension-brakes": 4
          },
          "productCount": 5,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "M5 Touring": {
      "G99": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW M5 Touring G99",
          "url": "/collections/all/bt-fit-route-bmw-m5-touring-g99-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m5-touring-g99-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m5-touring-g99-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 3
          },
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "M8": {
      "F91": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW M8 F91",
          "url": "/collections/all/bt-fit-route-bmw-m8-f91-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m8-f91-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m8-f91-chassis",
          "systems": [
            "engine-management",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 1,
            "suspension-brakes": 3
          },
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "S63 / S63TU",
          "family": "BMW M8 F91",
          "url": "/collections/all/bt-fit-route-bmw-m8-f91-s63?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m8-f91-s63&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m8-f91-s63",
          "systems": [
            "engine-management",
            "turbo-forced-induction",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "suspension-brakes",
            "service-maintenance"
          ],
          "systemCounts": {
            "engine-management": 2,
            "turbo-forced-induction": 2,
            "fuel-system": 4,
            "intake": 1,
            "exhaust": 2,
            "engine-parts": 2,
            "suspension-brakes": 2,
            "service-maintenance": 1
          },
          "engineTag": "bt-fit-engine-s63",
          "productCount": 12,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "S63 — ZF8HP75 automatic",
          "family": "BMW S63 ZF8",
          "url": "/collections/all/bt-fit-route-bmw-m8-f91-s63-zf8hp75?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m8-f91-s63-zf8hp75&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m8-f91-s63-zf8hp75",
          "engineTag": "bt-fit-transmission-zf8hp75",
          "systems": [
            "engine-management",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 2,
            "transmission-driveline": 5,
            "suspension-brakes": 2
          },
          "productCount": 7,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "M8 xDrive — ATC-13",
          "family": "BMW ATC-13 xDrive",
          "url": "/collections/all/bt-fit-route-bmw-f91-m8-atc13?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-f91-m8-atc13&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-f91-m8-atc13",
          "engineTag": "bt-fit-transfer-atc13",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "F92": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW M8 F92",
          "url": "/collections/all/bt-fit-route-bmw-m8-f92-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m8-f92-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m8-f92-chassis",
          "systems": [
            "engine-management",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 1,
            "suspension-brakes": 7
          },
          "productCount": 7,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "S63 / S63TU",
          "family": "BMW M8 F92",
          "url": "/collections/all/bt-fit-route-bmw-m8-f92-s63?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m8-f92-s63&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m8-f92-s63",
          "systems": [
            "engine-management",
            "turbo-forced-induction",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "suspension-brakes",
            "service-maintenance"
          ],
          "systemCounts": {
            "engine-management": 2,
            "turbo-forced-induction": 2,
            "fuel-system": 4,
            "intake": 1,
            "exhaust": 2,
            "engine-parts": 2,
            "suspension-brakes": 6,
            "service-maintenance": 1
          },
          "engineTag": "bt-fit-engine-s63",
          "productCount": 16,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "S63 — ZF8HP75 automatic",
          "family": "BMW S63 ZF8",
          "url": "/collections/all/bt-fit-route-bmw-m8-f92-s63-zf8hp75?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m8-f92-s63-zf8hp75&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m8-f92-s63-zf8hp75",
          "engineTag": "bt-fit-transmission-zf8hp75",
          "systems": [
            "engine-management",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 2,
            "transmission-driveline": 5,
            "suspension-brakes": 6
          },
          "productCount": 11,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "M8 xDrive — ATC-13",
          "family": "BMW ATC-13 xDrive",
          "url": "/collections/all/bt-fit-route-bmw-f92-m8-atc13?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-f92-m8-atc13&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-f92-m8-atc13",
          "engineTag": "bt-fit-transfer-atc13",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "F93": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW M8 F93",
          "url": "/collections/all/bt-fit-route-bmw-m8-f93-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m8-f93-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m8-f93-chassis",
          "systems": [
            "engine-management",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 1,
            "suspension-brakes": 4
          },
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "S63 / S63TU",
          "family": "BMW M8 F93",
          "url": "/collections/all/bt-fit-route-bmw-m8-f93-s63?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m8-f93-s63&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m8-f93-s63",
          "systems": [
            "engine-management",
            "turbo-forced-induction",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "suspension-brakes",
            "service-maintenance"
          ],
          "systemCounts": {
            "engine-management": 2,
            "turbo-forced-induction": 2,
            "fuel-system": 4,
            "intake": 1,
            "exhaust": 2,
            "engine-parts": 2,
            "suspension-brakes": 3,
            "service-maintenance": 1
          },
          "engineTag": "bt-fit-engine-s63",
          "productCount": 13,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "S63 — ZF8HP75 automatic",
          "family": "BMW S63 ZF8",
          "url": "/collections/all/bt-fit-route-bmw-m8-f93-s63-zf8hp75?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-m8-f93-s63-zf8hp75&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-m8-f93-s63-zf8hp75",
          "engineTag": "bt-fit-transmission-zf8hp75",
          "systems": [
            "engine-management",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 2,
            "transmission-driveline": 5,
            "suspension-brakes": 3
          },
          "productCount": 8,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "M8 xDrive — ATC-13",
          "family": "BMW ATC-13 xDrive",
          "url": "/collections/all/bt-fit-route-bmw-f93-m8-atc13?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-f93-m8-atc13&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-f93-m8-atc13",
          "engineTag": "bt-fit-transfer-atc13",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "X1": {
      "E84": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW X1 E84",
          "url": "/collections/all/bt-fit-route-bmw-x1-e84-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-x1-e84-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-x1-e84-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "F48": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW X1 F48",
          "url": "/collections/all/bt-fit-route-bmw-x1-f48-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-x1-f48-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-x1-f48-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 2
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B48 2.0L Turbo",
          "family": "BMW B46/B48",
          "url": "/collections/all/bt-fit-route-bmw-x1-f48-b48?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-x1-f48-b48&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-x1-f48-b48",
          "engineTag": "bt-fit-engine-b48",
          "systems": [
            "turbo-forced-induction",
            "exhaust"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "exhaust": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "X2": {
      "F39": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW X2 F39",
          "url": "/collections/all/bt-fit-route-bmw-x2-f39-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-x2-f39-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-x2-f39-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 2
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B48 2.0L Turbo",
          "family": "BMW B46/B48",
          "url": "/collections/all/bt-fit-route-bmw-x2-f39-b48?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-x2-f39-b48&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-x2-f39-b48",
          "engineTag": "bt-fit-engine-b48",
          "systems": [
            "turbo-forced-induction",
            "exhaust"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "exhaust": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "U10": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW X2 U10",
          "url": "/collections/all/bt-fit-route-bmw-x2-u10-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-x2-u10-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-x2-u10-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "X3": {
      "F25": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW X3 F25",
          "url": "/collections/all/bt-fit-route-bmw-x3-f25-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-x3-f25-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-x3-f25-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "G01": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW X3 G01",
          "url": "/collections/all/bt-fit-route-bmw-x3-g01-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-x3-g01-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-x3-g01-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 3
          },
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B48 2.0L Turbo (30i)",
          "family": "BMW B46/B48",
          "url": "/collections/all/bt-fit-route-bmw-x3-g01-b48?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-x3-g01-b48&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-x3-g01-b48",
          "engineTag": "bt-fit-engine-b48",
          "systems": [
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2,
            "intercooler": 1,
            "fuel-system": 3,
            "intake": 1,
            "exhaust": 1
          },
          "productCount": 5,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B58 3.0L Turbo (M40i)",
          "family": "BMW B58",
          "url": "/collections/all/bt-fit-route-bmw-x3-g01-b58?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-x3-g01-b58&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-x3-g01-b58",
          "engineTag": "bt-fit-engine-b58",
          "systems": [
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts"
          ],
          "systemCounts": {
            "turbo-forced-induction": 5,
            "intercooler": 1,
            "fuel-system": 5,
            "intake": 1,
            "exhaust": 3,
            "engine-parts": 2
          },
          "productCount": 12,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B58 — ZF8HP50/51 automatic",
          "family": "BMW B58 ZF8",
          "url": "/collections/all/bt-fit-route-bmw-x3-g01-b58-zf8hp5x?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-x3-g01-b58-zf8hp5x&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-x3-g01-b58-zf8hp5x",
          "engineTag": "bt-fit-transmission-zf8hp45-50-51",
          "systems": [
            "engine-management",
            "transmission-driveline",
            "cooling"
          ],
          "systemCounts": {
            "engine-management": 1,
            "transmission-driveline": 7,
            "cooling": 1
          },
          "productCount": 7,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "xDrive — ATC-13",
          "family": "BMW ATC-13 xDrive",
          "url": "/collections/all/bt-fit-route-bmw-g01-x3-atc13?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-g01-x3-atc13&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-g01-x3-atc13",
          "engineTag": "bt-fit-transfer-atc13",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "G45": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW X3 G45",
          "url": "/collections/all/bt-fit-route-bmw-x3-g45-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-x3-g45-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-x3-g45-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "X3 M": {
      "F97": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW X3 M F97",
          "url": "/collections/all/bt-fit-route-bmw-x3-m-f97-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-x3-m-f97-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-x3-m-f97-chassis",
          "systems": [
            "engine-management",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 1,
            "transmission-driveline": 1,
            "suspension-brakes": 7
          },
          "productCount": 7,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "S58",
          "family": "BMW X3 M F97",
          "url": "/collections/all/bt-fit-route-bmw-x3-m-f97-s58?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-x3-m-f97-s58&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-x3-m-f97-s58",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "transmission-driveline",
            "suspension-brakes",
            "service-maintenance"
          ],
          "systemCounts": {
            "engine-management": 6,
            "wiring-sensors-displays": 2,
            "turbo-forced-induction": 3,
            "intercooler": 2,
            "fuel-system": 11,
            "intake": 3,
            "exhaust": 2,
            "engine-parts": 9,
            "transmission-driveline": 3,
            "suspension-brakes": 6,
            "service-maintenance": 1
          },
          "engineTag": "bt-fit-engine-s58",
          "productCount": 34,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "S58 — ZF8HP75 automatic",
          "family": "BMW S58 ZF8",
          "url": "/collections/all/bt-fit-route-bmw-x3m-f97-s58-zf8hp75?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-x3m-f97-s58-zf8hp75&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-x3m-f97-s58-zf8hp75",
          "engineTag": "bt-fit-transmission-zf8hp75-76",
          "systems": [
            "engine-management",
            "transmission-driveline",
            "cooling"
          ],
          "systemCounts": {
            "engine-management": 1,
            "transmission-driveline": 7,
            "cooling": 1
          },
          "productCount": 7,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "X3M — ATC-13",
          "family": "BMW ATC-13 xDrive",
          "url": "/collections/all/bt-fit-route-bmw-f97-x3m-atc13?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-f97-x3m-atc13&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-f97-x3m-atc13",
          "engineTag": "bt-fit-transfer-atc13",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "X4": {
      "F26": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW X4 F26",
          "url": "/collections/all/bt-fit-route-bmw-x4-f26-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-x4-f26-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-x4-f26-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 2
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "G02": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW X4 G02",
          "url": "/collections/all/bt-fit-route-bmw-x4-g02-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-x4-g02-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-x4-g02-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 4
          },
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B48 2.0L Turbo (30i)",
          "family": "BMW B46/B48",
          "url": "/collections/all/bt-fit-route-bmw-x4-g02-b48?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-x4-g02-b48&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-x4-g02-b48",
          "engineTag": "bt-fit-engine-b48",
          "systems": [
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2,
            "intercooler": 1,
            "fuel-system": 3,
            "intake": 1,
            "exhaust": 1
          },
          "productCount": 5,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B58 3.0L Turbo (M40i)",
          "family": "BMW B58",
          "url": "/collections/all/bt-fit-route-bmw-x4-g02-b58?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-x4-g02-b58&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-x4-g02-b58",
          "engineTag": "bt-fit-engine-b58",
          "systems": [
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts"
          ],
          "systemCounts": {
            "turbo-forced-induction": 4,
            "intercooler": 1,
            "fuel-system": 5,
            "intake": 1,
            "exhaust": 3,
            "engine-parts": 2
          },
          "productCount": 11,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B58 — ZF8HP50/51 automatic",
          "family": "BMW B58 ZF8",
          "url": "/collections/all/bt-fit-route-bmw-x4-g02-b58-zf8hp5x?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-x4-g02-b58-zf8hp5x&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-x4-g02-b58-zf8hp5x",
          "engineTag": "bt-fit-transmission-zf8hp45-50-51",
          "systems": [
            "engine-management",
            "transmission-driveline",
            "cooling"
          ],
          "systemCounts": {
            "engine-management": 1,
            "transmission-driveline": 7,
            "cooling": 1
          },
          "productCount": 7,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "xDrive — ATC-13",
          "family": "BMW ATC-13 xDrive",
          "url": "/collections/all/bt-fit-route-bmw-g02-x4-atc13?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-g02-x4-atc13&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-g02-x4-atc13",
          "engineTag": "bt-fit-transfer-atc13",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "X4 M": {
      "F98": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW X4 M F98",
          "url": "/collections/all/bt-fit-route-bmw-x4-m-f98-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-x4-m-f98-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-x4-m-f98-chassis",
          "systems": [
            "engine-management",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 1,
            "transmission-driveline": 1,
            "suspension-brakes": 7
          },
          "productCount": 7,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "S58",
          "family": "BMW X4 M F98",
          "url": "/collections/all/bt-fit-route-bmw-x4-m-f98-s58?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-x4-m-f98-s58&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-x4-m-f98-s58",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "transmission-driveline",
            "suspension-brakes",
            "service-maintenance"
          ],
          "systemCounts": {
            "engine-management": 6,
            "wiring-sensors-displays": 2,
            "turbo-forced-induction": 2,
            "intercooler": 1,
            "fuel-system": 10,
            "intake": 1,
            "exhaust": 2,
            "engine-parts": 8,
            "transmission-driveline": 3,
            "suspension-brakes": 6,
            "service-maintenance": 1
          },
          "engineTag": "bt-fit-engine-s58",
          "productCount": 31,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "S58 — ZF8HP75 automatic",
          "family": "BMW S58 ZF8",
          "url": "/collections/all/bt-fit-route-bmw-x4m-f98-s58-zf8hp75?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-x4m-f98-s58-zf8hp75&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-x4m-f98-s58-zf8hp75",
          "engineTag": "bt-fit-transmission-zf8hp75-76",
          "systems": [
            "engine-management",
            "transmission-driveline",
            "cooling"
          ],
          "systemCounts": {
            "engine-management": 1,
            "transmission-driveline": 7,
            "cooling": 1
          },
          "productCount": 7,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "X4M — ATC-13",
          "family": "BMW ATC-13 xDrive",
          "url": "/collections/all/bt-fit-route-bmw-f98-x4m-atc13?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-f98-x4m-atc13&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-f98-x4m-atc13",
          "engineTag": "bt-fit-transfer-atc13",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "X5": {
      "E53": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW X5 E53",
          "url": "/collections/all/bt-fit-route-bmw-x5-e53-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-x5-e53-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-x5-e53-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 4
          },
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "F15": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW X5 F15",
          "url": "/collections/all/bt-fit-route-bmw-x5-f15-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-x5-f15-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-x5-f15-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 2
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "G05": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW X5 G05",
          "url": "/collections/all/bt-fit-route-bmw-x5-g05-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-x5-g05-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-x5-g05-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 4
          },
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B58 3.0L Turbo (40i)",
          "family": "BMW B58",
          "url": "/collections/all/bt-fit-route-bmw-x5-g05-b58?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-x5-g05-b58&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-x5-g05-b58",
          "engineTag": "bt-fit-engine-b58",
          "systems": [
            "fuel-system",
            "engine-parts"
          ],
          "systemCounts": {
            "fuel-system": 2,
            "engine-parts": 2
          },
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "xDrive — ATC-13",
          "family": "BMW ATC-13 xDrive",
          "url": "/collections/all/bt-fit-route-bmw-g05-x5-atc13?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-g05-x5-atc13&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-g05-x5-atc13",
          "engineTag": "bt-fit-transfer-atc13",
          "systems": [
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "transmission-driveline": 1,
            "suspension-brakes": 1
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "X5 M": {
      "F85": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW X5 M F85",
          "url": "/collections/all/bt-fit-route-bmw-x5-m-f85-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-x5-m-f85-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-x5-m-f85-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 2
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "F95": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW X5 M F95",
          "url": "/collections/all/bt-fit-route-bmw-x5-m-f95-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-x5-m-f95-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-x5-m-f95-chassis",
          "systems": [
            "engine-management",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 1,
            "suspension-brakes": 4
          },
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "S63 / S63TU",
          "family": "BMW X5 M F95",
          "url": "/collections/all/bt-fit-route-bmw-x5-m-f95-s63?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-x5-m-f95-s63&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-x5-m-f95-s63",
          "systems": [
            "engine-management",
            "turbo-forced-induction",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "transmission-driveline",
            "suspension-brakes",
            "service-maintenance"
          ],
          "systemCounts": {
            "engine-management": 2,
            "turbo-forced-induction": 1,
            "fuel-system": 2,
            "intake": 1,
            "exhaust": 1,
            "engine-parts": 2,
            "transmission-driveline": 1,
            "suspension-brakes": 3,
            "service-maintenance": 1
          },
          "engineTag": "bt-fit-engine-s63",
          "productCount": 11,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "S63 — ZF8HP75 automatic",
          "family": "BMW S63 ZF8",
          "url": "/collections/all/bt-fit-route-bmw-x5m-f95-s63-zf8hp75?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-x5m-f95-s63-zf8hp75&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-x5m-f95-s63-zf8hp75",
          "engineTag": "bt-fit-transmission-zf8hp75",
          "systems": [
            "engine-management",
            "transmission-driveline"
          ],
          "systemCounts": {
            "engine-management": 1,
            "transmission-driveline": 5
          },
          "productCount": 5,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "X5M — ATC-13",
          "family": "BMW ATC-13 xDrive",
          "url": "/collections/all/bt-fit-route-bmw-f95-x5m-atc13?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-f95-x5m-atc13&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-f95-x5m-atc13",
          "engineTag": "bt-fit-transfer-atc13",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "X6": {
      "F16": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW X6 F16",
          "url": "/collections/all/bt-fit-route-bmw-x6-f16-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-x6-f16-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-x6-f16-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 3
          },
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "G06": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW X6 G06",
          "url": "/collections/all/bt-fit-route-bmw-x6-g06-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-x6-g06-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-x6-g06-chassis",
          "systems": [
            "engine-management",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 1,
            "suspension-brakes": 3
          },
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B58 3.0L Turbo (40i)",
          "family": "BMW B58",
          "url": "/collections/all/bt-fit-route-bmw-x6-g06-b58?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-x6-g06-b58&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-x6-g06-b58",
          "engineTag": "bt-fit-engine-b58",
          "systems": [
            "fuel-system",
            "engine-parts"
          ],
          "systemCounts": {
            "fuel-system": 2,
            "engine-parts": 2
          },
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "xDrive — ATC-13",
          "family": "BMW ATC-13 xDrive",
          "url": "/collections/all/bt-fit-route-bmw-g06-x6-atc13?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-g06-x6-atc13&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-g06-x6-atc13",
          "engineTag": "bt-fit-transfer-atc13",
          "systems": [
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "transmission-driveline": 1,
            "suspension-brakes": 1
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "X6 M": {
      "F86": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW X6 M F86",
          "url": "/collections/all/bt-fit-route-bmw-x6-m-f86-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-x6-m-f86-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-x6-m-f86-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 2
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "F96": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW X6 M F96",
          "url": "/collections/all/bt-fit-route-bmw-x6-m-f96-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-x6-m-f96-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-x6-m-f96-chassis",
          "systems": [
            "engine-management",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 1,
            "suspension-brakes": 4
          },
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "S63 / S63TU",
          "family": "BMW X6 M F96",
          "url": "/collections/all/bt-fit-route-bmw-x6-m-f96-s63?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-x6-m-f96-s63&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-x6-m-f96-s63",
          "systems": [
            "engine-management",
            "turbo-forced-induction",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "transmission-driveline",
            "suspension-brakes",
            "service-maintenance"
          ],
          "systemCounts": {
            "engine-management": 2,
            "turbo-forced-induction": 1,
            "fuel-system": 2,
            "intake": 1,
            "exhaust": 1,
            "engine-parts": 2,
            "transmission-driveline": 1,
            "suspension-brakes": 3,
            "service-maintenance": 1
          },
          "engineTag": "bt-fit-engine-s63",
          "productCount": 11,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "S63 — ZF8HP75 automatic",
          "family": "BMW S63 ZF8",
          "url": "/collections/all/bt-fit-route-bmw-x6m-f96-s63-zf8hp75?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-x6m-f96-s63-zf8hp75&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-x6m-f96-s63-zf8hp75",
          "engineTag": "bt-fit-transmission-zf8hp75",
          "systems": [
            "engine-management",
            "transmission-driveline"
          ],
          "systemCounts": {
            "engine-management": 1,
            "transmission-driveline": 5
          },
          "productCount": 5,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "X6M — ATC-13",
          "family": "BMW ATC-13 xDrive",
          "url": "/collections/all/bt-fit-route-bmw-f96-x6m-atc13?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-f96-x6m-atc13&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-f96-x6m-atc13",
          "engineTag": "bt-fit-transfer-atc13",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "X7": {
      "G07": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW X7 G07",
          "url": "/collections/all/bt-fit-route-bmw-x7-g07-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-x7-g07-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-x7-g07-chassis",
          "systems": [
            "engine-management",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 1,
            "suspension-brakes": 2
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B58 3.0L Turbo (40i)",
          "family": "BMW B58",
          "url": "/collections/all/bt-fit-route-bmw-x7-g07-b58?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-x7-g07-b58&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-x7-g07-b58",
          "engineTag": "bt-fit-engine-b58",
          "systems": [
            "fuel-system",
            "engine-parts"
          ],
          "systemCounts": {
            "fuel-system": 2,
            "engine-parts": 2
          },
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "xDrive — ATC-13",
          "family": "BMW ATC-13 xDrive",
          "url": "/collections/all/bt-fit-route-bmw-g07-x7-atc13?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-g07-x7-atc13&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-g07-x7-atc13",
          "engineTag": "bt-fit-transfer-atc13",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "XM": {
      "G09": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW XM G09",
          "url": "/collections/all/bt-fit-route-bmw-xm-g09-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-xm-g09-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-xm-g09-chassis",
          "systems": [
            "engine-management",
            "suspension-brakes"
          ],
          "systemCounts": {
            "engine-management": 1,
            "suspension-brakes": 3
          },
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "XM — ATC-13",
          "family": "BMW ATC-13 xDrive",
          "url": "/collections/all/bt-fit-route-bmw-g09-xm-atc13?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-g09-xm-atc13&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-g09-xm-atc13",
          "engineTag": "bt-fit-transfer-atc13",
          "systems": [
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "transmission-driveline": 1,
            "suspension-brakes": 2
          },
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Z4": {
      "E85": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW Z4 E85",
          "url": "/collections/all/bt-fit-route-bmw-z4-e85-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-z4-e85-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-z4-e85-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 2
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "E86": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW Z4 E86",
          "url": "/collections/all/bt-fit-route-bmw-z4-e86-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-z4-e86-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-z4-e86-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "E89": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW Z4 E89",
          "url": "/collections/all/bt-fit-route-bmw-z4-e89-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-z4-e89-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-z4-e89-chassis",
          "systems": [
            "turbo-forced-induction",
            "exhaust",
            "suspension-brakes"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "exhaust": 1,
            "suspension-brakes": 1
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "N54 3.0L Twin-Turbo",
          "family": "BMW N54",
          "url": "/collections/all/bt-fit-route-bmw-z4-e89-n54?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-z4-e89-n54&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-z4-e89-n54",
          "engineTag": "bt-fit-engine-n54",
          "systems": [
            "turbo-forced-induction",
            "exhaust",
            "engine-parts",
            "suspension-brakes"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2,
            "exhaust": 1,
            "engine-parts": 3,
            "suspension-brakes": 1
          },
          "productCount": 6,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "G29": [
        {
          "label": "Chassis fitment (suspension / brakes / body)",
          "family": "BMW Z4 G29",
          "url": "/collections/all/bt-fit-route-bmw-z4-g29-chassis?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-z4-g29-chassis&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-z4-g29-chassis",
          "systems": [
            "suspension-brakes"
          ],
          "systemCounts": {
            "suspension-brakes": 19
          },
          "productCount": 19,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "B58 3.0L Turbo (M40i)",
          "family": "BMW B58",
          "url": "/collections/all/bt-fit-route-bmw-z4-g29-b58?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-z4-g29-b58&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-z4-g29-b58",
          "engineTag": "bt-fit-engine-b58",
          "systems": [
            "fuel-system",
            "engine-parts",
            "suspension-brakes"
          ],
          "systemCounts": {
            "fuel-system": 4,
            "engine-parts": 2,
            "suspension-brakes": 19
          },
          "productCount": 25,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Transmission Family / Custom": {
      "ZF 8HP51": [
        {
          "label": "2021+ Mild-Hybrid 8HP51",
          "family": "BMW ZF8",
          "url": "/collections/all/bt-fit-route-bmw-transmission-family-2021-mild-hybrid-8hp51?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-transmission-family-2021-mild-hybrid-8hp51&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-transmission-family-2021-mild-hybrid-8hp51",
          "engineTag": "bt-fit-transmission-zf8hp51-mhev",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "6 Series GT": {
      "G32": [
        {
          "label": "640i xDrive — ATC-13",
          "family": "BMW ATC-13 xDrive",
          "url": "/collections/all/bt-fit-route-bmw-g32-640i-xdrive-atc13?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-g32-640i-xdrive-atc13&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-g32-640i-xdrive-atc13",
          "engineTag": "bt-fit-transfer-atc13",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "8 Series Gran Coupe": {
      "G16": [
        {
          "label": "840i / M850i xDrive — ATC-13",
          "family": "BMW ATC-13 xDrive",
          "url": "/collections/all/bt-fit-route-bmw-g16-xdrive-atc13?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-g16-xdrive-atc13&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-g16-xdrive-atc13",
          "engineTag": "bt-fit-transfer-atc13",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Engine Family / Custom": {
      "B58 Gen 3": [
        {
          "label": "Kompact EM VR58 BOV",
          "family": "BMW B58 Gen3",
          "url": "/collections/all/bt-fit-route-bmw-engine-family-b58-gen3-bov?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-engine-family-b58-gen3-bov&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-engine-family-b58-gen3-bov",
          "engineTag": "bt-fit-engine-b58-gen3",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Component Family / Custom": {
      "Kompact EM VR9": [
        {
          "label": "Kompact EM",
          "family": "Turbosmart Component Family",
          "url": "/collections/all/bt-fit-route-bmw-kompact-em-vr9?bbt_vehicle=1&bbt_route=bt-fit-route-bmw-kompact-em-vr9&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-bmw-kompact-em-vr9",
          "engineTag": "bt-fit-component-bmw-kompact-em-vr9",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "Audi": {
    "S3": {
      "8P": [
        {
          "label": "EA113 2.0T",
          "family": "VW / Audi EA113",
          "url": "/collections/all/bt-fit-route-audi-s3-8p-ea113?bbt_vehicle=1&bbt_route=bt-fit-route-audi-s3-8p-ea113&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-audi-s3-8p-ea113",
          "engineTag": "bt-fit-engine-ea113",
          "systems": [
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "engine-parts",
            "ignition",
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "intercooler": 1,
            "fuel-system": 3,
            "engine-parts": 2,
            "ignition": 1,
            "clutch": 1,
            "transmission-driveline": 1,
            "suspension-brakes": 1
          },
          "productCount": 9,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "EA113 2.0T — 6-speed manual",
          "family": "VAG Manual",
          "url": "/collections/all/bt-fit-route-audi-s3-8p-ea113-manual?bbt_vehicle=1&bbt_route=bt-fit-route-audi-s3-8p-ea113-manual&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-audi-s3-8p-ea113-manual",
          "engineTag": "bt-fit-engine-ea113",
          "systems": [
            "engine-parts",
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "engine-parts": 1,
            "clutch": 1,
            "transmission-driveline": 1
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "8V": [
        {
          "label": "EA888 2.0T",
          "family": "VW / Audi EA888",
          "url": "/collections/all/bt-fit-route-audi-s3-8v-ea888?bbt_vehicle=1&bbt_route=bt-fit-route-audi-s3-8v-ea888&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-audi-s3-8v-ea888",
          "engineTag": "bt-fit-engine-ea888",
          "systems": [
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "wiring-sensors-displays": 1,
            "turbo-forced-induction": 7,
            "intercooler": 2,
            "fuel-system": 3,
            "intake": 3,
            "exhaust": 2,
            "engine-parts": 6,
            "ignition": 2,
            "clutch": 2,
            "transmission-driveline": 4,
            "suspension-brakes": 2
          },
          "productCount": 28,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "EA888 Gen 3 — 6-speed manual",
          "family": "VAG Manual",
          "url": "/collections/all/bt-fit-route-audi-s3-8v-ea888-manual?bbt_vehicle=1&bbt_route=bt-fit-route-audi-s3-8v-ea888-manual&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-audi-s3-8v-ea888-manual",
          "engineTag": "bt-fit-engine-ea888",
          "systems": [
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "clutch": 1,
            "transmission-driveline": 1,
            "suspension-brakes": 1
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "DQ250 6-speed DSG",
          "family": "VAG DQ250",
          "url": "/collections/all/bt-fit-route-audi-s3-8v-dq250?bbt_vehicle=1&bbt_route=bt-fit-route-audi-s3-8v-dq250&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-audi-s3-8v-dq250",
          "engineTag": "bt-fit-transmission-dq250",
          "systems": [
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "clutch": 1,
            "transmission-driveline": 1,
            "suspension-brakes": 1
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "DQ381 7-speed DSG",
          "family": "VAG DQ381",
          "url": "/collections/all/bt-fit-route-audi-s3-8v-dq381?bbt_vehicle=1&bbt_route=bt-fit-route-audi-s3-8v-dq381&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-audi-s3-8v-dq381",
          "engineTag": "bt-fit-transmission-dq381",
          "systems": [
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "clutch": 2,
            "transmission-driveline": 2,
            "suspension-brakes": 1
          },
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "8Y": [
        {
          "label": "EA888 Gen 4 2.0T",
          "family": "Audi S3 8Y",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-audi-s3-8y-ea888-gen4",
          "systems": [
            "intake",
            "exhaust",
            "engine-parts"
          ],
          "systemCounts": {
            "intake": 1,
            "exhaust": 2,
            "engine-parts": 1
          },
          "url": "/collections/all/bt-fit-route-audi-s3-8y-ea888-gen4?bbt_vehicle=1&bbt_route=bt-fit-route-audi-s3-8y-ea888-gen4&sort_by=price-ascending",
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "DQ381 7-speed DSG",
          "family": "VAG DQ381",
          "url": "/collections/all/bt-fit-route-audi-s3-8y-dq381?bbt_vehicle=1&bbt_route=bt-fit-route-audi-s3-8y-dq381&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-audi-s3-8y-dq381",
          "engineTag": "bt-fit-transmission-dq381",
          "systems": [
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "clutch": 2,
            "transmission-driveline": 2
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "RS3": {
      "8V / 8Y": [
        {
          "label": "EA855 2.5 TFSI",
          "family": "Audi EA855",
          "url": "/collections/all/bt-fit-route-audi-rs3-8v-8y-ea855?bbt_vehicle=1&bbt_route=bt-fit-route-audi-rs3-8v-8y-ea855&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-audi-rs3-8v-8y-ea855",
          "engineTag": "bt-fit-engine-ea855",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "transmission-driveline",
            "suspension-brakes",
            "tools-accessories"
          ],
          "systemCounts": {
            "engine-management": 1,
            "wiring-sensors-displays": 3,
            "turbo-forced-induction": 6,
            "intercooler": 1,
            "fuel-system": 5,
            "intake": 5,
            "exhaust": 7,
            "engine-parts": 21,
            "transmission-driveline": 2,
            "suspension-brakes": 2,
            "tools-accessories": 2
          },
          "productCount": 50,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "DQ500 7-speed DSG",
          "family": "VAG DQ500",
          "url": "/collections/all/bt-fit-route-audi-rs3-8v-8y-dq500?bbt_vehicle=1&bbt_route=bt-fit-route-audi-rs3-8v-8y-dq500&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-audi-rs3-8v-8y-dq500",
          "engineTag": "bt-fit-transmission-dq500",
          "systems": [
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "clutch": 1,
            "transmission-driveline": 4,
            "suspension-brakes": 1
          },
          "productCount": 5,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "TTRS": {
      "8S": [
        {
          "label": "EA855 2.5 TFSI",
          "family": "Audi EA855",
          "url": "/collections/all/bt-fit-route-audi-ttrs-8s-ea855?bbt_vehicle=1&bbt_route=bt-fit-route-audi-ttrs-8s-ea855&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-audi-ttrs-8s-ea855",
          "engineTag": "bt-fit-engine-ea855",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "transmission-driveline",
            "suspension-brakes",
            "tools-accessories"
          ],
          "systemCounts": {
            "engine-management": 1,
            "wiring-sensors-displays": 3,
            "turbo-forced-induction": 6,
            "intercooler": 1,
            "fuel-system": 5,
            "intake": 5,
            "exhaust": 5,
            "engine-parts": 20,
            "transmission-driveline": 2,
            "suspension-brakes": 2,
            "tools-accessories": 2
          },
          "productCount": 47,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "DQ500 7-speed DSG",
          "family": "VAG DQ500",
          "url": "/collections/all/bt-fit-route-audi-ttrs-8s-dq500?bbt_vehicle=1&bbt_route=bt-fit-route-audi-ttrs-8s-dq500&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-audi-ttrs-8s-dq500",
          "engineTag": "bt-fit-transmission-dq500",
          "systems": [
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "clutch": 2,
            "transmission-driveline": 5,
            "suspension-brakes": 1
          },
          "productCount": 6,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "8J": [
        {
          "label": "DQ500 7-speed DSG",
          "family": "VAG DQ500",
          "url": "/collections/all/bt-fit-route-audi-ttrs-8j-dq500?bbt_vehicle=1&bbt_route=bt-fit-route-audi-ttrs-8j-dq500&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-audi-ttrs-8j-dq500",
          "engineTag": "bt-fit-transmission-dq500",
          "systems": [
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "clutch": 1,
            "transmission-driveline": 2
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "S1": {
      "8X": [
        {
          "label": "2.0 TFSI / EA888 Gen 3",
          "family": "Audi S1 8X",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-audi-s1-8x-ea888-gen3",
          "systems": [
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "clutch": 1,
            "transmission-driveline": 1
          },
          "url": "/collections/all/bt-fit-route-audi-s1-8x-ea888-gen3?bbt_vehicle=1&bbt_route=bt-fit-route-audi-s1-8x-ea888-gen3&sort_by=price-ascending",
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "EA888 Gen 3 — 6-speed manual",
          "family": "VAG Manual",
          "url": "/collections/all/bt-fit-route-audi-s1-8x-ea888-gen3-manual?bbt_vehicle=1&bbt_route=bt-fit-route-audi-s1-8x-ea888-gen3-manual&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-audi-s1-8x-ea888-gen3-manual",
          "engineTag": "bt-fit-engine-ea888-gen3",
          "systems": [
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "clutch": 1,
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "TT": {
      "Mk1 / 8N (2001–2006)": [
        {
          "label": "1.8T AWP — manual",
          "family": "VW / Audi 1.8T AWP",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-audi-tt-mk1-8n-1-8t-awp",
          "systems": [
            "engine-management",
            "wiring-sensors-displays"
          ],
          "systemCounts": {
            "engine-management": 2,
            "wiring-sensors-displays": 3
          },
          "url": "/collections/all/bt-fit-route-audi-tt-mk1-8n-1-8t-awp?bbt_vehicle=1&bbt_route=bt-fit-route-audi-tt-mk1-8n-1-8t-awp&sort_by=price-ascending",
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "A3": {
      "8L (2001–2006)": [
        {
          "label": "1.8T AWP — manual",
          "family": "VW / Audi 1.8T AWP",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-audi-a3-8l-1-8t-awp",
          "systems": [
            "engine-management",
            "wiring-sensors-displays"
          ],
          "systemCounts": {
            "engine-management": 2,
            "wiring-sensors-displays": 3
          },
          "url": "/collections/all/bt-fit-route-audi-a3-8l-1-8t-awp?bbt_vehicle=1&bbt_route=bt-fit-route-audi-a3-8l-1-8t-awp&sort_by=price-ascending",
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "8P (2003–2012)": [
        {
          "label": "1.8 TFSI / 1.9–2.0 TDI",
          "family": "Audi A3 8P",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-audi-a3-8p-18tfsi-19-20tdi",
          "systems": [
            "intake"
          ],
          "systemCounts": {
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-audi-a3-8p-18tfsi-19-20tdi?bbt_vehicle=1&bbt_route=bt-fit-route-audi-a3-8p-18tfsi-19-20tdi&sort_by=price-ascending",
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "8P": [
        {
          "label": "EA113 2.0T — 6-speed manual",
          "family": "VAG Manual",
          "url": "/collections/all/bt-fit-route-audi-a3-8p-ea113-manual?bbt_vehicle=1&bbt_route=bt-fit-route-audi-a3-8p-ea113-manual&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-audi-a3-8p-ea113-manual",
          "engineTag": "bt-fit-engine-ea113",
          "systems": [
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "clutch": 1,
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "EA888 2.0T — 6-speed manual",
          "family": "VAG Manual",
          "url": "/collections/all/bt-fit-route-audi-a3-8p-ea888-manual?bbt_vehicle=1&bbt_route=bt-fit-route-audi-a3-8p-ea888-manual&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-audi-a3-8p-ea888-manual",
          "engineTag": "bt-fit-engine-ea888",
          "systems": [
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "clutch": 1,
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "PQ35 2.0T — FWD/AWD fuel module",
          "family": "VW AG PQ35",
          "url": "/collections/all/bt-fit-route-audi-a3-8p-pq35-lpfp?bbt_vehicle=1&bbt_route=bt-fit-route-audi-a3-8p-pq35-lpfp&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-audi-a3-8p-pq35-lpfp",
          "engineTag": "bt-fit-platform-pq35",
          "systems": [
            "fuel-system"
          ],
          "systemCounts": {
            "fuel-system": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "8V": [
        {
          "label": "DQ250 6-speed DSG",
          "family": "VAG DQ250",
          "url": "/collections/all/bt-fit-route-audi-a3-8v-dq250?bbt_vehicle=1&bbt_route=bt-fit-route-audi-a3-8v-dq250&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-audi-a3-8v-dq250",
          "engineTag": "bt-fit-transmission-dq250",
          "systems": [
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "clutch": 1,
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "K03 / K04": [
        {
          "label": "Factory-frame K03/K04 IWG",
          "family": "VAG K03/K04",
          "url": "/collections/all/bt-fit-route-audi-a3-k03-k04-iwg?bbt_vehicle=1&bbt_route=bt-fit-route-audi-a3-k03-k04-iwg&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-audi-a3-k03-k04-iwg",
          "engineTag": "bt-fit-turbo-vag-k03-k04",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "TT / TTS": {
      "8J": [
        {
          "label": "EA113 2.0T — 6-speed manual",
          "family": "VAG Manual",
          "url": "/collections/all/bt-fit-route-audi-tt-tts-8j-ea113-manual?bbt_vehicle=1&bbt_route=bt-fit-route-audi-tt-tts-8j-ea113-manual&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-audi-tt-tts-8j-ea113-manual",
          "engineTag": "bt-fit-engine-ea113",
          "systems": [
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "clutch": 1,
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "EA888 2.0T — 6-speed manual",
          "family": "VAG Manual",
          "url": "/collections/all/bt-fit-route-audi-tt-tts-8j-ea888-manual?bbt_vehicle=1&bbt_route=bt-fit-route-audi-tt-tts-8j-ea888-manual&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-audi-tt-tts-8j-ea888-manual",
          "engineTag": "bt-fit-engine-ea888",
          "systems": [
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "clutch": 1,
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "PQ35-derived 2.0T — FWD/AWD fuel module",
          "family": "VW AG PQ35",
          "url": "/collections/all/bt-fit-route-audi-tt-tts-8j-pq35-lpfp?bbt_vehicle=1&bbt_route=bt-fit-route-audi-tt-tts-8j-pq35-lpfp&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-audi-tt-tts-8j-pq35-lpfp",
          "engineTag": "bt-fit-platform-pq35",
          "systems": [
            "fuel-system"
          ],
          "systemCounts": {
            "fuel-system": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "8S": [
        {
          "label": "EA888 Gen 3 — 6-speed manual",
          "family": "VAG Manual",
          "url": "/collections/all/bt-fit-route-audi-tt-tts-8s-ea888-manual?bbt_vehicle=1&bbt_route=bt-fit-route-audi-tt-tts-8s-ea888-manual&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-audi-tt-tts-8s-ea888-manual",
          "engineTag": "bt-fit-engine-ea888",
          "systems": [
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "clutch": 1,
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "DQ250 6-speed DSG",
          "family": "VAG DQ250",
          "url": "/collections/all/bt-fit-route-audi-tt-tts-8s-dq250?bbt_vehicle=1&bbt_route=bt-fit-route-audi-tt-tts-8s-dq250&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-audi-tt-tts-8s-dq250",
          "engineTag": "bt-fit-transmission-dq250",
          "systems": [
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "clutch": 1,
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Q3": {
      "8U": [
        {
          "label": "DQ500-equipped",
          "family": "VAG DQ500",
          "url": "/collections/all/bt-fit-route-audi-q3-8u-dq500?bbt_vehicle=1&bbt_route=bt-fit-route-audi-q3-8u-dq500&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-audi-q3-8u-dq500",
          "engineTag": "bt-fit-transmission-dq500",
          "systems": [
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "clutch": 2,
            "transmission-driveline": 3
          },
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "RS Q3": {
      "8U": [
        {
          "label": "DQ500 7-speed DSG",
          "family": "VAG DQ500",
          "url": "/collections/all/bt-fit-route-audi-rsq3-8u-dq500?bbt_vehicle=1&bbt_route=bt-fit-route-audi-rsq3-8u-dq500&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-audi-rsq3-8u-dq500",
          "engineTag": "bt-fit-transmission-dq500",
          "systems": [
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "clutch": 2,
            "transmission-driveline": 3
          },
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "R8": {
      "4S / Gen 2": [
        {
          "label": "DL800 7-speed dual-clutch",
          "family": "Audi R8 DL800",
          "url": "/collections/all/bt-fit-route-audi-r8-4s-dl800?bbt_vehicle=1&bbt_route=bt-fit-route-audi-r8-4s-dl800&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-audi-r8-4s-dl800",
          "engineTag": "bt-fit-transmission-dl800",
          "systems": [
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "clutch": 1,
            "transmission-driveline": 2
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "V10": [
        {
          "label": "V10 intake-manifold application",
          "family": "Audi R8 V10",
          "url": "/collections/all/bt-fit-route-audi-r8-v10-intake?bbt_vehicle=1&bbt_route=bt-fit-route-audi-r8-v10-intake&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-audi-r8-v10-intake",
          "engineTag": "bt-fit-engine-r8-v10",
          "systems": [],
          "systemCounts": {},
          "productCount": 0,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "S2": {
      "5-cylinder / RWD": [
        {
          "label": "5-cylinder RWD turbo manifold application",
          "family": "Audi S2 5-cylinder",
          "url": "/collections/all/bt-fit-route-audi-s2-5cyl-rwd?bbt_vehicle=1&bbt_route=bt-fit-route-audi-s2-5cyl-rwd&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-audi-s2-5cyl-rwd",
          "engineTag": "bt-fit-engine-audi-s2-5cyl",
          "systems": [
            "turbo-forced-induction",
            "exhaust",
            "engine-parts"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "exhaust": 1,
            "engine-parts": 2
          },
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Engine Family / Custom": {
      "EA888 Gen 3": [
        {
          "label": "Port-injector / auxiliary-fuel application",
          "family": "Audi EA888 Gen3",
          "url": "/collections/all/bt-fit-route-audi-engine-family-ea888-gen3-port-injector?bbt_vehicle=1&bbt_route=bt-fit-route-audi-engine-family-ea888-gen3-port-injector&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-audi-engine-family-ea888-gen3-port-injector",
          "engineTag": "bt-fit-engine-ea888-gen3",
          "systems": [
            "fuel-system"
          ],
          "systemCounts": {
            "fuel-system": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Component Family / Custom": {
      "TFSI Kompact EM VR1": [
        {
          "label": "Kompact EM",
          "family": "Turbosmart Component Family",
          "url": "/collections/all/bt-fit-route-audi-tfsi-kompact-em-vr1?bbt_vehicle=1&bbt_route=bt-fit-route-audi-tfsi-kompact-em-vr1&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-audi-tfsi-kompact-em-vr1",
          "engineTag": "bt-fit-component-audi-tfsi-kompact-em-vr1",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "Kompact EM VR18": [
        {
          "label": "Kompact EM",
          "family": "Turbosmart Component Family",
          "url": "/collections/all/bt-fit-route-audi-kompact-em-vr18?bbt_vehicle=1&bbt_route=bt-fit-route-audi-kompact-em-vr18&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-audi-kompact-em-vr18",
          "engineTag": "bt-fit-component-audi-kompact-em-vr18",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "1.4 TFSI Kompact EM VR4": [
        {
          "label": "Kompact EM",
          "family": "Turbosmart Component Family",
          "url": "/collections/all/bt-fit-route-audi-14tfsi-kompact-em-vr4?bbt_vehicle=1&bbt_route=bt-fit-route-audi-14tfsi-kompact-em-vr4&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-audi-14tfsi-kompact-em-vr4",
          "engineTag": "bt-fit-component-audi-14tfsi-kompact-em-vr4",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "Volkswagen": {
    "Golf R": {
      "Mk6": [
        {
          "label": "EA113 2.0T",
          "family": "VW / Audi EA113",
          "url": "/collections/all/bt-fit-route-volkswagen-golf-r-mk6-ea113?bbt_vehicle=1&bbt_route=bt-fit-route-volkswagen-golf-r-mk6-ea113&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-volkswagen-golf-r-mk6-ea113",
          "engineTag": "bt-fit-engine-ea113",
          "systems": [
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "engine-parts",
            "ignition",
            "suspension-brakes"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2,
            "intercooler": 1,
            "fuel-system": 4,
            "engine-parts": 3,
            "ignition": 1,
            "suspension-brakes": 1
          },
          "productCount": 11,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "EA113 2.0T — 6-speed manual",
          "family": "VAG Manual",
          "url": "/collections/all/bt-fit-route-volkswagen-golf-r-mk6-ea113-manual?bbt_vehicle=1&bbt_route=bt-fit-route-volkswagen-golf-r-mk6-ea113-manual&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-volkswagen-golf-r-mk6-ea113-manual",
          "engineTag": "bt-fit-engine-ea113",
          "systems": [
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "clutch": 1,
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "Mk7 / Mk7.5": [
        {
          "label": "EA888 Gen 3 2.0T",
          "family": "VW Golf R Mk7 / Mk7.5",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-volkswagen-golf-r-mk7-mk75-mk8-ea888",
          "systems": [
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "ignition",
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "wiring-sensors-displays": 1,
            "turbo-forced-induction": 7,
            "intercooler": 2,
            "fuel-system": 2,
            "intake": 4,
            "exhaust": 4,
            "engine-parts": 4,
            "ignition": 2,
            "clutch": 1,
            "transmission-driveline": 2,
            "suspension-brakes": 2
          },
          "url": "/collections/all/bt-fit-route-volkswagen-golf-r-mk7-mk75-mk8-ea888?bbt_vehicle=1&bbt_route=bt-fit-route-volkswagen-golf-r-mk7-mk75-mk8-ea888&sort_by=price-ascending",
          "productCount": 26,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "EA888 Gen 3 — 6-speed manual",
          "family": "VAG Manual",
          "url": "/collections/all/bt-fit-route-volkswagen-golf-r-mk7-mk75-ea888-manual?bbt_vehicle=1&bbt_route=bt-fit-route-volkswagen-golf-r-mk7-mk75-ea888-manual&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-volkswagen-golf-r-mk7-mk75-ea888-manual",
          "engineTag": "bt-fit-engine-ea888",
          "systems": [
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "clutch": 1,
            "transmission-driveline": 1,
            "suspension-brakes": 1
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "DQ250 6-speed DSG",
          "family": "VAG DQ250",
          "url": "/collections/all/bt-fit-route-volkswagen-golf-r-mk7-mk75-dq250?bbt_vehicle=1&bbt_route=bt-fit-route-volkswagen-golf-r-mk7-mk75-dq250&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-volkswagen-golf-r-mk7-mk75-dq250",
          "engineTag": "bt-fit-transmission-dq250",
          "systems": [
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "clutch": 1,
            "transmission-driveline": 1,
            "suspension-brakes": 1
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "DQ381 7-speed DSG",
          "family": "VAG DQ381",
          "url": "/collections/all/bt-fit-route-volkswagen-golf-r-mk7-mk75-dq381?bbt_vehicle=1&bbt_route=bt-fit-route-volkswagen-golf-r-mk7-mk75-dq381&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-volkswagen-golf-r-mk7-mk75-dq381",
          "engineTag": "bt-fit-transmission-dq381",
          "systems": [
            "clutch",
            "transmission-driveline",
            "suspension-brakes"
          ],
          "systemCounts": {
            "clutch": 2,
            "transmission-driveline": 2,
            "suspension-brakes": 1
          },
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "Mk8": [
        {
          "label": "EA888 Gen 4 2.0T",
          "family": "VW Golf R Mk8",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-volkswagen-golf-r-mk8-ea888-gen4",
          "systems": [
            "intake",
            "exhaust",
            "engine-parts"
          ],
          "systemCounts": {
            "intake": 1,
            "exhaust": 2,
            "engine-parts": 1
          },
          "url": "/collections/all/bt-fit-route-volkswagen-golf-r-mk8-ea888-gen4?bbt_vehicle=1&bbt_route=bt-fit-route-volkswagen-golf-r-mk8-ea888-gen4&sort_by=price-ascending",
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "DQ381 7-speed DSG",
          "family": "VAG DQ381",
          "url": "/collections/all/bt-fit-route-volkswagen-golf-r-mk8-dq381?bbt_vehicle=1&bbt_route=bt-fit-route-volkswagen-golf-r-mk8-dq381&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-volkswagen-golf-r-mk8-dq381",
          "engineTag": "bt-fit-transmission-dq381",
          "systems": [
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "clutch": 2,
            "transmission-driveline": 2
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Golf GTI": {
      "Mk4 (2001–2006)": [
        {
          "label": "1.8T AWP — manual",
          "family": "VW / Audi 1.8T AWP",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-volkswagen-golf-gti-mk4-1-8t-awp",
          "systems": [
            "engine-management",
            "wiring-sensors-displays"
          ],
          "systemCounts": {
            "engine-management": 2,
            "wiring-sensors-displays": 3
          },
          "url": "/collections/all/bt-fit-route-volkswagen-golf-gti-mk4-1-8t-awp?bbt_vehicle=1&bbt_route=bt-fit-route-volkswagen-golf-gti-mk4-1-8t-awp&sort_by=price-ascending",
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "Mk5 (2004–2008)": [
        {
          "label": "2.0T FSI",
          "family": "VW Golf GTI Mk5",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-volkswagen-golf-gti-mk5-2-0t",
          "systems": [
            "fuel-system",
            "intake"
          ],
          "systemCounts": {
            "fuel-system": 1,
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-volkswagen-golf-gti-mk5-2-0t?bbt_vehicle=1&bbt_route=bt-fit-route-volkswagen-golf-gti-mk5-2-0t&sort_by=price-ascending",
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "EA113 2.0T — 6-speed manual",
          "family": "VAG Manual",
          "url": "/collections/all/bt-fit-route-volkswagen-golf-gti-mk5-ea113-manual?bbt_vehicle=1&bbt_route=bt-fit-route-volkswagen-golf-gti-mk5-ea113-manual&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-volkswagen-golf-gti-mk5-ea113-manual",
          "engineTag": "bt-fit-engine-ea113",
          "systems": [
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "clutch": 1,
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "Mk7 / Mk7.5": [
        {
          "label": "EA888 Gen 3 2.0T",
          "family": "VW Golf GTI Mk7 / Mk7.5",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-volkswagen-golf-gti-mk7-mk75-ea888-gen3",
          "systems": [
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "intercooler": 1,
            "fuel-system": 2,
            "intake": 2,
            "exhaust": 2,
            "engine-parts": 1,
            "clutch": 1,
            "transmission-driveline": 1
          },
          "url": "/collections/all/bt-fit-route-volkswagen-golf-gti-mk7-mk75-ea888-gen3?bbt_vehicle=1&bbt_route=bt-fit-route-volkswagen-golf-gti-mk7-mk75-ea888-gen3&sort_by=price-ascending",
          "productCount": 9,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "EA888 Gen 3 — 6-speed manual",
          "family": "VAG Manual",
          "url": "/collections/all/bt-fit-route-volkswagen-golf-gti-mk7-mk75-ea888-manual?bbt_vehicle=1&bbt_route=bt-fit-route-volkswagen-golf-gti-mk7-mk75-ea888-manual&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-volkswagen-golf-gti-mk7-mk75-ea888-manual",
          "engineTag": "bt-fit-engine-ea888",
          "systems": [
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "clutch": 1,
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "DQ250 6-speed DSG",
          "family": "VAG DQ250",
          "url": "/collections/all/bt-fit-route-volkswagen-golf-gti-mk7-mk75-dq250?bbt_vehicle=1&bbt_route=bt-fit-route-volkswagen-golf-gti-mk7-mk75-dq250&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-volkswagen-golf-gti-mk7-mk75-dq250",
          "engineTag": "bt-fit-transmission-dq250",
          "systems": [
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "clutch": 1,
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "DQ381 7-speed DSG",
          "family": "VAG DQ381",
          "url": "/collections/all/bt-fit-route-volkswagen-golf-gti-mk7-mk75-dq381?bbt_vehicle=1&bbt_route=bt-fit-route-volkswagen-golf-gti-mk7-mk75-dq381&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-volkswagen-golf-gti-mk7-mk75-dq381",
          "engineTag": "bt-fit-transmission-dq381",
          "systems": [
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "clutch": 2,
            "transmission-driveline": 2
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "Mk6 (2009–2013)": [
        {
          "label": "EA888 Gen 2 2.0T",
          "family": "VW Golf GTI Mk6",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-volkswagen-golf-gti-mk6-ea888-gen2",
          "systems": [
            "turbo-forced-induction",
            "intercooler",
            "fuel-system",
            "engine-parts",
            "ignition"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "intercooler": 1,
            "fuel-system": 1,
            "engine-parts": 2,
            "ignition": 1
          },
          "url": "/collections/all/bt-fit-route-volkswagen-golf-gti-mk6-ea888-gen2?bbt_vehicle=1&bbt_route=bt-fit-route-volkswagen-golf-gti-mk6-ea888-gen2&sort_by=price-ascending",
          "productCount": 5,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "EA888 Gen 2 — 6-speed manual",
          "family": "VAG Manual",
          "url": "/collections/all/bt-fit-route-volkswagen-golf-gti-mk6-ea888-manual?bbt_vehicle=1&bbt_route=bt-fit-route-volkswagen-golf-gti-mk6-ea888-manual&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-volkswagen-golf-gti-mk6-ea888-manual",
          "engineTag": "bt-fit-engine-ea888",
          "systems": [
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "clutch": 1,
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "Mk8": [
        {
          "label": "DQ381 7-speed DSG",
          "family": "VAG DQ381",
          "url": "/collections/all/bt-fit-route-volkswagen-golf-gti-mk8-dq381?bbt_vehicle=1&bbt_route=bt-fit-route-volkswagen-golf-gti-mk8-dq381&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-volkswagen-golf-gti-mk8-dq381",
          "engineTag": "bt-fit-transmission-dq381",
          "systems": [
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "clutch": 2,
            "transmission-driveline": 2
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Amarok": {
      "NF (2023+)": [
        {
          "label": "3.0L V6 Turbo Diesel",
          "family": "VW Amarok NF",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-volkswagen-amarok-nf-v6-diesel",
          "systems": [
            "intercooler",
            "exhaust",
            "engine-parts",
            "transmission-driveline",
            "cooling"
          ],
          "systemCounts": {
            "intercooler": 1,
            "exhaust": 1,
            "engine-parts": 1,
            "transmission-driveline": 1,
            "cooling": 1
          },
          "url": "/collections/all/bt-fit-route-volkswagen-amarok-nf-v6-diesel?bbt_vehicle=1&bbt_route=bt-fit-route-volkswagen-amarok-nf-v6-diesel&sort_by=price-ascending",
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Golf Mk5 VR6": {
      "Mk5": [
        {
          "label": "VR6",
          "family": "Volkswagen Golf Mk5 VR6",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-volkswagen-golf-mk5-vr6",
          "systems": [
            "turbo-forced-induction",
            "exhaust"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "exhaust": 1
          },
          "url": "/collections/all/bt-fit-route-volkswagen-golf-mk5-vr6?bbt_vehicle=1&bbt_route=bt-fit-route-volkswagen-golf-mk5-vr6&sort_by=price-ascending",
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Golf": {
      "Mk5": [
        {
          "label": "1.9 / 2.0 TDI",
          "family": "Volkswagen Golf Mk5",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-volkswagen-golf-mk5-19-20tdi",
          "systems": [
            "intake"
          ],
          "systemCounts": {
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-volkswagen-golf-mk5-19-20tdi?bbt_vehicle=1&bbt_route=bt-fit-route-volkswagen-golf-mk5-19-20tdi&sort_by=price-ascending",
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "K03 / K04": [
        {
          "label": "Factory-frame K03/K04 IWG",
          "family": "VAG K03/K04",
          "url": "/collections/all/bt-fit-route-volkswagen-golf-k03-k04-iwg?bbt_vehicle=1&bbt_route=bt-fit-route-volkswagen-golf-k03-k04-iwg&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-volkswagen-golf-k03-k04-iwg",
          "engineTag": "bt-fit-turbo-vag-k03-k04",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Jetta": {
      "1K": [
        {
          "label": "EA113 2.0T — 6-speed manual",
          "family": "VAG Manual",
          "url": "/collections/all/bt-fit-route-volkswagen-jetta-1k-ea113-manual?bbt_vehicle=1&bbt_route=bt-fit-route-volkswagen-jetta-1k-ea113-manual&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-volkswagen-jetta-1k-ea113-manual",
          "engineTag": "bt-fit-engine-ea113",
          "systems": [
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "clutch": 1,
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "EA888 2.0T — 6-speed manual",
          "family": "VAG Manual",
          "url": "/collections/all/bt-fit-route-volkswagen-jetta-1k-ea888-manual?bbt_vehicle=1&bbt_route=bt-fit-route-volkswagen-jetta-1k-ea888-manual&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-volkswagen-jetta-1k-ea888-manual",
          "engineTag": "bt-fit-engine-ea888",
          "systems": [
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "clutch": 1,
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "PQ35 2.0T — FWD fuel module",
          "family": "VW AG PQ35",
          "url": "/collections/all/bt-fit-route-volkswagen-jetta-1k-pq35-lpfp?bbt_vehicle=1&bbt_route=bt-fit-route-volkswagen-jetta-1k-pq35-lpfp&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-volkswagen-jetta-1k-pq35-lpfp",
          "engineTag": "bt-fit-platform-pq35",
          "systems": [
            "fuel-system"
          ],
          "systemCounts": {
            "fuel-system": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Passat": {
      "B6": [
        {
          "label": "EA113 2.0T — 6-speed manual",
          "family": "VAG Manual",
          "url": "/collections/all/bt-fit-route-volkswagen-passat-b6-ea113-manual?bbt_vehicle=1&bbt_route=bt-fit-route-volkswagen-passat-b6-ea113-manual&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-volkswagen-passat-b6-ea113-manual",
          "engineTag": "bt-fit-engine-ea113",
          "systems": [
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "clutch": 1,
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "EA888 2.0T — 6-speed manual",
          "family": "VAG Manual",
          "url": "/collections/all/bt-fit-route-volkswagen-passat-b6-ea888-manual?bbt_vehicle=1&bbt_route=bt-fit-route-volkswagen-passat-b6-ea888-manual&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-volkswagen-passat-b6-ea888-manual",
          "engineTag": "bt-fit-engine-ea888",
          "systems": [
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "clutch": 1,
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Eos": {
      "1F": [
        {
          "label": "EA113 2.0T — 6-speed manual",
          "family": "VAG Manual",
          "url": "/collections/all/bt-fit-route-volkswagen-eos-1f-ea113-manual?bbt_vehicle=1&bbt_route=bt-fit-route-volkswagen-eos-1f-ea113-manual&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-volkswagen-eos-1f-ea113-manual",
          "engineTag": "bt-fit-engine-ea113",
          "systems": [
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "clutch": 1,
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "EA888 2.0T — 6-speed manual",
          "family": "VAG Manual",
          "url": "/collections/all/bt-fit-route-volkswagen-eos-1f-ea888-manual?bbt_vehicle=1&bbt_route=bt-fit-route-volkswagen-eos-1f-ea888-manual&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-volkswagen-eos-1f-ea888-manual",
          "engineTag": "bt-fit-engine-ea888",
          "systems": [
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "clutch": 1,
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "PQ35 2.0T — FWD fuel module",
          "family": "VW AG PQ35",
          "url": "/collections/all/bt-fit-route-volkswagen-eos-1f-pq35-lpfp?bbt_vehicle=1&bbt_route=bt-fit-route-volkswagen-eos-1f-pq35-lpfp&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-volkswagen-eos-1f-pq35-lpfp",
          "engineTag": "bt-fit-platform-pq35",
          "systems": [
            "fuel-system"
          ],
          "systemCounts": {
            "fuel-system": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Scirocco R": {
      "1K8": [
        {
          "label": "EA113 2.0T — 6-speed manual",
          "family": "VAG Manual",
          "url": "/collections/all/bt-fit-route-volkswagen-scirocco-r-1k8-ea113-manual?bbt_vehicle=1&bbt_route=bt-fit-route-volkswagen-scirocco-r-1k8-ea113-manual&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-volkswagen-scirocco-r-1k8-ea113-manual",
          "engineTag": "bt-fit-engine-ea113",
          "systems": [
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "clutch": 1,
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "PQ35 — fuel module",
          "family": "VW AG PQ35",
          "url": "/collections/all/bt-fit-route-volkswagen-scirocco-r-1k8-pq35-lpfp?bbt_vehicle=1&bbt_route=bt-fit-route-volkswagen-scirocco-r-1k8-pq35-lpfp&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-volkswagen-scirocco-r-1k8-pq35-lpfp",
          "engineTag": "bt-fit-platform-pq35",
          "systems": [
            "fuel-system"
          ],
          "systemCounts": {
            "fuel-system": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Tiguan": {
      "5N": [
        {
          "label": "DQ500-equipped",
          "family": "VAG DQ500",
          "url": "/collections/all/bt-fit-route-volkswagen-tiguan-5n-dq500?bbt_vehicle=1&bbt_route=bt-fit-route-volkswagen-tiguan-5n-dq500&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-volkswagen-tiguan-5n-dq500",
          "engineTag": "bt-fit-transmission-dq500",
          "systems": [
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "clutch": 2,
            "transmission-driveline": 3
          },
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Component Family / Custom": {
      "TFSI Kompact EM VR1": [
        {
          "label": "Kompact EM",
          "family": "Turbosmart Component Family",
          "url": "/collections/all/bt-fit-route-volkswagen-tfsi-kompact-em-vr1?bbt_vehicle=1&bbt_route=bt-fit-route-volkswagen-tfsi-kompact-em-vr1&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-volkswagen-tfsi-kompact-em-vr1",
          "engineTag": "bt-fit-component-volkswagen-tfsi-kompact-em-vr1",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "Kompact EM VR18": [
        {
          "label": "Kompact EM",
          "family": "Turbosmart Component Family",
          "url": "/collections/all/bt-fit-route-volkswagen-kompact-em-vr18?bbt_vehicle=1&bbt_route=bt-fit-route-volkswagen-kompact-em-vr18&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-volkswagen-kompact-em-vr18",
          "engineTag": "bt-fit-component-volkswagen-kompact-em-vr18",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "1.4 TSI Kompact EM VR4": [
        {
          "label": "Kompact EM",
          "family": "Turbosmart Component Family",
          "url": "/collections/all/bt-fit-route-volkswagen-14tsi-kompact-em-vr4?bbt_vehicle=1&bbt_route=bt-fit-route-volkswagen-14tsi-kompact-em-vr4&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-volkswagen-14tsi-kompact-em-vr4",
          "engineTag": "bt-fit-component-volkswagen-14tsi-kompact-em-vr4",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "Honda": {
    "Civic Type R": {
      "EP3 (2001–2005)": [
        {
          "label": "K20",
          "family": "Honda K20",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-honda-civic-type-r-ep3-k20",
          "engineTag": "bt-fit-engine-k20",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intake",
            "exhaust",
            "engine-parts"
          ],
          "systemCounts": {
            "engine-management": 2,
            "wiring-sensors-displays": 2,
            "turbo-forced-induction": 4,
            "intake": 1,
            "exhaust": 1,
            "engine-parts": 1
          },
          "url": "/collections/all/bt-fit-route-honda-civic-type-r-ep3-k20?bbt_vehicle=1&bbt_route=bt-fit-route-honda-civic-type-r-ep3-k20&sort_by=price-ascending",
          "productCount": 9,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "FK8 (2017–2021)": [
        {
          "label": "K20C1 2.0L Turbo",
          "family": "Honda Civic Type R",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-honda-civic-type-r-fk8-k20c1",
          "systems": [
            "turbo-forced-induction",
            "intake"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-honda-civic-type-r-fk8-k20c1?bbt_vehicle=1&bbt_route=bt-fit-route-honda-civic-type-r-fk8-k20c1&sort_by=price-ascending",
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "FL5 (2023+)": [
        {
          "label": "K20C1 2.0L Turbo",
          "family": "Honda Civic Type R",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-honda-civic-type-r-fl5-k20c1",
          "systems": [
            "turbo-forced-induction",
            "intake"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-honda-civic-type-r-fl5-k20c1?bbt_vehicle=1&bbt_route=bt-fit-route-honda-civic-type-r-fl5-k20c1&sort_by=price-ascending",
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "FK2 (2014–2017)": [
        {
          "label": "K20C1 2.0L Turbo",
          "family": "Honda Type R",
          "url": "/collections/all/bt-fit-route-honda-civic-type-r-fk2-k20c1?bbt_vehicle=1&bbt_route=bt-fit-route-honda-civic-type-r-fk2-k20c1&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-honda-civic-type-r-fk2-k20c1",
          "engineTag": "bt-fit-engine-k20c1",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Integra / RSX": {
      "DC5 (2002–2006)": [
        {
          "label": "K20",
          "family": "Honda K20",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-honda-integra-dc5-k20",
          "engineTag": "bt-fit-engine-k20",
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intake",
            "exhaust",
            "engine-parts"
          ],
          "systemCounts": {
            "engine-management": 2,
            "wiring-sensors-displays": 3,
            "turbo-forced-induction": 4,
            "intake": 1,
            "exhaust": 1,
            "engine-parts": 1
          },
          "url": "/collections/all/bt-fit-route-honda-integra-dc5-k20?bbt_vehicle=1&bbt_route=bt-fit-route-honda-integra-dc5-k20&sort_by=price-ascending",
          "productCount": 10,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Accord Euro": {
      "CL9 (2003–2008)": [
        {
          "label": "K24A3",
          "family": "Honda K24",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-honda-accord-euro-cl9-k24a3",
          "engineTag": "bt-fit-engine-k24",
          "systems": [
            "turbo-forced-induction",
            "intake",
            "exhaust",
            "engine-parts"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2,
            "intake": 1,
            "exhaust": 1,
            "engine-parts": 1
          },
          "url": "/collections/all/bt-fit-route-honda-accord-euro-cl9-k24a3?bbt_vehicle=1&bbt_route=bt-fit-route-honda-accord-euro-cl9-k24a3&sort_by=price-ascending",
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "CR-V": {
      "2002–2004": [
        {
          "label": "K24A1 2.4L",
          "family": "Honda CR-V RD7",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-honda-cr-v-rd7-2002-2004-k24a1",
          "systems": [
            "turbo-forced-induction",
            "intake",
            "exhaust",
            "engine-parts"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2,
            "intake": 3,
            "exhaust": 1,
            "engine-parts": 1
          },
          "url": "/collections/all/bt-fit-route-honda-cr-v-rd7-2002-2004-k24a1?bbt_vehicle=1&bbt_route=bt-fit-route-honda-cr-v-rd7-2002-2004-k24a1&sort_by=price-ascending",
          "productCount": 6,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "2005–2006": [
        {
          "label": "K24A1 2.4L",
          "family": "Honda CR-V RD7",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-honda-cr-v-rd7-2005-2006-k24a1",
          "systems": [
            "turbo-forced-induction",
            "intake",
            "exhaust",
            "engine-parts"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2,
            "intake": 3,
            "exhaust": 1,
            "engine-parts": 1
          },
          "url": "/collections/all/bt-fit-route-honda-cr-v-rd7-2005-2006-k24a1?bbt_vehicle=1&bbt_route=bt-fit-route-honda-cr-v-rd7-2005-2006-k24a1&sort_by=price-ascending",
          "productCount": 6,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "2007–2008": [
        {
          "label": "K24 2.4L",
          "family": "Honda CR-V RE",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-honda-cr-v-re-2007-2008-k24",
          "systems": [
            "turbo-forced-induction",
            "intake",
            "engine-parts"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "intake": 3,
            "engine-parts": 1
          },
          "url": "/collections/all/bt-fit-route-honda-cr-v-re-2007-2008-k24?bbt_vehicle=1&bbt_route=bt-fit-route-honda-cr-v-re-2007-2008-k24&sort_by=price-ascending",
          "productCount": 5,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "K-Series / Conversion": {
      "Engine family": [
        {
          "label": "K20",
          "family": "Honda K20",
          "url": "/collections/bbt-nav-family-honda-k20",
          "routeType": "engine-family-landing",
          "systemCounts": {
            "engine-management": 9,
            "wiring-sensors-displays": 11,
            "turbo-forced-induction": 24,
            "fuel-system": 1,
            "intake": 5,
            "exhaust": 3,
            "engine-parts": 1,
            "tools-accessories": 2
          },
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "tools-accessories"
          ],
          "productCount": 46,
          "catalogueVersion": "113-11sep2026"
        },
        {
          "label": "K24",
          "family": "Honda K24",
          "url": "/collections/bbt-nav-family-honda-k24",
          "routeType": "engine-family-landing",
          "systemCounts": {
            "engine-management": 8,
            "wiring-sensors-displays": 10,
            "turbo-forced-induction": 29,
            "fuel-system": 1,
            "intake": 5,
            "exhaust": 3,
            "engine-parts": 1,
            "tools-accessories": 2
          },
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "tools-accessories"
          ],
          "productCount": 49,
          "catalogueVersion": "113-11sep2026"
        },
        {
          "label": "K-series (general)",
          "family": "Honda K-series",
          "url": "/collections/bbt-nav-family-honda-k-series",
          "routeType": "engine-family-landing",
          "systemCounts": {
            "engine-management": 9,
            "wiring-sensors-displays": 11,
            "turbo-forced-induction": 32,
            "fuel-system": 1,
            "intake": 7,
            "exhaust": 3,
            "engine-parts": 2,
            "tools-accessories": 2
          },
          "systems": [
            "engine-management",
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "fuel-system",
            "intake",
            "exhaust",
            "engine-parts",
            "tools-accessories"
          ],
          "productCount": 57,
          "catalogueVersion": "113-11sep2026"
        }
      ]
    },
    "S2000": {
      "AP1 / early AP2 (2000–2005)": [
        {
          "label": "Factory non-DBW / K20-K24 RWD conversion",
          "family": "Honda S2000 / K-Series RWD",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-honda-s2000-ap1-ap2-2000-2005-non-dbw",
          "systems": [
            "wiring-sensors-displays",
            "turbo-forced-induction",
            "intake",
            "exhaust",
            "engine-parts"
          ],
          "systemCounts": {
            "wiring-sensors-displays": 2,
            "turbo-forced-induction": 4,
            "intake": 1,
            "exhaust": 1,
            "engine-parts": 1
          },
          "url": "/collections/all/bt-fit-route-honda-s2000-ap1-ap2-2000-2005-non-dbw?bbt_vehicle=1&bbt_route=bt-fit-route-honda-s2000-ap1-ap2-2000-2005-non-dbw&sort_by=price-ascending",
          "productCount": 8,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Civic": {
      "10th Gen (2016–2021)": [
        {
          "label": "1.5L Turbo — non-Si",
          "family": "Honda Civic",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-honda-civic-2016-2021-15-turbo-non-si",
          "systems": [
            "intake"
          ],
          "systemCounts": {
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-honda-civic-2016-2021-15-turbo-non-si?bbt_vehicle=1&bbt_route=bt-fit-route-honda-civic-2016-2021-15-turbo-non-si&sort_by=price-ascending",
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "1992–1995": [
        {
          "label": "OBD-I — manual transmission only",
          "family": "Honda OBD-I Manual / Haltech",
          "url": "/collections/all/bt-fit-route-honda-civic-1992-1995-obd1-manual?bbt_vehicle=1&bbt_route=bt-fit-route-honda-civic-1992-1995-obd1-manual&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-honda-civic-1992-1995-obd1-manual",
          "engineTag": "bt-fit-platform-honda-obd1-manual",
          "systems": [
            "engine-management",
            "wiring-sensors-displays"
          ],
          "systemCounts": {
            "engine-management": 1,
            "wiring-sensors-displays": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Accord": {
      "9th Gen (2013–2016)": [
        {
          "label": "2.4L",
          "family": "Honda Accord",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-honda-accord-9th-gen-2013-2016-24",
          "systems": [
            "intake"
          ],
          "systemCounts": {
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-honda-accord-9th-gen-2013-2016-24?bbt_vehicle=1&bbt_route=bt-fit-route-honda-accord-9th-gen-2013-2016-24&sort_by=price-ascending",
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "1990–1995": [
        {
          "label": "OBD-I — manual transmission only",
          "family": "Honda OBD-I Manual / Haltech",
          "url": "/collections/all/bt-fit-route-honda-accord-1990-1995-obd1-manual?bbt_vehicle=1&bbt_route=bt-fit-route-honda-accord-1990-1995-obd1-manual&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-honda-accord-1990-1995-obd1-manual",
          "engineTag": "bt-fit-platform-honda-obd1-manual",
          "systems": [
            "engine-management",
            "wiring-sensors-displays"
          ],
          "systemCounts": {
            "engine-management": 1,
            "wiring-sensors-displays": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Engine Family / Custom": {
      "K20 / K24": [
        {
          "label": "K-Series K20 / K24 — engine / swap fitment",
          "family": "Honda Engine Family",
          "url": "/collections/all/bt-fit-route-honda-engine-family-k20-k24?bbt_vehicle=1&bbt_route=bt-fit-route-honda-engine-family-k20-k24&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-honda-engine-family-k20-k24",
          "engineTag": "bt-fit-engine-k-series",
          "systems": [
            "turbo-forced-induction",
            "exhaust"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "exhaust": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Civic Si / RS": {
      "1.5T": [
        {
          "label": "1.5L Turbo",
          "family": "Honda Civic Turbo",
          "url": "/collections/all/bt-fit-route-honda-civic-si-rs-15-turbo?bbt_vehicle=1&bbt_route=bt-fit-route-honda-civic-si-rs-15-turbo&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-honda-civic-si-rs-15-turbo",
          "engineTag": "bt-fit-engine-honda-15t",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Integra": {
      "1992–1995": [
        {
          "label": "OBD-I — manual transmission only",
          "family": "Honda OBD-I Manual / Haltech",
          "url": "/collections/all/bt-fit-route-honda-integra-1992-1995-obd1-manual?bbt_vehicle=1&bbt_route=bt-fit-route-honda-integra-1992-1995-obd1-manual&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-honda-integra-1992-1995-obd1-manual",
          "engineTag": "bt-fit-platform-honda-obd1-manual",
          "systems": [
            "engine-management",
            "wiring-sensors-displays"
          ],
          "systemCounts": {
            "engine-management": 1,
            "wiring-sensors-displays": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Prelude": {
      "1992–1995": [
        {
          "label": "OBD-I — manual transmission only",
          "family": "Honda OBD-I Manual / Haltech",
          "url": "/collections/all/bt-fit-route-honda-prelude-1992-1995-obd1-manual?bbt_vehicle=1&bbt_route=bt-fit-route-honda-prelude-1992-1995-obd1-manual&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-honda-prelude-1992-1995-obd1-manual",
          "engineTag": "bt-fit-platform-honda-obd1-manual",
          "systems": [
            "engine-management",
            "wiring-sensors-displays"
          ],
          "systemCounts": {
            "engine-management": 1,
            "wiring-sensors-displays": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "MINI": {
    "Cooper S": {
      "R53": [
        {
          "label": "R53 Supercharged",
          "family": "MINI Cooper S R53",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-mini-cooper-s-r53",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "url": "/collections/all/bt-fit-route-mini-cooper-s-r53?bbt_vehicle=1&bbt_route=bt-fit-route-mini-cooper-s-r53&sort_by=price-ascending",
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "R56 / R57 (2007–2010)": [
        {
          "label": "1.6L Turbo",
          "family": "MINI Cooper S R56 / R57",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-mini-cooper-s-r56-r57-16t",
          "systems": [
            "intake"
          ],
          "systemCounts": {
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-mini-cooper-s-r56-r57-16t?bbt_vehicle=1&bbt_route=bt-fit-route-mini-cooper-s-r56-r57-16t&sort_by=price-ascending",
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "R56": [
        {
          "label": "1.6L Turbo — Turbosmart direct-fit",
          "family": "MINI Turbosmart",
          "url": "/collections/all/bt-fit-route-mini-cooper-s-r56-16t-turbosmart?bbt_vehicle=1&bbt_route=bt-fit-route-mini-cooper-s-r56-16t-turbosmart&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-mini-cooper-s-r56-16t-turbosmart",
          "engineTag": "bt-fit-engine-mini-r56-16t",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 3
          },
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Component Family / Custom": {
      "Kompact EM VR10": [
        {
          "label": "Kompact EM",
          "family": "Turbosmart Component Family",
          "url": "/collections/all/bt-fit-route-mini-kompact-em-vr10?bbt_vehicle=1&bbt_route=bt-fit-route-mini-kompact-em-vr10&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-mini-kompact-em-vr10",
          "engineTag": "bt-fit-component-mini-kompact-em-vr10",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "Hyundai": {
    "Veloster": {
      "FS (2013–2017)": [
        {
          "label": "1.6L Turbo",
          "family": "Hyundai Veloster Turbo",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-hyundai-veloster-fs-2013-2017-16-turbo",
          "systems": [
            "intake"
          ],
          "systemCounts": {
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-hyundai-veloster-fs-2013-2017-16-turbo?bbt_vehicle=1&bbt_route=bt-fit-route-hyundai-veloster-fs-2013-2017-16-turbo&sort_by=price-ascending",
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "JS (2019–2020)": [
        {
          "label": "2.0L Naturally Aspirated",
          "family": "Hyundai Veloster",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-hyundai-veloster-js-2019-2020-20-na",
          "systems": [
            "intake"
          ],
          "systemCounts": {
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-hyundai-veloster-js-2019-2020-20-na?bbt_vehicle=1&bbt_route=bt-fit-route-hyundai-veloster-js-2019-2020-20-na&sort_by=price-ascending",
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Veloster N": {
      "JS (2019–2021)": [
        {
          "label": "2.0L Turbo",
          "family": "Hyundai Veloster N",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-hyundai-veloster-n-js-2019-2021-20-turbo",
          "systems": [
            "turbo-forced-induction",
            "intake"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-hyundai-veloster-n-js-2019-2021-20-turbo?bbt_vehicle=1&bbt_route=bt-fit-route-hyundai-veloster-n-js-2019-2021-20-turbo&sort_by=price-ascending",
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "i30 N": {
      "PD (2018–2023)": [
        {
          "label": "2.0L Turbo",
          "family": "Hyundai i30 N",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-hyundai-i30n-pd-2018-2023-20-turbo",
          "systems": [
            "turbo-forced-induction",
            "intake"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-hyundai-i30n-pd-2018-2023-20-turbo?bbt_vehicle=1&bbt_route=bt-fit-route-hyundai-i30n-pd-2018-2023-20-turbo&sort_by=price-ascending",
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Elantra N": {
      "CN7 (2022+)": [
        {
          "label": "2.0L Turbo",
          "family": "Hyundai Elantra N",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-hyundai-elantra-n-cn7-20t",
          "systems": [
            "intake"
          ],
          "systemCounts": {
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-hyundai-elantra-n-cn7-20t?bbt_vehicle=1&bbt_route=bt-fit-route-hyundai-elantra-n-cn7-20t&sort_by=price-ascending",
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Elantra Sport": {
      "AD (2017–2018)": [
        {
          "label": "1.6L Turbo",
          "family": "Hyundai Elantra Sport",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-hyundai-elantra-sport-ad-16t",
          "systems": [
            "intake"
          ],
          "systemCounts": {
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-hyundai-elantra-sport-ad-16t?bbt_vehicle=1&bbt_route=bt-fit-route-hyundai-elantra-sport-ad-16t&sort_by=price-ascending",
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Kona N": {
      "2.0T": [
        {
          "label": "2.0L Turbo",
          "family": "Hyundai N",
          "url": "/collections/all/bt-fit-route-hyundai-kona-n-20-turbo?bbt_vehicle=1&bbt_route=bt-fit-route-hyundai-kona-n-20-turbo&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-hyundai-kona-n-20-turbo",
          "engineTag": "bt-fit-engine-hyundai-20t",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "i20 N": {
      "1.6T": [
        {
          "label": "1.6L Turbo",
          "family": "Hyundai N",
          "url": "/collections/all/bt-fit-route-hyundai-i20n-16-turbo?bbt_vehicle=1&bbt_route=bt-fit-route-hyundai-i20n-16-turbo&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-hyundai-i20n-16-turbo",
          "engineTag": "bt-fit-engine-hyundai-16t",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "i30 N-Line": {
      "1.6T": [
        {
          "label": "1.6L Turbo",
          "family": "Hyundai N-Line",
          "url": "/collections/all/bt-fit-route-hyundai-i30-nline-16-turbo?bbt_vehicle=1&bbt_route=bt-fit-route-hyundai-i30-nline-16-turbo&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-hyundai-i30-nline-16-turbo",
          "engineTag": "bt-fit-engine-hyundai-16t",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Kona N-Line": {
      "1.6T": [
        {
          "label": "1.6L Turbo",
          "family": "Hyundai N-Line",
          "url": "/collections/all/bt-fit-route-hyundai-kona-nline-16-turbo?bbt_vehicle=1&bbt_route=bt-fit-route-hyundai-kona-nline-16-turbo&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-hyundai-kona-nline-16-turbo",
          "engineTag": "bt-fit-engine-hyundai-16t",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Veloster N-Line": {
      "1.6T": [
        {
          "label": "1.6L Turbo",
          "family": "Hyundai N-Line",
          "url": "/collections/all/bt-fit-route-hyundai-veloster-nline-16-turbo?bbt_vehicle=1&bbt_route=bt-fit-route-hyundai-veloster-nline-16-turbo&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-hyundai-veloster-nline-16-turbo",
          "engineTag": "bt-fit-engine-hyundai-16t",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "Kia": {
    "Stinger": {
      "CK (2018–2023)": [
        {
          "label": "3.3L Twin-Turbo V6",
          "family": "Kia Stinger",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-kia-stinger-ck-2018-2023-33-twin-turbo",
          "systems": [
            "turbo-forced-induction",
            "intake"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-kia-stinger-ck-2018-2023-33-twin-turbo?bbt_vehicle=1&bbt_route=bt-fit-route-kia-stinger-ck-2018-2023-33-twin-turbo&sort_by=price-ascending",
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "Genesis": {
    "G70": {
      "IK (2019–2025)": [
        {
          "label": "3.3L Twin-Turbo V6",
          "family": "Genesis G70",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-genesis-g70-ik-2019-2025-33-twin-turbo",
          "systems": [
            "intake"
          ],
          "systemCounts": {
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-genesis-g70-ik-2019-2025-33-twin-turbo?bbt_vehicle=1&bbt_route=bt-fit-route-genesis-g70-ik-2019-2025-33-twin-turbo&sort_by=price-ascending",
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "G80": {
      "3.3T": [
        {
          "label": "3.3L Twin-Turbo V6",
          "family": "Genesis 3.3T",
          "url": "/collections/all/bt-fit-route-genesis-g80-33-twin-turbo?bbt_vehicle=1&bbt_route=bt-fit-route-genesis-g80-33-twin-turbo&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-genesis-g80-33-twin-turbo",
          "engineTag": "bt-fit-engine-genesis-33tt",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "Isuzu": {
    "D-Max": {
      "2008–2018": [
        {
          "label": "4WD driveline applications",
          "family": "Isuzu D-Max",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-isuzu-dmax-2008-2018",
          "systems": [
            "exhaust",
            "transmission-driveline"
          ],
          "systemCounts": {
            "exhaust": 6,
            "transmission-driveline": 6
          },
          "url": "/collections/all/bt-fit-route-isuzu-dmax-2008-2018?bbt_vehicle=1&bbt_route=bt-fit-route-isuzu-dmax-2008-2018&sort_by=price-ascending",
          "productCount": 12,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "4JJ1 3.0L Diesel",
          "family": "Isuzu Exact Engine",
          "url": "/collections/all/bt-fit-route-isuzu-dmax-2008-2018-4jj1?bbt_vehicle=1&bbt_route=bt-fit-route-isuzu-dmax-2008-2018-4jj1&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-isuzu-dmax-2008-2018-4jj1",
          "engineTag": "bt-fit-engine-4jj1",
          "systems": [
            "exhaust"
          ],
          "systemCounts": {
            "exhaust": 6
          },
          "productCount": 6,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "MU-X": {
      "to 2018": [
        {
          "label": "4WD driveline applications",
          "family": "Isuzu MU-X",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-isuzu-mux-2008-2018",
          "systems": [
            "exhaust",
            "transmission-driveline"
          ],
          "systemCounts": {
            "exhaust": 2,
            "transmission-driveline": 6
          },
          "url": "/collections/all/bt-fit-route-isuzu-mux-2008-2018?bbt_vehicle=1&bbt_route=bt-fit-route-isuzu-mux-2008-2018&sort_by=price-ascending",
          "productCount": 8,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "2013–2021": [
        {
          "label": "4JJ1 3.0L Diesel",
          "family": "Isuzu Exact Engine",
          "url": "/collections/all/bt-fit-route-isuzu-mux-2013-2021-4jj1?bbt_vehicle=1&bbt_route=bt-fit-route-isuzu-mux-2013-2021-4jj1&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-isuzu-mux-2013-2021-4jj1",
          "engineTag": "bt-fit-engine-4jj1",
          "systems": [
            "exhaust"
          ],
          "systemCounts": {
            "exhaust": 2
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Engine Family / Custom": {
      "G180": [
        {
          "label": "G180",
          "family": "Isuzu Engine Family",
          "url": "/collections/all/bt-fit-route-isuzu-engine-family-g180?bbt_vehicle=1&bbt_route=bt-fit-route-isuzu-engine-family-g180&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-isuzu-engine-family-g180",
          "engineTag": "bt-fit-engine-g180",
          "systems": [
            "turbo-forced-induction",
            "exhaust"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "exhaust": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "Skoda": {
    "Octavia": {
      "Mk2 / 1Z": [
        {
          "label": "1.8 TFSI / 1.9–2.0 TDI",
          "family": "Skoda Octavia II",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-skoda-octavia-ii-18tfsi-19-20tdi",
          "systems": [
            "intake"
          ],
          "systemCounts": {
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-skoda-octavia-ii-18tfsi-19-20tdi?bbt_vehicle=1&bbt_route=bt-fit-route-skoda-octavia-ii-18tfsi-19-20tdi&sort_by=price-ascending",
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "EA113 2.0T — 6-speed manual",
          "family": "VAG Manual",
          "url": "/collections/all/bt-fit-route-skoda-octavia-1z-ea113-manual?bbt_vehicle=1&bbt_route=bt-fit-route-skoda-octavia-1z-ea113-manual&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-skoda-octavia-1z-ea113-manual",
          "engineTag": "bt-fit-engine-ea113",
          "systems": [
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "clutch": 1,
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "EA888 2.0T — 6-speed manual",
          "family": "VAG Manual",
          "url": "/collections/all/bt-fit-route-skoda-octavia-1z-ea888-manual?bbt_vehicle=1&bbt_route=bt-fit-route-skoda-octavia-1z-ea888-manual&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-skoda-octavia-1z-ea888-manual",
          "engineTag": "bt-fit-engine-ea888",
          "systems": [
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "clutch": 1,
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "PQ35 — FWD/AWD fuel module",
          "family": "VW AG PQ35",
          "url": "/collections/all/bt-fit-route-skoda-octavia-1z-pq35-lpfp?bbt_vehicle=1&bbt_route=bt-fit-route-skoda-octavia-1z-pq35-lpfp&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-skoda-octavia-1z-pq35-lpfp",
          "engineTag": "bt-fit-platform-pq35",
          "systems": [
            "fuel-system"
          ],
          "systemCounts": {
            "fuel-system": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "Mk3 / 5E": [
        {
          "label": "EA888 Gen 3 — 6-speed manual",
          "family": "VAG Manual",
          "url": "/collections/all/bt-fit-route-skoda-octavia-5e-ea888-manual?bbt_vehicle=1&bbt_route=bt-fit-route-skoda-octavia-5e-ea888-manual&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-skoda-octavia-5e-ea888-manual",
          "engineTag": "bt-fit-engine-ea888",
          "systems": [
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "clutch": 1,
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "DQ250 6-speed DSG",
          "family": "VAG DQ250",
          "url": "/collections/all/bt-fit-route-skoda-octavia-5e-dq250?bbt_vehicle=1&bbt_route=bt-fit-route-skoda-octavia-5e-dq250&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-skoda-octavia-5e-dq250",
          "engineTag": "bt-fit-transmission-dq250",
          "systems": [
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "clutch": 1,
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "K03 / K04": [
        {
          "label": "Factory-frame K03/K04 IWG",
          "family": "VAG K03/K04",
          "url": "/collections/all/bt-fit-route-skoda-octavia-k03-k04-iwg?bbt_vehicle=1&bbt_route=bt-fit-route-skoda-octavia-k03-k04-iwg&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-skoda-octavia-k03-k04-iwg",
          "engineTag": "bt-fit-turbo-vag-k03-k04",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Superb": {
      "3T": [
        {
          "label": "EA888 2.0T — 6-speed manual",
          "family": "VAG Manual",
          "url": "/collections/all/bt-fit-route-skoda-superb-3t-ea888-manual?bbt_vehicle=1&bbt_route=bt-fit-route-skoda-superb-3t-ea888-manual&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-skoda-superb-3t-ea888-manual",
          "engineTag": "bt-fit-engine-ea888",
          "systems": [
            "clutch",
            "transmission-driveline"
          ],
          "systemCounts": {
            "clutch": 1,
            "transmission-driveline": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Component Family / Custom": {
      "TFSI Kompact EM VR1": [
        {
          "label": "Kompact EM",
          "family": "Turbosmart Component Family",
          "url": "/collections/all/bt-fit-route-skoda-tfsi-kompact-em-vr1?bbt_vehicle=1&bbt_route=bt-fit-route-skoda-tfsi-kompact-em-vr1&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-skoda-tfsi-kompact-em-vr1",
          "engineTag": "bt-fit-component-skoda-tfsi-kompact-em-vr1",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "1.4 TSI Kompact EM VR4": [
        {
          "label": "Kompact EM",
          "family": "Turbosmart Component Family",
          "url": "/collections/all/bt-fit-route-skoda-14tsi-kompact-em-vr4?bbt_vehicle=1&bbt_route=bt-fit-route-skoda-14tsi-kompact-em-vr4&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-skoda-14tsi-kompact-em-vr4",
          "engineTag": "bt-fit-component-skoda-14tsi-kompact-em-vr4",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "Jeep": {
    "Wrangler": {
      "JL (2018–2025)": [
        {
          "label": "3.6L Pentastar — non-eTorque",
          "family": "Jeep Wrangler JL",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-jeep-wrangler-jl-36-pentastar-non-etorque",
          "systems": [
            "turbo-forced-induction",
            "intake"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-jeep-wrangler-jl-36-pentastar-non-etorque?bbt_vehicle=1&bbt_route=bt-fit-route-jeep-wrangler-jl-36-pentastar-non-etorque&sort_by=price-ascending",
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "JL / 2024+": [
        {
          "label": "Kompact EM VR34 direct-fit",
          "family": "Jeep Kompact EM",
          "url": "/collections/all/bt-fit-route-jeep-wrangler-jl-2024-kompact-em?bbt_vehicle=1&bbt_route=bt-fit-route-jeep-wrangler-jl-2024-kompact-em&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-jeep-wrangler-jl-2024-kompact-em",
          "engineTag": "bt-fit-component-vr34",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Gladiator": {
      "JT (2020–2025)": [
        {
          "label": "3.6L Pentastar",
          "family": "Jeep Gladiator JT",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-jeep-gladiator-jt-36-pentastar",
          "systems": [
            "turbo-forced-induction",
            "intake"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-jeep-gladiator-jt-36-pentastar?bbt_vehicle=1&bbt_route=bt-fit-route-jeep-gladiator-jt-36-pentastar&sort_by=price-ascending",
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Patriot": {
      "2011–2017": [
        {
          "label": "2.0L / 2.4L",
          "family": "Jeep Patriot",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-jeep-patriot-2011-2017-20-24",
          "systems": [
            "intake"
          ],
          "systemCounts": {
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-jeep-patriot-2011-2017-20-24?bbt_vehicle=1&bbt_route=bt-fit-route-jeep-patriot-2011-2017-20-24&sort_by=price-ascending",
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Compass": {
      "2011–2017": [
        {
          "label": "2.0L / 2.4L",
          "family": "Jeep Compass",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-jeep-compass-2011-2017-20-24",
          "systems": [
            "intake"
          ],
          "systemCounts": {
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-jeep-compass-2011-2017-20-24?bbt_vehicle=1&bbt_route=bt-fit-route-jeep-compass-2011-2017-20-24&sort_by=price-ascending",
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Grand Cherokee": {
      "2016–2022": [
        {
          "label": "3.6L Pentastar V6",
          "family": "Jeep Grand Cherokee",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-jeep-grand-cherokee-2016-2022-36-pentastar",
          "systems": [
            "intake"
          ],
          "systemCounts": {
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-jeep-grand-cherokee-2016-2022-36-pentastar?bbt_vehicle=1&bbt_route=bt-fit-route-jeep-grand-cherokee-2016-2022-36-pentastar&sort_by=price-ascending",
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "2011–2021": [
        {
          "label": "5.7L HEMI V8",
          "family": "Jeep Grand Cherokee",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-jeep-grand-cherokee-2011-2021-57-hemi",
          "systems": [
            "intake"
          ],
          "systemCounts": {
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-jeep-grand-cherokee-2011-2021-57-hemi?bbt_vehicle=1&bbt_route=bt-fit-route-jeep-grand-cherokee-2011-2021-57-hemi&sort_by=price-ascending",
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "SRT 6.4L HEMI V8",
          "family": "Jeep Grand Cherokee SRT",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-jeep-grand-cherokee-srt-2012-2021-64-hemi",
          "systems": [
            "intake"
          ],
          "systemCounts": {
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-jeep-grand-cherokee-srt-2012-2021-64-hemi?bbt_vehicle=1&bbt_route=bt-fit-route-jeep-grand-cherokee-srt-2012-2021-64-hemi&sort_by=price-ascending",
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "2018–2021": [
        {
          "label": "Trackhawk 6.2L Supercharged HEMI",
          "family": "Jeep Grand Cherokee Trackhawk",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-jeep-grand-cherokee-trackhawk-2018-2021-62-supercharged",
          "systems": [
            "intake",
            "engine-parts"
          ],
          "systemCounts": {
            "intake": 1,
            "engine-parts": 1
          },
          "url": "/collections/all/bt-fit-route-jeep-grand-cherokee-trackhawk-2018-2021-62-supercharged?bbt_vehicle=1&bbt_route=bt-fit-route-jeep-grand-cherokee-trackhawk-2018-2021-62-supercharged&sort_by=price-ascending",
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Wagoneer": {
      "3.0 Hurricane": [
        {
          "label": "3.0L Hurricane SO / HO",
          "family": "Hurricane",
          "url": "/collections/all/bt-fit-route-jeep-wagoneer-30-hurricane?bbt_vehicle=1&bbt_route=bt-fit-route-jeep-wagoneer-30-hurricane&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-jeep-wagoneer-30-hurricane",
          "engineTag": "bt-fit-engine-hurricane-30",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Component Family / Custom": {
      "Kompact EM VR3": [
        {
          "label": "Kompact EM",
          "family": "Turbosmart Component Family",
          "url": "/collections/all/bt-fit-route-jeep-kompact-em-vr3?bbt_vehicle=1&bbt_route=bt-fit-route-jeep-kompact-em-vr3&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-jeep-kompact-em-vr3",
          "engineTag": "bt-fit-component-jeep-kompact-em-vr3",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "Dodge": {
    "Durango": {
      "2016–2026": [
        {
          "label": "3.6L Pentastar V6",
          "family": "Dodge Durango",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-dodge-durango-2016-2026-36-pentastar",
          "systems": [
            "intake"
          ],
          "systemCounts": {
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-dodge-durango-2016-2026-36-pentastar?bbt_vehicle=1&bbt_route=bt-fit-route-dodge-durango-2016-2026-36-pentastar&sort_by=price-ascending",
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "2011–2026": [
        {
          "label": "5.7L HEMI V8",
          "family": "Dodge Durango",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-dodge-durango-2011-2026-57-hemi",
          "systems": [
            "intake"
          ],
          "systemCounts": {
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-dodge-durango-2011-2026-57-hemi?bbt_vehicle=1&bbt_route=bt-fit-route-dodge-durango-2011-2026-57-hemi&sort_by=price-ascending",
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "2018–2023": [
        {
          "label": "SRT 6.4L HEMI V8",
          "family": "Dodge Durango SRT",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-dodge-durango-srt-2018-2023-64-hemi",
          "systems": [
            "intake"
          ],
          "systemCounts": {
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-dodge-durango-srt-2018-2023-64-hemi?bbt_vehicle=1&bbt_route=bt-fit-route-dodge-durango-srt-2018-2023-64-hemi&sort_by=price-ascending",
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "2021–2023": [
        {
          "label": "SRT Hellcat 6.2L Supercharged HEMI",
          "family": "Dodge Durango SRT Hellcat",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-dodge-durango-srt-hellcat-2021-2023-62-supercharged",
          "systems": [
            "intake"
          ],
          "systemCounts": {
            "intake": 1
          },
          "url": "/collections/all/bt-fit-route-dodge-durango-srt-hellcat-2021-2023-62-supercharged?bbt_vehicle=1&bbt_route=bt-fit-route-dodge-durango-srt-hellcat-2021-2023-62-supercharged&sort_by=price-ascending",
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Challenger": {
      "2015–2017 Hellcat": [
        {
          "label": "6.2L Supercharged HEMI",
          "family": "Mopar Hellcat",
          "url": "/collections/all/bt-fit-route-dodge-challenger-2015-2017-hellcat-6-2?bbt_vehicle=1&bbt_route=bt-fit-route-dodge-challenger-2015-2017-hellcat-6-2&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-dodge-challenger-2015-2017-hellcat-6-2",
          "engineTag": "bt-fit-engine-hemi-6-2-supercharged",
          "systems": [
            "fuel-system",
            "intake"
          ],
          "systemCounts": {
            "fuel-system": 1,
            "intake": 1
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "2011–2021 SRT": [
        {
          "label": "6.4L HEMI",
          "family": "Mopar SRT",
          "url": "/collections/all/bt-fit-route-dodge-challenger-2011-2021-srt-6-4?bbt_vehicle=1&bbt_route=bt-fit-route-dodge-challenger-2011-2021-srt-6-4&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-dodge-challenger-2011-2021-srt-6-4",
          "engineTag": "bt-fit-engine-hemi-6-4",
          "systems": [
            "turbo-forced-induction",
            "intake"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "intake": 1
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "2011–2024": [
        {
          "label": "5.7L HEMI V8",
          "family": "Mopar HEMI",
          "url": "/collections/all/bt-fit-route-dodge-challenger-2011-2024-5-7-hemi?bbt_vehicle=1&bbt_route=bt-fit-route-dodge-challenger-2011-2024-5-7-hemi&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-dodge-challenger-2011-2024-5-7-hemi",
          "engineTag": "bt-fit-engine-hemi-5-7",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "2008–2021": [
        {
          "label": "HEMI fuel-module fitment — excludes 6.2 Hellcat",
          "family": "DeatschWerks HEMI Fuel Module",
          "url": "/collections/all/bt-fit-route-dodge-challenger-2008-2021-hemi-dw-module?bbt_vehicle=1&bbt_route=bt-fit-route-dodge-challenger-2008-2021-hemi-dw-module&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-dodge-challenger-2008-2021-hemi-dw-module",
          "engineTag": "bt-fit-engine-hemi",
          "systems": [
            "fuel-system"
          ],
          "systemCounts": {
            "fuel-system": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Charger": {
      "2015–2017 Hellcat": [
        {
          "label": "6.2L Supercharged HEMI",
          "family": "Mopar Hellcat",
          "url": "/collections/all/bt-fit-route-dodge-charger-2015-2017-hellcat-6-2?bbt_vehicle=1&bbt_route=bt-fit-route-dodge-charger-2015-2017-hellcat-6-2&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-dodge-charger-2015-2017-hellcat-6-2",
          "engineTag": "bt-fit-engine-hemi-6-2-supercharged",
          "systems": [
            "fuel-system",
            "intake"
          ],
          "systemCounts": {
            "fuel-system": 1,
            "intake": 1
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "2012–2021 SRT": [
        {
          "label": "6.4L HEMI",
          "family": "Mopar SRT",
          "url": "/collections/all/bt-fit-route-dodge-charger-2012-2021-srt-6-4?bbt_vehicle=1&bbt_route=bt-fit-route-dodge-charger-2012-2021-srt-6-4&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-dodge-charger-2012-2021-srt-6-4",
          "engineTag": "bt-fit-engine-hemi-6-4",
          "systems": [
            "turbo-forced-induction",
            "intake"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "intake": 1
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "2011–2024": [
        {
          "label": "5.7L HEMI V8",
          "family": "Mopar HEMI",
          "url": "/collections/all/bt-fit-route-dodge-charger-2011-2024-5-7-hemi?bbt_vehicle=1&bbt_route=bt-fit-route-dodge-charger-2011-2024-5-7-hemi&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-dodge-charger-2011-2024-5-7-hemi",
          "engineTag": "bt-fit-engine-hemi-5-7",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "2006–2021": [
        {
          "label": "HEMI fuel-module fitment — excludes 6.2 Hellcat",
          "family": "DeatschWerks HEMI Fuel Module",
          "url": "/collections/all/bt-fit-route-dodge-charger-2006-2021-hemi-dw-module?bbt_vehicle=1&bbt_route=bt-fit-route-dodge-charger-2006-2021-hemi-dw-module&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-dodge-charger-2006-2021-hemi-dw-module",
          "engineTag": "bt-fit-engine-hemi",
          "systems": [
            "fuel-system"
          ],
          "systemCounts": {
            "fuel-system": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "Pontiac": {
    "G8": {
      "VE Platform / 2008–2009": [
        {
          "label": "3.6L V6",
          "family": "Pontiac G8",
          "url": "/collections/all/bt-fit-route-pontiac-g8-ve-3-6-v6?bbt_vehicle=1&bbt_route=bt-fit-route-pontiac-g8-ve-3-6-v6&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-pontiac-g8-ve-3-6-v6",
          "engineTag": "bt-fit-engine-pontiac-3-6-v6",
          "systems": [
            "intake"
          ],
          "systemCounts": {
            "intake": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "RAM": {
    "1500": {
      "DS / Classic": [
        {
          "label": "5.7L HEMI V8",
          "family": "RAM 1500",
          "url": "/collections/all/bt-fit-route-ram-1500-ds-5-7-hemi?bbt_vehicle=1&bbt_route=bt-fit-route-ram-1500-ds-5-7-hemi&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ram-1500-ds-5-7-hemi",
          "engineTag": "bt-fit-engine-hemi-5-7",
          "systems": [
            "turbo-forced-induction",
            "intake"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "intake": 1
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "DT": [
        {
          "label": "5.7L HEMI V8",
          "family": "RAM 1500",
          "url": "/collections/all/bt-fit-route-ram-1500-dt-5-7-hemi?bbt_vehicle=1&bbt_route=bt-fit-route-ram-1500-dt-5-7-hemi&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ram-1500-dt-5-7-hemi",
          "engineTag": "bt-fit-engine-hemi-5-7",
          "systems": [
            "turbo-forced-induction",
            "intake"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "intake": 3
          },
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "5.7L HEMI V8 eTorque",
          "family": "RAM 1500",
          "url": "/collections/all/bt-fit-route-ram-1500-dt-5-7-hemi-etorque?bbt_vehicle=1&bbt_route=bt-fit-route-ram-1500-dt-5-7-hemi-etorque&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ram-1500-dt-5-7-hemi-etorque",
          "engineTag": "bt-fit-engine-hemi-5-7-etorque",
          "systems": [
            "turbo-forced-induction",
            "intake"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "intake": 3
          },
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "3.0L Twin-Turbo I6",
          "family": "RAM 1500",
          "url": "/collections/all/bt-fit-route-ram-1500-dt-3-0-tt-i6?bbt_vehicle=1&bbt_route=bt-fit-route-ram-1500-dt-3-0-tt-i6&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ram-1500-dt-3-0-tt-i6",
          "engineTag": "bt-fit-engine-ram-3-0-tt-i6",
          "systems": [
            "turbo-forced-induction",
            "intake"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "intake": 1
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "DT / TRX": [
        {
          "label": "6.2L Supercharged HEMI V8",
          "family": "RAM 1500 TRX",
          "url": "/collections/all/bt-fit-route-ram-1500-dt-trx-6-2?bbt_vehicle=1&bbt_route=bt-fit-route-ram-1500-dt-trx-6-2&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ram-1500-dt-trx-6-2",
          "engineTag": "bt-fit-engine-hemi-6-2-supercharged",
          "systems": [
            "intake"
          ],
          "systemCounts": {
            "intake": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "GMC": {
    "Sierra 1500": {
      "K2XX": [
        {
          "label": "5.3L / 6.2L V8",
          "family": "GM K2XX",
          "url": "/collections/all/bt-fit-route-gmc-sierra1500-k2xx-5-3-6-2?bbt_vehicle=1&bbt_route=bt-fit-route-gmc-sierra1500-k2xx-5-3-6-2&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-gmc-sierra1500-k2xx-5-3-6-2",
          "engineTag": "bt-fit-engine-gm-v8-5-3-6-2",
          "systems": [],
          "systemCounts": {},
          "productCount": 0,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "T1XX / 2019+": [
        {
          "label": "5.3L / 6.2L V8",
          "family": "GM T1XX",
          "url": "/collections/all/bt-fit-route-gmc-sierra1500-t1xx-5-3-6-2?bbt_vehicle=1&bbt_route=bt-fit-route-gmc-sierra1500-t1xx-5-3-6-2&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-gmc-sierra1500-t1xx-5-3-6-2",
          "engineTag": "bt-fit-engine-gm-v8-5-3-6-2",
          "systems": [
            "intake"
          ],
          "systemCounts": {
            "intake": 4
          },
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "L87 6.2L V8",
          "family": "GM L87 6.2L",
          "url": "/collections/all/bt-fit-route-gmc-sierra1500-t1xx-l87-6-2?bbt_vehicle=1&bbt_route=bt-fit-route-gmc-sierra1500-t1xx-l87-6-2&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-gmc-sierra1500-t1xx-l87-6-2",
          "engineTag": "bt-fit-engine-l87",
          "systems": [
            "turbo-forced-induction",
            "intake"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "intake": 5
          },
          "productCount": 6,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Sierra 2500 / 3500 HD": {
      "2020+": [
        {
          "label": "6.6L Duramax Diesel",
          "family": "GM HD",
          "url": "/collections/all/bt-fit-route-gmc-sierra-hd-2020-6-6-duramax?bbt_vehicle=1&bbt_route=bt-fit-route-gmc-sierra-hd-2020-6-6-duramax&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-gmc-sierra-hd-2020-6-6-duramax",
          "engineTag": "bt-fit-engine-duramax-6-6",
          "systems": [
            "intake"
          ],
          "systemCounts": {
            "intake": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "L8T 6.6L Gas V8",
          "family": "GM L8T 6.6L",
          "url": "/collections/all/bt-fit-route-gmc-sierra-hd-2020-6-6-gas?bbt_vehicle=1&bbt_route=bt-fit-route-gmc-sierra-hd-2020-6-6-gas&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-gmc-sierra-hd-2020-6-6-gas",
          "engineTag": "bt-fit-engine-l8t",
          "systems": [
            "fuel-system",
            "engine-parts"
          ],
          "systemCounts": {
            "fuel-system": 1,
            "engine-parts": 1
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Yukon / Yukon XL": {
      "2021+": [
        {
          "label": "5.3L / 6.2L V8",
          "family": "GM T1XX SUV",
          "url": "/collections/all/bt-fit-route-gmc-yukon-2021-5-3-6-2?bbt_vehicle=1&bbt_route=bt-fit-route-gmc-yukon-2021-5-3-6-2&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-gmc-yukon-2021-5-3-6-2",
          "engineTag": "bt-fit-engine-gm-v8-5-3-6-2",
          "systems": [
            "intake"
          ],
          "systemCounts": {
            "intake": 4
          },
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "L87 6.2L V8",
          "family": "GM L87 6.2L",
          "url": "/collections/all/bt-fit-route-gmc-yukon-2021-l87-6-2?bbt_vehicle=1&bbt_route=bt-fit-route-gmc-yukon-2021-l87-6-2&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-gmc-yukon-2021-l87-6-2",
          "engineTag": "bt-fit-engine-l87",
          "systems": [
            "turbo-forced-induction",
            "intake"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "intake": 4
          },
          "productCount": 5,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Acadia": {
      "2017–2020": [
        {
          "label": "3.6L V6",
          "family": "GM 3.6 V6",
          "url": "/collections/all/bt-fit-route-gmc-acadia-2017-2020-3-6-v6?bbt_vehicle=1&bbt_route=bt-fit-route-gmc-acadia-2017-2020-3-6-v6&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-gmc-acadia-2017-2020-3-6-v6",
          "engineTag": "bt-fit-engine-gm-3-6-v6",
          "systems": [
            "intake"
          ],
          "systemCounts": {
            "intake": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "Cadillac": {
    "Escalade": {
      "2021+": [
        {
          "label": "6.2L V8",
          "family": "GM T1XX SUV",
          "url": "/collections/all/bt-fit-route-cadillac-escalade-2021-6-2?bbt_vehicle=1&bbt_route=bt-fit-route-cadillac-escalade-2021-6-2&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-cadillac-escalade-2021-6-2",
          "engineTag": "bt-fit-engine-gm-v8-6-2",
          "systems": [
            "intake"
          ],
          "systemCounts": {
            "intake": 4
          },
          "productCount": 4,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        },
        {
          "label": "L87 6.2L V8",
          "family": "GM L87 6.2L",
          "url": "/collections/all/bt-fit-route-cadillac-escalade-2021-l87-6-2?bbt_vehicle=1&bbt_route=bt-fit-route-cadillac-escalade-2021-l87-6-2&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-cadillac-escalade-2021-l87-6-2",
          "engineTag": "bt-fit-engine-l87",
          "systems": [
            "turbo-forced-induction",
            "intake"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "intake": 4
          },
          "productCount": 5,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "XT5": {
      "2017–2020": [
        {
          "label": "3.6L V6",
          "family": "GM 3.6 V6",
          "url": "/collections/all/bt-fit-route-cadillac-xt5-2017-2020-3-6-v6?bbt_vehicle=1&bbt_route=bt-fit-route-cadillac-xt5-2017-2020-3-6-v6&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-cadillac-xt5-2017-2020-3-6-v6",
          "engineTag": "bt-fit-engine-gm-3-6-v6",
          "systems": [
            "intake"
          ],
          "systemCounts": {
            "intake": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Engine Family / Custom": {
      "LTG 2.0T": [
        {
          "label": "GM LTG 2.0L Turbo",
          "family": "GM LTG",
          "url": "/collections/all/bt-fit-route-cadillac-engine-family-ltg-2-0t?bbt_vehicle=1&bbt_route=bt-fit-route-cadillac-engine-family-ltg-2-0t&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-cadillac-engine-family-ltg-2-0t",
          "engineTag": "bt-fit-engine-ltg",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "ATS-V": {
      "2015+": [
        {
          "label": "3.6L Twin-Turbo V6",
          "family": "Cadillac ATS-V",
          "url": "/collections/all/bt-fit-route-cadillac-atsv-2015-36tt?bbt_vehicle=1&bbt_route=bt-fit-route-cadillac-atsv-2015-36tt&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-cadillac-atsv-2015-36tt",
          "engineTag": "bt-fit-engine-lf4",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "Chrysler": {
    "300 / 300C": {
      "2012–2015 SRT": [
        {
          "label": "6.4L HEMI",
          "family": "Mopar SRT",
          "url": "/collections/all/bt-fit-route-chrysler-300-2012-2015-srt-6-4?bbt_vehicle=1&bbt_route=bt-fit-route-chrysler-300-2012-2015-srt-6-4&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-chrysler-300-2012-2015-srt-6-4",
          "engineTag": "bt-fit-engine-hemi-6-4",
          "systems": [
            "turbo-forced-induction",
            "intake"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "intake": 1
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "2011–2024": [
        {
          "label": "5.7L HEMI V8",
          "family": "Mopar HEMI",
          "url": "/collections/all/bt-fit-route-chrysler-300-2011-2024-5-7-hemi?bbt_vehicle=1&bbt_route=bt-fit-route-chrysler-300-2011-2024-5-7-hemi&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-chrysler-300-2011-2024-5-7-hemi",
          "engineTag": "bt-fit-engine-hemi-5-7",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "2006–2019": [
        {
          "label": "HEMI fuel-module fitment — excludes 6.2 Hellcat",
          "family": "DeatschWerks HEMI Fuel Module",
          "url": "/collections/all/bt-fit-route-chrysler-300-2006-2019-hemi-dw-module?bbt_vehicle=1&bbt_route=bt-fit-route-chrysler-300-2006-2019-hemi-dw-module&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-chrysler-300-2006-2019-hemi-dw-module",
          "engineTag": "bt-fit-engine-hemi",
          "systems": [
            "fuel-system"
          ],
          "systemCounts": {
            "fuel-system": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "2020–2021": [
        {
          "label": "6.4L HEMI fuel-module fitment",
          "family": "DeatschWerks HEMI Fuel Module",
          "url": "/collections/all/bt-fit-route-chrysler-300-2020-2021-6-4-dw-module?bbt_vehicle=1&bbt_route=bt-fit-route-chrysler-300-2020-2021-6-4-dw-module&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-chrysler-300-2020-2021-6-4-dw-module",
          "engineTag": "bt-fit-engine-hemi-6-4",
          "systems": [
            "fuel-system"
          ],
          "systemCounts": {
            "fuel-system": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "Mercedes-Benz": {
    "A-Class": {
      "W176": [
        {
          "label": "1.6L / 2.0L Turbo Petrol",
          "family": "Mercedes Compact",
          "url": "/collections/all/bt-fit-route-mercedes-a-class-w176-petrol-turbo?bbt_vehicle=1&bbt_route=bt-fit-route-mercedes-a-class-w176-petrol-turbo&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-mercedes-a-class-w176-petrol-turbo",
          "engineTag": "bt-fit-engine-mercedes-m270",
          "systems": [
            "intake"
          ],
          "systemCounts": {
            "intake": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "CLA-Class": {
      "C117": [
        {
          "label": "1.6L / 2.0L Turbo Petrol",
          "family": "Mercedes Compact",
          "url": "/collections/all/bt-fit-route-mercedes-cla-c117-petrol-turbo?bbt_vehicle=1&bbt_route=bt-fit-route-mercedes-cla-c117-petrol-turbo&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-mercedes-cla-c117-petrol-turbo",
          "engineTag": "bt-fit-engine-mercedes-m270",
          "systems": [
            "intake"
          ],
          "systemCounts": {
            "intake": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "C63 AMG": {
      "Kompact EM VR29": [
        {
          "label": "Direct-fit electronic BOV",
          "family": "Mercedes C63",
          "url": "/collections/all/bt-fit-route-mercedes-c63-kompact-em-vr29?bbt_vehicle=1&bbt_route=bt-fit-route-mercedes-c63-kompact-em-vr29&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-mercedes-c63-kompact-em-vr29",
          "engineTag": "bt-fit-component-vr29",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "C300": {
      "W206": [
        {
          "label": "M254 Turbo",
          "family": "Mercedes W206",
          "url": "/collections/all/bt-fit-route-mercedes-c300-w206-m254?bbt_vehicle=1&bbt_route=bt-fit-route-mercedes-c300-w206-m254&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-mercedes-c300-w206-m254",
          "engineTag": "bt-fit-engine-m254",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Component Family / Custom": {
      "AMG Kompact EM VR2": [
        {
          "label": "Kompact EM",
          "family": "Turbosmart Component Family",
          "url": "/collections/all/bt-fit-route-mercedes-amg-kompact-em-vr2?bbt_vehicle=1&bbt_route=bt-fit-route-mercedes-amg-kompact-em-vr2&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-mercedes-amg-kompact-em-vr2",
          "engineTag": "bt-fit-component-mercedes-amg-kompact-em-vr2",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "Saturn": {
    "Ion Red Line": {
      "2004–2007": [
        {
          "label": "LSJ 2.0L Supercharged",
          "family": "GM LSJ",
          "url": "/collections/all/bt-fit-route-saturn-ion-red-line-2004-2007-lsj?bbt_vehicle=1&bbt_route=bt-fit-route-saturn-ion-red-line-2004-2007-lsj&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-saturn-ion-red-line-2004-2007-lsj",
          "engineTag": "bt-fit-engine-lsj",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "Fiat": {
    "Fullback": {
      "2016+": [
        {
          "label": "Driveline / ELocker-compatible axle",
          "family": "Harrop ELocker",
          "url": "/collections/all/bt-fit-route-fiat-fullback-2016-harrop-driveline?bbt_vehicle=1&bbt_route=bt-fit-route-fiat-fullback-2016-harrop-driveline&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-fiat-fullback-2016-harrop-driveline",
          "engineTag": "bt-fit-driveline-harrop-elocker",
          "systems": [
            "transmission-driveline"
          ],
          "systemCounts": {
            "transmission-driveline": 2
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "124 Spider": {
      "1.4 MultiAir": [
        {
          "label": "Factory turbo / IWG",
          "family": "Fiat MultiAir",
          "url": "/collections/all/bt-fit-route-fiat-124-spider-1-4-multiair?bbt_vehicle=1&bbt_route=bt-fit-route-fiat-124-spider-1-4-multiair&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-fiat-124-spider-1-4-multiair",
          "engineTag": "bt-fit-engine-fiat-1-4-multiair",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "500T": {
      "2012+": [
        {
          "label": "1.4 MultiAir Turbo",
          "family": "Fiat MultiAir",
          "url": "/collections/all/bt-fit-route-fiat-500t-1-4-multiair?bbt_vehicle=1&bbt_route=bt-fit-route-fiat-500t-1-4-multiair&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-fiat-500t-1-4-multiair",
          "engineTag": "bt-fit-engine-fiat-1-4-multiair",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "500L": {
      "1.4 MultiAir Turbo": [
        {
          "label": "Factory turbo / IWG",
          "family": "Fiat MultiAir",
          "url": "/collections/all/bt-fit-route-fiat-500l-1-4-multiair?bbt_vehicle=1&bbt_route=bt-fit-route-fiat-500l-1-4-multiair&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-fiat-500l-1-4-multiair",
          "engineTag": "bt-fit-engine-fiat-1-4-multiair",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "500X": {
      "1.4 MultiAir Turbo": [
        {
          "label": "Factory turbo / IWG",
          "family": "Fiat MultiAir",
          "url": "/collections/all/bt-fit-route-fiat-500x-1-4-multiair?bbt_vehicle=1&bbt_route=bt-fit-route-fiat-500x-1-4-multiair&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-fiat-500x-1-4-multiair",
          "engineTag": "bt-fit-engine-fiat-1-4-multiair",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Component Family / Custom": {
      "Kompact EM VR15": [
        {
          "label": "Kompact EM",
          "family": "Turbosmart Component Family",
          "url": "/collections/all/bt-fit-route-fiat-kompact-em-vr15?bbt_vehicle=1&bbt_route=bt-fit-route-fiat-kompact-em-vr15&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-fiat-kompact-em-vr15",
          "engineTag": "bt-fit-component-fiat-kompact-em-vr15",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "Porsche": {
    "911": {
      "993 Turbo": [
        {
          "label": "3.6L Twin-Turbo",
          "family": "Porsche IWG",
          "url": "/collections/all/bt-fit-route-porsche-911-993-turbo-3-6?bbt_vehicle=1&bbt_route=bt-fit-route-porsche-911-993-turbo-3-6&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-porsche-911-993-turbo-3-6",
          "engineTag": "bt-fit-engine-porsche-993-turbo",
          "systems": [
            "turbo-forced-induction",
            "engine-parts"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "engine-parts": 6
          },
          "productCount": 7,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "996 Turbo": [
        {
          "label": "3.6L Twin-Turbo",
          "family": "Porsche IWG",
          "url": "/collections/all/bt-fit-route-porsche-911-996-turbo-3-6?bbt_vehicle=1&bbt_route=bt-fit-route-porsche-911-996-turbo-3-6&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-porsche-911-996-turbo-3-6",
          "engineTag": "bt-fit-engine-porsche-996-turbo",
          "systems": [
            "turbo-forced-induction",
            "engine-parts"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "engine-parts": 6
          },
          "productCount": 7,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "996 GT2": [
        {
          "label": "3.6L Twin-Turbo",
          "family": "Porsche IWG",
          "url": "/collections/all/bt-fit-route-porsche-911-996-gt2-3-6?bbt_vehicle=1&bbt_route=bt-fit-route-porsche-911-996-gt2-3-6&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-porsche-911-996-gt2-3-6",
          "engineTag": "bt-fit-engine-porsche-996-gt2",
          "systems": [
            "turbo-forced-induction",
            "engine-parts"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "engine-parts": 5
          },
          "productCount": 6,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "997 Turbo": [
        {
          "label": "Factory turbo diverter-valve fitment",
          "family": "Porsche 997",
          "url": "/collections/all/bt-fit-route-porsche-911-997-turbo?bbt_vehicle=1&bbt_route=bt-fit-route-porsche-911-997-turbo&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-porsche-911-997-turbo",
          "engineTag": "bt-fit-engine-porsche-997-turbo",
          "systems": [
            "turbo-forced-induction",
            "engine-parts"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "engine-parts": 2
          },
          "productCount": 3,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "997 GT2": [
        {
          "label": "Factory turbo diverter-valve fitment",
          "family": "Porsche 997",
          "url": "/collections/all/bt-fit-route-porsche-911-997-gt2?bbt_vehicle=1&bbt_route=bt-fit-route-porsche-911-997-gt2&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-porsche-911-997-gt2",
          "engineTag": "bt-fit-engine-porsche-997-gt2",
          "systems": [
            "turbo-forced-induction",
            "engine-parts"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1,
            "engine-parts": 1
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "Abarth": {
    "Engine Family / Custom": {
      "1.4 MultiAir": [
        {
          "label": "1.4L MultiAir Turbo",
          "family": "Abarth MultiAir",
          "url": "/collections/all/bt-fit-route-abarth-engine-family-1-4-multiair?bbt_vehicle=1&bbt_route=bt-fit-route-abarth-engine-family-1-4-multiair&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-abarth-engine-family-1-4-multiair",
          "engineTag": "bt-fit-engine-fiat-1-4-multiair",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Component Family / Custom": {
      "Kompact EM VR15": [
        {
          "label": "Kompact EM",
          "family": "Turbosmart Component Family",
          "url": "/collections/all/bt-fit-route-abarth-kompact-em-vr15?bbt_vehicle=1&bbt_route=bt-fit-route-abarth-kompact-em-vr15&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-abarth-kompact-em-vr15",
          "engineTag": "bt-fit-component-abarth-kompact-em-vr15",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "Renault": {
    "Clio RS": {
      "1.6T": [
        {
          "label": "1.6L Turbo",
          "family": "Renault IWG",
          "url": "/collections/all/bt-fit-route-renault-clio-rs-1-6t?bbt_vehicle=1&bbt_route=bt-fit-route-renault-clio-rs-1-6t&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-renault-clio-rs-1-6t",
          "engineTag": "bt-fit-engine-renault-1-6t",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Megane RS": {
      "RS250": [
        {
          "label": "2.0L Turbo",
          "family": "Renault IWG",
          "url": "/collections/all/bt-fit-route-renault-megane-rs250-2-0t?bbt_vehicle=1&bbt_route=bt-fit-route-renault-megane-rs250-2-0t&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-renault-megane-rs250-2-0t",
          "engineTag": "bt-fit-engine-renault-rs250",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "RS265": [
        {
          "label": "2.0L Turbo",
          "family": "Renault Megane RS",
          "url": "/collections/all/bt-fit-route-renault-megane-rs265-20t?bbt_vehicle=1&bbt_route=bt-fit-route-renault-megane-rs265-20t&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-renault-megane-rs265-20t",
          "engineTag": "bt-fit-engine-renault-rs265",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "Vauxhall / Opel": {
    "Astra VXR": {
      "Type H": [
        {
          "label": "Factory turbo / IWG",
          "family": "Vauxhall Opel IWG",
          "url": "/collections/all/bt-fit-route-vauxhall-opel-astra-h-vxr?bbt_vehicle=1&bbt_route=bt-fit-route-vauxhall-opel-astra-h-vxr&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-vauxhall-opel-astra-h-vxr",
          "engineTag": "bt-fit-engine-astra-vxr",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Corsa VXR": {
      "VXR": [
        {
          "label": "Factory turbo / IWG",
          "family": "Vauxhall Opel IWG",
          "url": "/collections/all/bt-fit-route-vauxhall-opel-corsa-vxr?bbt_vehicle=1&bbt_route=bt-fit-route-vauxhall-opel-corsa-vxr&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-vauxhall-opel-corsa-vxr",
          "engineTag": "bt-fit-engine-corsa-vxr",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 2
          },
          "productCount": 2,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Insignia": {
      "LTG 2.0T": [
        {
          "label": "GM LTG 2.0L Turbo",
          "family": "GM LTG",
          "url": "/collections/all/bt-fit-route-vauxhall-opel-insignia-ltg-20t?bbt_vehicle=1&bbt_route=bt-fit-route-vauxhall-opel-insignia-ltg-20t&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-vauxhall-opel-insignia-ltg-20t",
          "engineTag": "bt-fit-engine-ltg",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "Dodge / RAM": {
    "Engine Family / Custom": {
      "Cummins Turbo Diesel": [
        {
          "label": "Dodge/RAM Cummins Turbo Diesel IWG",
          "family": "Cummins IWG",
          "url": "/collections/all/bt-fit-route-dodge-ram-engine-family-cummins-turbo-diesel?bbt_vehicle=1&bbt_route=bt-fit-route-dodge-ram-engine-family-cummins-turbo-diesel&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-dodge-ram-engine-family-cummins-turbo-diesel",
          "engineTag": "bt-fit-engine-cummins-turbo-diesel",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "Volvo": {
    "C30": {
      "T5": [
        {
          "label": "T5 Turbo — Turbosmart direct-fit",
          "family": "Volvo T5",
          "url": "/collections/all/bt-fit-route-volvo-c30-t5-turbosmart?bbt_vehicle=1&bbt_route=bt-fit-route-volvo-c30-t5-turbosmart&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-volvo-c30-t5-turbosmart",
          "engineTag": "bt-fit-engine-volvo-t5",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "C70": {
      "T5": [
        {
          "label": "T5 Turbo — Turbosmart direct-fit",
          "family": "Volvo T5",
          "url": "/collections/all/bt-fit-route-volvo-c70-t5-turbosmart?bbt_vehicle=1&bbt_route=bt-fit-route-volvo-c70-t5-turbosmart&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-volvo-c70-t5-turbosmart",
          "engineTag": "bt-fit-engine-volvo-t5",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "S40": {
      "T5": [
        {
          "label": "T5 Turbo — Turbosmart direct-fit",
          "family": "Volvo T5",
          "url": "/collections/all/bt-fit-route-volvo-s40-t5-turbosmart?bbt_vehicle=1&bbt_route=bt-fit-route-volvo-s40-t5-turbosmart&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-volvo-s40-t5-turbosmart",
          "engineTag": "bt-fit-engine-volvo-t5",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "S60": {
      "T5": [
        {
          "label": "T5 Turbo — Turbosmart direct-fit",
          "family": "Volvo T5",
          "url": "/collections/all/bt-fit-route-volvo-s60-t5-turbosmart?bbt_vehicle=1&bbt_route=bt-fit-route-volvo-s60-t5-turbosmart&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-volvo-s60-t5-turbosmart",
          "engineTag": "bt-fit-engine-volvo-t5",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "V50": {
      "T5": [
        {
          "label": "T5 Turbo — Turbosmart direct-fit",
          "family": "Volvo T5",
          "url": "/collections/all/bt-fit-route-volvo-v50-t5-turbosmart?bbt_vehicle=1&bbt_route=bt-fit-route-volvo-v50-t5-turbosmart&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-volvo-v50-t5-turbosmart",
          "engineTag": "bt-fit-engine-volvo-t5",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "V70": {
      "T5": [
        {
          "label": "T5 Turbo — Turbosmart direct-fit",
          "family": "Volvo T5",
          "url": "/collections/all/bt-fit-route-volvo-v70-t5-turbosmart?bbt_vehicle=1&bbt_route=bt-fit-route-volvo-v70-t5-turbosmart&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-volvo-v70-t5-turbosmart",
          "engineTag": "bt-fit-engine-volvo-t5",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Component Family / Custom": {
      "Kompact EM VR2": [
        {
          "label": "Kompact EM",
          "family": "Turbosmart Component Family",
          "url": "/collections/all/bt-fit-route-volvo-kompact-em-vr2?bbt_vehicle=1&bbt_route=bt-fit-route-volvo-kompact-em-vr2&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-volvo-kompact-em-vr2",
          "engineTag": "bt-fit-component-volvo-kompact-em-vr2",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "Suzuki": {
    "Swift / Swift Sport": {
      "K14C": [
        {
          "label": "1.4L K14C Boosterjet",
          "family": "Suzuki K14C",
          "url": "/collections/all/bt-fit-route-suzuki-swift-k14c?bbt_vehicle=1&bbt_route=bt-fit-route-suzuki-swift-k14c&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-suzuki-swift-k14c",
          "engineTag": "bt-fit-engine-k14c",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Vitara": {
      "K14C": [
        {
          "label": "1.4L K14C Boosterjet",
          "family": "Suzuki K14C",
          "url": "/collections/all/bt-fit-route-suzuki-vitara-k14c?bbt_vehicle=1&bbt_route=bt-fit-route-suzuki-vitara-k14c&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-suzuki-vitara-k14c",
          "engineTag": "bt-fit-engine-k14c",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "SX4 S-Cross": {
      "K14C": [
        {
          "label": "1.4L K14C Boosterjet",
          "family": "Suzuki K14C",
          "url": "/collections/all/bt-fit-route-suzuki-sx4-scross-k14c?bbt_vehicle=1&bbt_route=bt-fit-route-suzuki-sx4-scross-k14c&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-suzuki-sx4-scross-k14c",
          "engineTag": "bt-fit-engine-k14c",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "Seat": {
    "Leon": {
      "K03 / K04": [
        {
          "label": "Factory-frame K03/K04 IWG",
          "family": "VAG K03/K04",
          "url": "/collections/all/bt-fit-route-seat-leon-k03-k04-iwg?bbt_vehicle=1&bbt_route=bt-fit-route-seat-leon-k03-k04-iwg&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-seat-leon-k03-k04-iwg",
          "engineTag": "bt-fit-turbo-vag-k03-k04",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    },
    "Component Family / Custom": {
      "TFSI Kompact EM VR1": [
        {
          "label": "Kompact EM",
          "family": "Turbosmart Component Family",
          "url": "/collections/all/bt-fit-route-seat-tfsi-kompact-em-vr1?bbt_vehicle=1&bbt_route=bt-fit-route-seat-tfsi-kompact-em-vr1&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-seat-tfsi-kompact-em-vr1",
          "engineTag": "bt-fit-component-seat-tfsi-kompact-em-vr1",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ],
      "1.4 TSI Kompact EM VR4": [
        {
          "label": "Kompact EM",
          "family": "Turbosmart Component Family",
          "url": "/collections/all/bt-fit-route-seat-14tsi-kompact-em-vr4?bbt_vehicle=1&bbt_route=bt-fit-route-seat-14tsi-kompact-em-vr4&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-seat-14tsi-kompact-em-vr4",
          "engineTag": "bt-fit-component-seat-14tsi-kompact-em-vr4",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "Ferrari": {
    "488": {
      "488": [
        {
          "label": "Kompact EM VR31 direct-fit",
          "family": "Ferrari 488",
          "url": "/collections/all/bt-fit-route-ferrari-488-kompact-em?bbt_vehicle=1&bbt_route=bt-fit-route-ferrari-488-kompact-em&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ferrari-488-kompact-em",
          "engineTag": "bt-fit-component-vr31",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "Peugeot": {
    "Component Family / Custom": {
      "Kompact EM VR10": [
        {
          "label": "Kompact EM",
          "family": "Turbosmart Component Family",
          "url": "/collections/all/bt-fit-route-peugeot-kompact-em-vr10?bbt_vehicle=1&bbt_route=bt-fit-route-peugeot-kompact-em-vr10&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-peugeot-kompact-em-vr10",
          "engineTag": "bt-fit-component-peugeot-kompact-em-vr10",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "Citroen": {
    "Component Family / Custom": {
      "Kompact EM VR10": [
        {
          "label": "Kompact EM",
          "family": "Turbosmart Component Family",
          "url": "/collections/all/bt-fit-route-citroen-kompact-em-vr10?bbt_vehicle=1&bbt_route=bt-fit-route-citroen-kompact-em-vr10&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-citroen-kompact-em-vr10",
          "engineTag": "bt-fit-component-citroen-kompact-em-vr10",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "DS": {
    "Component Family / Custom": {
      "Kompact EM VR10": [
        {
          "label": "Kompact EM",
          "family": "Turbosmart Component Family",
          "url": "/collections/all/bt-fit-route-ds-kompact-em-vr10?bbt_vehicle=1&bbt_route=bt-fit-route-ds-kompact-em-vr10&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-ds-kompact-em-vr10",
          "engineTag": "bt-fit-component-ds-kompact-em-vr10",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "McLaren": {
    "Component Family / Custom": {
      "Kompact EM VR14": [
        {
          "label": "Kompact EM",
          "family": "Turbosmart Component Family",
          "url": "/collections/all/bt-fit-route-mclaren-kompact-em-vr14?bbt_vehicle=1&bbt_route=bt-fit-route-mclaren-kompact-em-vr14&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-mclaren-kompact-em-vr14",
          "engineTag": "bt-fit-component-mclaren-kompact-em-vr14",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "Alfa Romeo": {
    "Component Family / Custom": {
      "Kompact EM VR15": [
        {
          "label": "Kompact EM",
          "family": "Turbosmart Component Family",
          "url": "/collections/all/bt-fit-route-alfa-romeo-kompact-em-vr15?bbt_vehicle=1&bbt_route=bt-fit-route-alfa-romeo-kompact-em-vr15&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-alfa-romeo-kompact-em-vr15",
          "engineTag": "bt-fit-component-alfa-romeo-kompact-em-vr15",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "Lancia": {
    "Component Family / Custom": {
      "Kompact EM VR15": [
        {
          "label": "Kompact EM",
          "family": "Turbosmart Component Family",
          "url": "/collections/all/bt-fit-route-lancia-kompact-em-vr15?bbt_vehicle=1&bbt_route=bt-fit-route-lancia-kompact-em-vr15&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-lancia-kompact-em-vr15",
          "engineTag": "bt-fit-component-lancia-kompact-em-vr15",
          "systems": [
            "turbo-forced-induction"
          ],
          "systemCounts": {
            "turbo-forced-induction": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  },
  "VAG": {
    "Component Family / Custom": {
      "Bosch in-rail FPR / Kompact": [
        {
          "label": "Fuel-system component family",
          "family": "Turbosmart Component Family",
          "url": "/collections/all/bt-fit-route-vag-bosch-inrail-fpr?bbt_vehicle=1&bbt_route=bt-fit-route-vag-bosch-inrail-fpr&sort_by=price-ascending",
          "routeType": "precision-route-tag",
          "routeTag": "bt-fit-route-vag-bosch-inrail-fpr",
          "engineTag": "bt-fit-component-vag-bosch-inrail-fpr",
          "systems": [
            "fuel-system"
          ],
          "systemCounts": {
            "fuel-system": 1
          },
          "productCount": 1,
          "catalogueVersion": "755-29sep2026-post754a-deep-audit"
        }
      ]
    }
  }
}
  window.BBT_VEHICLE_DATA = {version: '116-25sep2026-catalogue-reconciliation', data: DATA};

  var STORAGE_KEY = 'bbt_selected_vehicle_v1';

  function fill(select, placeholder, values) {
    select.innerHTML = '<option value="">' + placeholder + '</option>';
    values.forEach(function (value) {
      var option = document.createElement('option');
      option.value = value;
      option.textContent = value;
      select.appendChild(option);
    });
    select.disabled = values.length === 0;
  }

  function init() {
    var form = document.querySelector('[data-bbt-vf-form]');
    if (!form) return;
    var make = form.querySelector('[data-bbt-vf-make]');
    var model = form.querySelector('[data-bbt-vf-model]');
    var generation = form.querySelector('[data-bbt-vf-generation]');
    var engine = form.querySelector('[data-bbt-vf-engine]');
    var submit = form.querySelector('.bbt-vf__submit');

    fill(make, 'Make', Object.keys(DATA));
    model.disabled = true;
    generation.disabled = true;
    engine.disabled = true;

    function resetFrom(level) {
      if (level <= 1) { fill(model, 'Model', []); }
      if (level <= 2) { fill(generation, 'Generation / chassis', []); }
      if (level <= 3) { fill(engine, 'Engine / fitment', []); }
      submit.disabled = true;
    }

    make.addEventListener('change', function () {
      resetFrom(1);
      if (!make.value) return;
      fill(model, 'Model', Object.keys(DATA[make.value] || {}));
    });

    model.addEventListener('change', function () {
      resetFrom(2);
      if (!make.value || !model.value) return;
      fill(generation, 'Generation / chassis', Object.keys((DATA[make.value] || {})[model.value] || {}));
    });

    generation.addEventListener('change', function () {
      resetFrom(3);
      if (!make.value || !model.value || !generation.value) return;
      var options = (((DATA[make.value] || {})[model.value] || {})[generation.value] || []);
      engine.innerHTML = '<option value="">Engine / fitment</option>';
      options.forEach(function (item, index) {
        var option = document.createElement('option');
        option.value = String(index);
        option.textContent = item.label;
        engine.appendChild(option);
      });
      engine.disabled = options.length === 0;
      if (options.length === 1) {
        engine.value = '0';
        engine.dispatchEvent(new Event('change'));
      }
    });

    engine.addEventListener('change', function () {
      submit.disabled = engine.value === '';
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!make.value || !model.value || !generation.value || engine.value === '') return;
      var options = (((DATA[make.value] || {})[model.value] || {})[generation.value] || []);
      var item = options[Number(engine.value)];
      if (!item || !item.url) return;
      var state = {
        make: make.value,
        model: model.value,
        generation: generation.value,
        engine: item.label,
        family: item.family,
        routeType: item.routeType || 'engine-family',
        engineTag: item.engineTag || '',
        routeTag: item.routeTag || '',
        systems: Array.isArray(item.systems) ? item.systems.slice() : [],
        systemCounts: Object.assign({}, item.systemCounts || {}),
        productCount: Number(item.productCount || 0),
        catalogueVersion: item.catalogueVersion,
        url: window.BBTCatalogue ? window.BBTCatalogue.destination(item.url) : item.url,
        savedAt: Date.now()
      };
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (e) {}
      window.location.assign(state.url);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
